import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import dashJs from 'dashjs';
import 'videojs-contrib-dash';
import 'videojs-contrib-eme';
import 'videojs-hotkeys';
import videoJs from 'video.js';
import 'core-js/modules/es.string.trim.js';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.array.index-of.js';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.array.splice.js';
import { ConfigService } from 'vimmi-web-utils/cjs/configService';
import { device } from 'vimmi-web-utils/cjs/device';
import 'core-js/modules/es.array.sort.js';
import 'core-js/modules/es.array.reduce.js';
import VimmiAI from 'vimmi-analytics-integration/dist/vimmi-analytics-integration.cjs';
import VimmiPI from 'vimmi-player-integration/dist/vimmi-player-integration.cjs';
import { screenMode } from 'vimmi-web-utils/cjs/screenMode';
import { EventEmitter } from 'vimmi-web-utils/cjs/eventEmitter';
import { normalizeLang } from 'vimmi-web-utils/cjs/normalizeLang';
import { PLAYER_METHODS, PM, PLAYER_EVENTS } from 'vimmi-web-utils/cjs/postMessage';
import canAutoplay from 'can-autoplay';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import { AppError } from 'vimmi-web-utils/cjs/errors/appError';
import { ErrorCodes } from 'vimmi-web-utils/cjs/errors/errorCodes';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.typed-array.uint16-array.js';
import 'core-js/modules/es.typed-array.sort.js';
import 'core-js/modules/es.typed-array.to-locale-string.js';
import 'core-js/modules/es.typed-array.to-string.js';
import 'core-js/modules/es.typed-array.uint8-array.js';
import lifecycle from 'page-lifecycle';
import { secondLocation } from 'vimmi-web-utils/cjs/secondLocation';

class Tools {
  constructor() {
    this.regCheckFields = /\{([a-z_-]+)\}(\[?([0-9\,]+)?\])?/ig;
  }

  copy(object) {
    return JSON.parse(JSON.stringify(object));
  }

  toNatural(number) {
    return !Number.isNaN(+number) ? number < 0 ? 0 : number : number;
  }

  fixTo(float) {
    var digitsAfterDot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    return float ? +float.toFixed(digitsAfterDot) : float;
  }

  htmlToElement(html) {
    var template = document.createElement('template');
    html = html.trim();
    template.innerHTML = html;
    return template.content && template.content.firstChild ? template.content.firstChild : template.firstElementChild;
  }

  sliceString(string, limit, start) {
    string = string || '';
    start = start || 0;
    limit = limit || 40;
    return string && string.length > limit ? string.slice(start, limit) : string;
  }

  stripTags(string) {
    if (string) {
      var div = document.createElement('div');
      div.innerHTML = string;
      return div.textContent || div.innerText || '';
    } else {
      return '';
    }
  }

  clearSelection() {
    if (window.getSelection) {
      if (window.getSelection().empty) {
        window.getSelection().empty();
      } else if (window.getSelection().removeAllRanges) {
        window.getSelection().removeAllRanges();
      }
    } else if (document.selection) {
      document.selection.empty();
    }
  }
  /**
   * Cross Browser helper to addEventListener.
   *
   * @param {HTMLElement} obj The Element to attach event to.
   * @param {string} evt The event that will trigger the binded function.
   * @param {function(event)} fnc The function to bind to the element.
   * @return {boolean} true if it was successfuly binded.
   */


  addEventListener(obj, evt, fnc) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    evt = evt || [];

    if (!Array.isArray(evt)) {
      evt = [evt];
    }

    if (obj.addEventListener) {
      evt.map(function (eventName) {
        obj.addEventListener(eventName, fnc, options);
      });
      return true;
    } else if (obj.attachEvent) {
      evt.map(function (eventName) {
        obj.attachEvent('on' + eventName, fnc);
      });
      return true;
    }

    return false;
  }

  addScript(id, link) {
    var js,
        d = document,
        fjs = d.getElementsByTagName('script')[0];

    if (d.getElementById(id)) {
      return d.getElementById(id);
    }

    js = d.createElement('script');
    js.id = id;
    js.src = link;
    fjs.parentNode.insertBefore(js, fjs);
    return js;
  }

  parseQueryOptions(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');

    for (var i = 0; i < pairs.length; i++) {
      var isArray = false;
      var pair = pairs[i].split('=');

      if (pair[0].indexOf('[') !== -1) {
        pair[0] = pair[0].split('[')[0];
        isArray = true;
      }

      if (isArray) {
        query[decodeURIComponent(pair[0])] = query[decodeURIComponent(pair[0])] || [];
      }

      var val = true;

      if (pair.length >= 2) {
        val = pair[1] === '' || pair[1].toLowerCase() === 'true' ? true : pair[1] === 'false' ? false : pair[1] ? decodeURIComponent(pair[1]) : true;
      }

      if (isArray) {
        query[decodeURIComponent(pair[0])].push(val);
      } else {
        query[decodeURIComponent(pair[0])] = val;
      }
    }

    return query;
  }

  toHHMMSS(inputSeconds) {
    var sec_num = parseInt(inputSeconds, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }

    if (minutes < 10) {
      minutes = "0" + minutes;
    }

    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return hours + ':' + minutes + ':' + seconds;
  }

}

var Tools$1 = new Tools();

var config = new ConfigService();
config.set({
  debug: false,
  params: {
    lang: 'en'
  },
  currentPlayType: null,
  keySystemsFullList: {
    'DASH/WIDEVINE': ['com.widevine.alpha'],
    'DASH/PLAYREADY': ['com.microsoft.playready', 'com.youtube.playready'],
    clearkey: ['webkit-org.w3.clearkey', 'org.w3.clearkey'],
    primetime: ['com.adobe.primetime', 'com.adobe.access'],
    'HLS/FAIRPLAY': ['com.apple.fairplay']
  },
  keySystems: {
    'DASH/PLAYREADY': 'com.microsoft.playready',
    'DASH/WIDEVINE': 'com.widevine.alpha',
    'HLS/FAIRPLAY': 'com.apple.fps.1_0'
  },
  eventsState: {
    isStartPlay: false,
    prevUserActiveState: false,
    loadstart: false,
    waiting: false,
    loadedmetadata: false,
    loadeddata: false,
    ended: false,
    error: false
  },
  supportTypes: {
    m3u8: 'application/x-mpegURL',
    mpd: 'application/dash+xml',
    mp4: 'video/mp4',
    fm3u8: 'application/vnd.apple.mpegurl',
    default: 'application/x-mpegURL'
  },
  EmbeddedCodeOpt: {
    height: 337.5,
    width: 600
  },
  vjsOptions: {
    width: '50%',
    height: '50%',
    language: 'en',
    textTrackSettings: true,
    persistTextTrackSettings: true,
    plugins: {
      eme: {}
    },
    html5: {
      vhs: {
        handleManifestRedirects: true
      },
      nativeCaptions: false,
      nativeTextTracks: false
    }
  },
  alphaIdRegExp: /\/([0-9a-z]{1,}[-]{1}[a-z0-9]{1,}[-]{1}[a-z0-9]{1,})\//i
});

var loggers = {};
var methods = ['dir', 'log', 'info', 'warn', 'error', 'debug'];
function Logger(type) {
  if (!type) {
    type = 'Player';
  } else {
    type = 'Player][' + type;
  }

  if (loggers[type]) {
    return loggers[type];
  }

  var logger = {};

  for (var m in console) {
    if (typeof console[m] == 'function' && methods.indexOf(m) !== -1) {
      logger[m] = console[m].bind(window.console, `[${type}]`);
    }
  }

  loggers[type] = logger;
  return logger;
}
var eventLog = Logger('event');

var vimmiPI$1 = new VimmiPI();
vimmiPI$1.beforeMetadataReq(asset => {
  return asset;
});
vimmiPI$1.beforePlayReq(asset => {
  return asset;
});

class PlayerAnalytics {
  constructor() {
    this.logger = Logger('Analytics');
    this.analyticModule = new VimmiAI();
    vimmiPI$1.attachAnalytics(this);
  }

  configure(configs) {
    this.analyticModule.conf({
      app_id: configs.portal.app_id,
      app_version: configs.portal.app_version,
      device_id: configs.portal.device_id,
      buhDeviceId: configs.portal.buhDeviceId || configs.portal.device_id,
      language: configs.portal.user_lang,
      customBrowserName: configs.customBrowserName
    });

    if (configs.analytics) {
      var drivers = [];

      if (configs.analytics.buh) {
        drivers.push(this.analyticModule.setDriver(VimmiAI.DRIVERS.BUH, configs.analytics.buh));
      }

      Promise.all(drivers).then(resull => {
        var err = this.analyticModule.initialize();

        if (err) {
          this.logger.warn('analytics drivers initialization error: ', err);
        }
      });
    }
  }

  beforePlay(activeAsset) {}

  resetCalculatedOptions(activeAsset) {
    if (!activeAsset) {
      return;
    }

    activeAsset.set('extraData.bytes', 0);
    activeAsset.set('extraData.active_bitrate', 0);
    activeAsset.set('extraData.jump', 0);
    activeAsset.set('extraData.buffer_time', 0);
    activeAsset.set('extraData.stream_time', 0);
    activeAsset.set('extraData.position_from', 0);
    activeAsset.set('extraData.position_to', 0);
    activeAsset.set('extraData.active_position', 0);
    activeAsset.set('extraData.max_view_bitrate', 0);
    activeAsset.set('extraData.actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.chu_bitrate', []);
    activeAsset.set('extraData.buh.total_average_bitrate', []);
    activeAsset.set('extraData.buh.missedBytes', null);
    activeAsset.set('extraData.buh.resume_bytes', 0);
    activeAsset.set('extraData.buh.resume_buffer_time', 0);
    activeAsset.set('extraData.buh.resume_actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.resume_jump', 0);
    activeAsset.set('extraData.buh.resume_stream_time', 0);
    activeAsset.set('extraData.buh.resume_bitrate', []);
    activeAsset.set('extraData.buh.resume_duration', Date.now());
    activeAsset.set('extraData.buh.stop_bytes', 0);
    activeAsset.set('extraData.buh.stop_jump', 0);
    activeAsset.set('extraData.buh.stop_buffer_time', 0);
    activeAsset.set('extraData.buh.stop_actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.stop_stream_time', 0);
    activeAsset.set('extraData.buh.pause_bytes', 0);
    activeAsset.set('extraData.buh.pause_jump', 0);
    activeAsset.set('extraData.buh.pause_buffer_time', 0);
    activeAsset.set('extraData.buh.pause_actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.pause_stream_time', 0);
    activeAsset.set('extraData.buh.chu_bytes', 0);
    activeAsset.set('extraData.buh.chu_buffer_time', 0);
    activeAsset.set('extraData.buh.chu_actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.chu_jump', 0);
    activeAsset.set('extraData.buh.chu_stream_time', 0);
  }

  getQoS(asset, buffer_time, stream_time, jumps) {
    var res = Math.round(50 * (stream_time / ((buffer_time || 0) + stream_time)) + 30 * Math.min(asset.get('extraData.active_bitrate', 1) / asset.get('extraData.max_bitrate'), 1) + 20 * (1 - Math.min(jumps, 10) / 10));
    return isNaN(res) || res === Infinity || res === null ? 100 : res < 0 ? 0 : res > 100 ? 100 : res;
  }

  getBufferTime(bufferTime) {
    return bufferTime ? Tools$1.toNatural(Tools$1.fixTo(bufferTime)) : 0;
  }

  getBufferRatio(bufferTime, streamTime) {
    return bufferTime ? Tools$1.toNatural(Tools$1.fixTo(bufferTime / (streamTime + bufferTime))) : 0;
  }

  _getFormatedError(error) {
    return {
      error_name: error.type || error.name || 'unknown error',
      error_code: error.status || error.statusCode || error.code,
      error_description: error.message || error.status || 'unknown error',
      error_source: error.source || (error.status || error.statusCode || error.code <= 2 && error.code >= 1 || error.code === 4 ? 'HTTP' : 'Player')
    };
  }

  getAverageBitrate(total_average_bitrate) {
    if (total_average_bitrate && total_average_bitrate.length) {
      return Tools$1.fixTo(total_average_bitrate.reduce((a, b) => {
        return a + b;
      }) / total_average_bitrate.length);
    }

    return null;
  }

  _getEventData(evn, options) {
    var asset = options.asset || vimmiPI$1.getActiveAsset() || {
      get: function get(key, defaultVal) {
        return defaultVal || null;
      },

      set() {}

    };
    var activePlayback = asset.get('activePlayback') || {};
    var data = {
      app_info: config.get(`params.portal.app_info`),
      app_version: config.get(`params.portal.app_version`),
      customer: (config.get(`params.portal.customer`) || '').toLowerCase(),
      user_id: config.get(`params.portal.user_id`),
      session_id: config.get(`params.portal.sid`)
    };

    if (!config.get(`params.portal.user_id`)) {
      data.temp_user_id = config.get(`params.portal.temp_user_id`);
    }

    if (config.get(`params.portal.classification`)) {
      data.classification = config.get(`params.portal.classification`);
    }

    if (this.analyticModule.getEventType(evn) === 'media') {
      data.player = 'vimmi-web';
      data.player_version = "2.9.47";
      data.streaming_server_id = asset.get('activePlayback.serverId');
      data.media_session_id = (config.get(`params.portal.user_id`) || config.get(`params.portal.temp_user_id`) || 'unknown') + '_' + asset.get('media_session_id');
      data.media_id = asset.get('alphaId') || null;
      data.itype = asset.get('itype') || null;
      data.subscription_status = asset.get('extraData.subscription_status') || null;
      data.item_language = vjsSrv.vjsPlayer.TechSrv.getActiveAudioTrack();
      data.position = vjsSrv.vjsPlayer.duration() === Infinity || asset.isLive ? 0 : Tools$1.fixTo(asset.get('extraData.active_position', 0), 0);
      data.playback_url = activePlayback.url ? activePlayback.url.toString() : null;
      data.item_id = asset.get('media_id');
      data.auto_play = !!asset.get('extraData.auto_play');

      if (asset.get("preview_info") !== null) {
        data.tag = 'preview';
      }
    } else {
      data.server = config.get(`params.portal.server`);
    }

    var total_average_bitrate = asset.get('extraData.buh.total_average_bitrate') || [];
    var cdn = asset.get('activePlayback.cdn');

    if (cdn) {
      var purifiedCdn = cdn.replace(/-https/g, '');
      asset.set('activePlayback.cdn', purifiedCdn);
    }

    switch (evn) {
      case 'player_ready':
        data = Object.assign(data, {
          bitrate: Tools$1.toNatural(asset.get('extraData.active_bitrate', 0)),
          bytes: Tools$1.toNatural(asset.get('extraData.bytes', 0)),
          context: asset.get('extraData.context'),
          cur_stream: asset.get('extraData.active_stream') || 1,
          delay: Tools$1.toNatural(Tools$1.fixTo(asset.get('extraData.delay_end') ? asset.get('extraData.delay_end') - asset.get('extraData.delay_start') : 0, 0)),
          cdn: asset.get('activePlayback.cdn'),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          n_streams: asset.get('extraData.n_streams', 0),
          click_to_media: Tools$1.toNatural(Tools$1.fixTo(asset.get('extraData.click_to_media_end') ? asset.get('extraData.click_to_media_end') - asset.get('extraData.click_to_media_start') : 0, 0))
        });
        delete data.position;
        break;

      case 'start':
        if (!asset.get('extraData.first_byte_end')) {
          asset.set('extraData.first_byte_end', Date.now());
        }

        data = Object.assign(data, {
          first_byte: Tools$1.toNatural(Tools$1.toNatural(Tools$1.fixTo(asset.get('extraData.first_byte_end') ? asset.get('extraData.first_byte_end') - asset.get('extraData.first_byte_start') : 0, 0))),
          bitrate: Tools$1.toNatural(Tools$1.toNatural(asset.get('extraData.active_bitrate', 0))),
          bytes: Tools$1.toNatural(Tools$1.toNatural(asset.get('extraData.bytes', 0))),
          qos: this.getQoS(asset, asset.get('extraData.buffer_time'), asset.get('extraData.stream_time', 0), asset.get('extraData.jump')),
          cur_stream: asset.get('extraData.active_stream') || 1,
          context: asset.get('extraData.context'),
          cdn: asset.get('activePlayback.cdn'),
          buffer_ratio: this.getBufferRatio(asset.get('extraData.buffer_time'), asset.get('extraData.stream_time', 0)),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          n_streams: asset.get('extraData.n_streams', 0),
          jump: asset.get('extraData.jump', 0),
          stream_time: Tools$1.toNatural(Tools$1.fixTo(asset.get('extraData.stream_time', 0))),
          buffer_time: Tools$1.toNatural(Tools$1.fixTo(asset.get('extraData.buffer_time', 0))),
          actual_max_bitrate: Tools$1.fixTo(asset.get('extraData.actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          click_to_media: Tools$1.toNatural(Tools$1.fixTo(asset.get('extraData.click_to_media_end') ? asset.get('extraData.click_to_media_end') - asset.get('extraData.click_to_media_start') : 0, 0))
        });
        asset.set('extraData.buh.start_streaming', Date.now());
        break;

      case 'chu':
        var chu_buffer_time = this.getBufferTime(asset.get('extraData.buffer_time', 0) - asset.get('extraData.buh.chu_buffer_time', 0));
        var chu_stream_time = asset.get('extraData.stream_time', 0) - asset.get('extraData.buh.chu_stream_time', 0);
        var chu_jumps = asset.get('extraData.jump') - asset.get('extraData.buh.chu_jump', 0);
        chu_stream_time = chu_stream_time < 0 ? 0 : chu_stream_time;
        var chu_bitrate = asset.get('extraData.buh.chu_bitrate', []);
        var chu_average_bitrate = asset.get('extraData.active_bitrate', 0);

        if (chu_bitrate && chu_bitrate.length) {
          chu_average_bitrate = chu_bitrate.reduce((a, b) => {
            return a + b;
          }) / chu_bitrate.length;
        }

        total_average_bitrate.push(chu_average_bitrate);
        asset.set('extraData.buh.total_average_bitrate', total_average_bitrate);
        data = Object.assign(data, {
          bitrate: Tools$1.toNatural(Tools$1.fixTo(chu_average_bitrate)),
          duration: Tools$1.fixTo(chu_buffer_time + (chu_stream_time < 0 ? 0 : chu_stream_time)),
          cdn: asset.get('activePlayback.cdn'),
          cur_stream: asset.get('extraData.active_stream') || 1,
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          n_streams: asset.get('extraData.n_streams', 0),
          buffer_time: chu_buffer_time,
          bytes: Tools$1.toNatural(asset.get('extraData.bytes', 1) - asset.get('extraData.buh.chu_bytes', 0)),
          buffer_ratio: this.getBufferRatio(chu_buffer_time, chu_stream_time),
          qos: this.getQoS(asset, chu_buffer_time, chu_stream_time, chu_jumps),
          actual_max_bitrate: Tools$1.fixTo(asset.get('extraData.buh.chu_actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          jump: chu_jumps,
          stream_time: Tools$1.toNatural(Tools$1.fixTo(chu_stream_time < 0 ? 0 : chu_stream_time))
        });
        asset.set('extraData.buh.chu_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.chu_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.chu_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.chu_jump', asset.get('extraData.jump'));
        asset.set('extraData.buh.chu_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.chu_bitrate', []);
        break;

      case 'media_pause':
        var pause_buffer_time = this.getBufferTime(asset.get('extraData.buffer_time', 0) - asset.get('extraData.buh.pause_buffer_time', 0));
        var pause_stream_time = asset.get('extraData.stream_time', 0) - asset.get('extraData.buh.pause_stream_time', 0);
        var pause_jumps = asset.get('extraData.jump') - asset.get('extraData.buh.pause_jump', 0);
        pause_stream_time = pause_stream_time < 0 ? 0 : pause_stream_time;
        data = Object.assign(data, {
          n_streams: asset.get('extraData.n_streams', 0),
          cur_stream: asset.get('extraData.active_stream', 1),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          buffer_time: pause_buffer_time,
          cdn: asset.get('activePlayback.cdn'),
          stream_time: Tools$1.toNatural(Tools$1.fixTo(pause_stream_time)),
          buffer_ratio: this.getBufferRatio(pause_buffer_time, pause_stream_time),
          qos: this.getQoS(asset, pause_buffer_time, pause_stream_time, pause_jumps),
          bitrate: Tools$1.toNatural(this.getAverageBitrate(total_average_bitrate) || Tools$1.fixTo(asset.get('extraData.active_bitrate', 0))),
          bytes: Tools$1.toNatural(asset.get('extraData.bytes', 1) - asset.get('extraData.buh.pause_bytes', 0)),
          actual_max_bitrate: Tools$1.fixTo(asset.get('extraData.buh.pause_actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          jump: pause_jumps,
          duration: Tools$1.fixTo(pause_buffer_time + pause_stream_time)
        });
        asset.set('extraData.buh.pause_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.pause_jump', asset.get('extraData.jump'));
        asset.set('extraData.buh.pause_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.pause_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.pause_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.resume_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.resume_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.resume_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.resume_jump', asset.get('extraData.jump'));
        asset.set('extraData.buh.resume_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.resume_bitrate', []);
        asset.set('extraData.buh.resume_duration', Date.now());
        break;

      case 'media_resume':
        var resume_buffer_time = this.getBufferTime(asset.get('extraData.buffer_time', 0) - asset.get('extraData.buh.resume_buffer_time', 0));
        var resume_stream_time = asset.get('extraData.stream_time', 0) - asset.get('extraData.buh.resume_stream_time', 0);
        var resume_jumps = asset.get('extraData.jump') - asset.get('extraData.buh.resume_jump', 0);
        resume_stream_time = resume_stream_time < 0 ? 0 : resume_stream_time;
        var resume_bitrate = asset.get('extraData.buh.resume_bitrate', []);
        var resume_average_bitrate = asset.get('extraData.active_bitrate', 0);

        if (resume_bitrate && resume_bitrate.length) {
          resume_average_bitrate = resume_bitrate.reduce((a, b) => {
            return a + b;
          }) / resume_bitrate.length;
        }

        total_average_bitrate.push(resume_average_bitrate);
        asset.set('extraData.buh.total_average_bitrate', total_average_bitrate);
        data = Object.assign(data, {
          bitrate: Tools$1.toNatural(Tools$1.fixTo(resume_average_bitrate)),
          duration: Tools$1.fixTo((Date.now() - (asset.get('extraData.buh.resume_duration') || asset.get('extraData.buh.start_streaming', 0))) / 1000),
          cdn: asset.get('activePlayback.cdn'),
          cur_stream: asset.get('extraData.active_stream', 1),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          n_streams: asset.get('extraData.n_streams', 0),
          buffer_time: resume_buffer_time,
          buffer_ratio: Tools$1.toNatural(this.getBufferRatio(resume_buffer_time, resume_stream_time)),
          bytes: Tools$1.toNatural(asset.get('extraData.bytes', 1) - asset.get('extraData.buh.resume_bytes', 0)),
          qos: this.getQoS(asset, resume_buffer_time, resume_stream_time, resume_jumps),
          actual_max_bitrate: Tools$1.fixTo(asset.get('extraData.buh.resume_actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          jump: resume_jumps,
          stream_time: Tools$1.toNatural(Tools$1.fixTo(resume_stream_time))
        });
        asset.set('extraData.buh.resume_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.resume_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.resume_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.resume_jump', asset.get('extraData.jump', 0));
        asset.set('extraData.buh.resume_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.resume_bitrate', []);
        asset.set('extraData.buh.resume_duration', Date.now());
        asset.set('extraData.buh.stop_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.stop_jump', asset.get('extraData.jump', 0));
        asset.set('extraData.buh.stop_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.stop_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.stop_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.pause_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.pause_jump', asset.get('extraData.jump'));
        asset.set('extraData.buh.pause_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.pause_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.pause_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.chu_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.chu_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.chu_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.chu_jump', asset.get('extraData.jump', 0));
        asset.set('extraData.buh.chu_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.chu_bitrate', []);
        break;

      case 'stop':
        var stop_buffer_time = this.getBufferTime(asset.get('extraData.buffer_time', 0) - asset.get('extraData.buh.stop_buffer_time', 0));
        var stop_stream_time = asset.get('extraData.stream_time', 0) - asset.get('extraData.buh.stop_stream_time', 0);
        var stop_jumps = asset.get('extraData.jump') - asset.get('extraData.buh.stop_jump', 0);
        stop_stream_time = stop_stream_time < 0 ? 0 : stop_stream_time;
        data = Object.assign(data, {
          cdn: asset.get('activePlayback.cdn') || null,
          n_streams: asset.get('extraData.n_streams', 0),
          cur_stream: asset.get('extraData.active_stream', 1),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          buffer_time: stop_buffer_time,
          stream_time: Tools$1.toNatural(Tools$1.fixTo(stop_stream_time)),
          buffer_ratio: this.getBufferRatio(stop_buffer_time, stop_stream_time),
          qos: this.getQoS(asset, stop_buffer_time, stop_stream_time, stop_jumps),
          bitrate: Tools$1.toNatural(this.getAverageBitrate(total_average_bitrate) || Tools$1.fixTo(asset.get('extraData.active_bitrate', 0))),
          bytes: Tools$1.toNatural(asset.get('extraData.bytes', 1) - asset.get('extraData.buh.stop_bytes', 0)),
          actual_max_bitrate: Tools$1.fixTo(asset.get('extraData.buh.stop_actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          jump: stop_jumps,
          duration: Tools$1.fixTo(stop_buffer_time + stop_stream_time)
        });
        asset.set('extraData.buh.stop_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.stop_jump', asset.get('extraData.jump', 0));
        asset.set('extraData.buh.stop_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.stop_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.stop_stream_time', asset.get('extraData.stream_time', 0));
        break;

      case 'media_is_playing':
        data.delay = Tools$1.fixTo(asset.get('extraData.delay_end') ? asset.get('extraData.delay_end') - asset.get('extraData.delay_start') : 0, 0);
        data.click_to_media = Tools$1.fixTo(asset.get('extraData.click_to_media_end') ? asset.get('extraData.click_to_media_end') - asset.get('extraData.click_to_media_start') : 0, 0);
        data.cdn = asset.get('activePlayback.cdn');
        break;

      case 'media_error':
        data = Object.assign(data, this._getFormatedError(options.error));
        data.cdn = asset.get('activePlayback.cdn');
        break;

      case 'media_buffering_start':
      case 'media_buffering_completed':
        data.cdn = asset.get('activePlayback.cdn');
        break;

      case 'abort':
        data = Object.assign(data, this._getFormatedError(options.error));
        break;

      case 'seek':
        data = Object.assign(data, {
          from_time: Tools$1.fixTo(asset.get('extraData.position_from', 0)),
          to_time: Tools$1.fixTo(asset.get('extraData.position_to'))
        });
        break;

      case 'media_screen_switch':
        data = Object.assign(data, {
          tar_screen_mode: screenMode()
        });
        break;

      case 'meta_request':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'),
          screen_id: asset.get('extraData.screen_id'),
          itype: asset.get('itype')
        });
        break;

      case 'meta_response':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'),
          screen_id: asset.get('extraData.screen_id'),
          itype: asset.get('itype')
        });
        break;

      case 'meta_error':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'),
          screen_id: asset.get('extraData.screen_id'),
          itype: asset.get('itype')
        }, this._getFormatedError(options.error));
        break;

      case 'play_request':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'),
          screen_id: asset.get('extraData.screen_id'),
          item_id: asset.get('media_id'),
          itype: asset.get('itype'),
          click_to_media: Tools$1.fixTo(asset.get('extraData.click_to_media_end') ? asset.get('extraData.click_to_media_end') - asset.get('extraData.click_to_media_start') : 0, 0),
          content_title: asset.get('extraData.title')
        });
        break;

      case 'play_response':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'),
          screen_id: asset.get('extraData.screen_id'),
          item_id: asset.get('media_id'),
          itype: asset.get('itype'),
          content_title: asset.get('extraData.title')
        });
        break;

      case 'play_error':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'),
          screen_id: asset.get('extraData.screen_id'),
          item_id: asset.get('media_id'),
          itype: asset.get('itype'),
          content_title: asset.get('extraData.title')
        }, this._getFormatedError(options.error));
        break;
    }

    return data;
  }

  onTimeUpdate(asset) {
    if (!asset) {
      return;
    }

    if (asset.get('extraData.start_buffering') && asset.get('extraData.active_position') !== vjsSrv.vjsPlayer.currentTime()) {
      var buffering_time = Date.now() - asset.get('extraData.start_buffering');
      var total_buffer_time = asset.get('extraData.buffer_time', 0);
      asset.set('extraData.buffer_time', total_buffer_time + buffering_time / 1000);
      asset.set('extraData.start_buffering', null);
      this.send('media_buffering_completed');
    }

    if (vjsSrv.vjsPlayer.TechSrv.stats) {
      var currentBitrate = asset.get('extraData.active_bitrate', 0);

      if (currentBitrate > asset.get('extraData.actual_max_bitrate', 0)) {
        asset.set('extraData.actual_max_bitrate', currentBitrate);
      }

      if (currentBitrate > asset.get('extraData.buh.chu_actual_max_bitrate')) {
        asset.set('extraData.buh.chu_actual_max_bitrate', currentBitrate);
      }

      if (currentBitrate > asset.get('extraData.buh.pause_actual_max_bitrate')) {
        asset.set('extraData.buh.pause_actual_max_bitrate', currentBitrate);
      }

      if (currentBitrate > asset.get('extraData.buh.stop_actual_max_bitrate')) {
        asset.set('extraData.buh.stop_actual_max_bitrate', currentBitrate);
      }

      var chuBitrates = asset.get('extraData.buh.chu_bitrate') || [];
      chuBitrates.push(currentBitrate);
      asset.set('extraData.buh.chu_bitrate', chuBitrates);
    }
  }

  send(event) {
    var event_extra_data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!options.force && event === 'chu' && (Math.round(vjsSrv.vjsPlayer.currentTime()) === 0 || Math.round(vjsSrv.vjsPlayer.currentTime()) % config.get('params.analytics.buh.chugap') !== 0)) {
      return;
    }

    var computedExtraData = Object.assign({}, this._getEventData(event, options), event_extra_data);
    this.analyticModule.send(event, computedExtraData, {
      beacon: !!options.beacon,
      fetch: !!options.fetch,
      only: options.only || null,
      buffer_timestamp: options.buffer_timestamp || null
    });
  }

  beforePageClose(options) {
    this.analyticModule.beforePageClose(options);
  }

}
var Analytics = new PlayerAnalytics();

var eventsSrv = new EventEmitter();

class TechSrv {
  constructor(vjsPlayer) {
    this.vjsPlayer = vjsPlayer;
    this.prevActiveBitrateId = null;
    this.activeAudioTrack = null;
    this.activeTextTrack = null;
    this.representations = [];
    this.logger = Logger('TechSrv');
    this.dashStats = {
      totalTraffic: 0
    };
    this.registerHooks();
    this.vjsPlayer.on('loadstart', () => {
      this.dashStats = {
        totalTraffic: 0
      };

      if (config.get('params.style_schema') === 'lg-ais' && localStorage.getItem('user_settings')) {
        var uiTimeout = JSON.parse(localStorage.getItem('user_settings'))._ui_timeout * 1000 || 2000;
        this.vjsPlayer.options_.inactivityTimeout = uiTimeout;
      }

      this.vjsPlayer.removeClass('fit-content-fill');
      this.representations = [];
    });
    this.vjsPlayer.on('mediachange', event => {
      this._onBitrateChanged(event);
    });
    this.vjsPlayer.on('playing', () => {
      if (config.get('params.style_schema') !== 'lg-ais') {
        this.handleAspectRatio();
      }
    });
    this.vjsPlayer.on('loadedmetadata', event => {
      this._onLoadedmetadata(event);
    });
    this.handlePreferredAudioLang();
    this.watchTextChanges();
    this.watchAudioChanges();
  }

  registerHooks() {
    if (videoJs.Html5DashJS) {
      videoJs.Html5DashJS.hook('beforeinitialize', (player, mediaPlayer_) => {
        vjsSrv.dashBitrateHook(mediaPlayer_);

        try {
          mediaPlayer_.getProtectionController().setRobustnessLevel(config.get('params.style_schema') === 'lg-ais' ? 'HW_SECURE_CRYPTO' : 'SW_SECURE_CRYPTO');
          this.logger.log('setRobustnessLevel', config.get('params.style_schema') === 'lg-ais' ? 'HW_SECURE_CRYPTO' : 'SW_SECURE_CRYPTO');
        } catch (e) {
          this.logger.log('setRobustnessLevel', e);
        }

        window._dashPLayer = mediaPlayer_;
        mediaPlayer_.on(dashJs.MediaPlayer.events.STREAM_INITIALIZED, e => {
          this.logger.log('dashJs.MediaPlayer.events.STREAM_INITIALIZED', e);
          player.dash.representations = this._createRepresentations(mediaPlayer_);
        });
        mediaPlayer_.on(dashJs.MediaPlayer.events.QUALITY_CHANGE_REQUESTED, e => {});
        mediaPlayer_.on(dashJs.MediaPlayer.events.QUALITY_CHANGE_RENDERED, e => {
          if (e.mediaType === 'video') {
            this._onBitrateChanged(e);
          }
        });
      });
    }
  }

  get stats() {
    var streamBandwidth = 0;
    var streamBitrate = 0;
    var averageBandwidth = 0;
    var averageBitrate = 0;
    var bytesReceived = 0;
    var bitrateInterval = 5;

    if ((vimmiPI$1.getActiveAsset().get('activePlayback.drm.type') || '').toLowerCase().indexOf('dash') !== -1 && this.vjsPlayer.dash && this.vjsPlayer.dash.mediaPlayer && this.vjsPlayer.dash.mediaPlayer.getDashAdapter && this.activeBitrate) {
      var mediaPlayer = this.vjsPlayer.dash.mediaPlayer;
      var activeStream = mediaPlayer.getActiveStream();
      var streamInfo = activeStream.getStreamInfo();
      var dashAdapter = mediaPlayer.getDashAdapter();
      var dashMetrics = mediaPlayer.getDashMetrics();

      if (dashMetrics && streamInfo) {
        var periodIdx = streamInfo.index;
        var repSwitch = dashMetrics.getCurrentRepresentationSwitch('video', true);
        streamBandwidth = Math.round(dashAdapter.getBandwidthForRepresentation(repSwitch.to, periodIdx) / 8);
        streamBitrate = repSwitch ? Math.round(streamBandwidth) * 8 : NaN;
      }

      averageBitrate = this._calculatedBitrate || 0;
      averageBandwidth = this._calculatedBandwidth || 0;
      bytesReceived = this.dashStats.totalTraffic;

      if (!this.bitrateCalculator) {
        this.lastBytesReceived = this.lastBytesReceived || 0;
        this.bitrateCalculator = setInterval(() => {
          if (!this.vjsPlayer.paused()) {
            this._calculatedBitrate = Math.round((this.dashStats.totalTraffic - this.lastBytesReceived) * 8 / bitrateInterval);
            this._calculatedBandwidth = Math.round((this.dashStats.totalTraffic - this.lastBytesReceived) / bitrateInterval);
            this.lastBytesReceived = this.dashStats.totalTraffic;
          }
        }, bitrateInterval * 1000);
      }
    } else if (this.vjsPlayer.tech({
      IWillNotUseThisInPlugins: true
    })) {
      var tech = this.vjsPlayer.tech({
        IWillNotUseThisInPlugins: true
      });

      if (tech.vhs && tech.vhs.stats && this.activeBitrate) {
        if (this.bitrateCalculator) {
          clearInterval(this.bitrateCalculator);
        }

        var vhsStat = tech.vhs && tech.vhs.stats ? tech.vhs.stats : {};
        bytesReceived = vhsStat.mediaBytesTransferred;

        if (vimmiPI$1.getActiveAsset() && vimmiPI$1.getActiveAsset().get('extraData.missedBytes')) {
          bytesReceived += vimmiPI$1.getActiveAsset().get('extraData.missedBytes');
        }

        averageBandwidth = Math.round(vhsStat.bandwidth / 8);
        averageBitrate = Math.round(vhsStat.bandwidth);
        streamBandwidth = Math.round(this.activeBitrate.bandwidth / 8);
        streamBitrate = Math.round(this.activeBitrate.bandwidth);
      }
    }

    return {
      averageBandwidth,
      streamBandwidth,
      averageBitrate,
      streamBitrate,
      bytesReceived
    };
  }

  getRepresentations() {
    return this.representations;
  }

  get activeBitrate() {
    if (this._activeBitrate) {
      return this._activeBitrate;
    }

    var tech = null;
    var drm = false;

    if ((vimmiPI$1.getActiveAsset().get('activePlayback.drm.type') || '').toLowerCase().indexOf('dash') !== -1) {
      tech = this.vjsPlayer.dash;
      drm = true;
    } else {
      tech = this.vjsPlayer.tech({
        IWillNotUseThisInPlugins: true
      });
    }

    if (drm && tech.mediaPlayer) {
      var qualityIndex = tech.mediaPlayer.getQualityFor('video');
      this._activeBitrate = this.representations.find(item => {
        return item.qualityIndex === qualityIndex;
      });
    } else if (tech && tech.vhs) {
      var selectedPlaylist = tech.vhs.selectPlaylist();

      if (selectedPlaylist) {
        var selectedPlaylistBandwidth = selectedPlaylist.attributes ? selectedPlaylist.attributes.BANDWIDTH : 0;
        this._activeBitrate = this.representations.find(item => {
          return item.bandwidth === selectedPlaylistBandwidth;
        });
      }
    }

    return this._activeBitrate || null;
  }

  _onBitrateChanged(event) {
    if (!vimmiPI$1.getActiveAsset()) {
      return;
    }

    var switches = vimmiPI$1.getActiveAsset().get('extraData.jump') || 0;
    vimmiPI$1.getActiveAsset().set('extraData.jump', switches + 1);
    var maxViewBitrate = vimmiPI$1.getActiveAsset().get('extraData.max_view_bitrate') || 0;
    this._activeBitrate = null;
    var active = this.activeBitrate;

    if (active) {
      var prevActive = vimmiPI$1.getActiveAsset().get('extraData.active_stream');
      var allBitrates = this.getRepresentations();

      if (prevActive !== active._id + 1) {
        vimmiPI$1.getActiveAsset().set('extraData.active_stream', active._id + 1);
        Analytics.send('media_bitrate_switch', {
          cur_bitrate: prevActive && allBitrates[prevActive - 1] ? allBitrates[prevActive - 1].bandwidth || 0 : 0,
          tar_bitrate: active.bandwidth || 0
        });
      }
    }

    var activeBandwidth = active && active.attributes && active.attributes.BANDWIDTH ? active.attributes.BANDWIDTH : 0;

    if (activeBandwidth > maxViewBitrate) {
      vimmiPI$1.getActiveAsset().set('extraData.max_view_bitrate', +activeBandwidth);
    }

    eventsSrv.emit('videoBitrateChanged', {
      current: active
    });
  }

  _onLoadedmetadata(event) {
    var _tech;

    if (!vimmiPI$1.getActiveAsset()) {
      return;
    }

    var maxBitrate = 0;
    var minBitrate = 0;
    var tech = null;

    if ((vimmiPI$1.getActiveAsset().get('activePlayback.drm.type') || '').toLowerCase().indexOf('dash') !== -1) {
      tech = this.vjsPlayer.dash;
    } else {
      tech = this.vjsPlayer.tech({
        IWillNotUseThisInPlugins: true
      }).vhs;
    }

    if ((_tech = tech) !== null && _tech !== void 0 && _tech.representations) {
      this.logger.log('#_onLoadedmetadata', {
        tech: tech,
        representations: tech.representations()
      });
      this.representations = tech.representations().sort(function (a, b) {
        return +a.bandwidth < +b.bandwidth;
      });
      this.representations.map((el, index) => {
        el._id = index;

        if (maxBitrate < el.bandwidth) {
          maxBitrate = el.bandwidth;
        }

        minBitrate = minBitrate || el.bandwidth;

        if (minBitrate > el.bandwidth) {
          minBitrate = el.bandwidth;
        }
      });
    } else {
      this.representations = [];
    }

    var active = this.activeBitrate;

    if (active) {
      var maxViewBitrate = vimmiPI$1.getActiveAsset().get('extraData.max_view_bitrate') || 0;
      var activeBandwidth = active.bandwidth || 0;

      if (active > maxViewBitrate) {
        vimmiPI$1.getActiveAsset().set('extraData.max_view_bitrate', +activeBandwidth);
      }

      vimmiPI$1.getActiveAsset().set('extraData.active_stream', active._id + 1);
    }

    vimmiPI$1.getActiveAsset().set('extraData.max_bitrate', maxBitrate);
    vimmiPI$1.getActiveAsset().set('extraData.min_bitrate', minBitrate);
    vimmiPI$1.getActiveAsset().set('extraData.n_streams', this.representations.length);
    setTimeout(() => {
      this.activeAudioTrack = this._findActiveAudioTrack();
      this.activeTextTrack = this._findActiveTextTrack();
    }, 100);
    eventsSrv.emit('app_representation_loads');
  }

  _createRepresentation(bitrateInfo, index, enabledCallback) {
    var representation = {};
    representation.id = bitrateInfo.qualityIndex || index;
    representation.width = bitrateInfo.width;
    representation.height = bitrateInfo.height;
    representation.bandwidth = bitrateInfo.bandwidth;
    representation.qualityIndex = bitrateInfo.qualityIndex || index;
    representation.isEnabled_ = true;

    representation.enabled = function (enable, isAutoBitrateEnabled) {
      if (enable === undefined) {
        return representation.isEnabled_;
      }

      if (enable === representation.isEnabled_) {
        return;
      }

      if (enable === true || enable === false) {
        representation.isEnabled_ = enable;
        enabledCallback(enable, isAutoBitrateEnabled);
      }
    };

    return representation;
  }

  _createRepresentations(mediaPlayer_) {
    var streamInfo = mediaPlayer_.getActiveStream().getStreamInfo();
    var periodIdx = streamInfo.index;

    if (!mediaPlayer_.getDashAdapter) {
      console.warn('mediaPlayer_.getDashAdapter is not a function!');
      return;
    }

    var dashAdapter = mediaPlayer_.getDashAdapter();
    var adaptation = dashAdapter.getAdaptationForType(periodIdx, 'video', streamInfo);
    var representations = adaptation.Representation_asArray.map((qualityLevel, index) => {
      this.dashStats.maxQualityLevel = !this.dashStats.maxQualityLevel ? qualityLevel : this.dashStats.maxQualityLevel.bandwidth < qualityLevel.bandwidth ? qualityLevel : this.dashStats.maxQualityLevel;
      return this._createRepresentation(qualityLevel, index, (state, isAutoBitrateEnabled) => {
        if (isAutoBitrateEnabled) {
          if (!this.dashStats.autoBitrateEnabled && this.dashStats.maxQualityLevel) {
            mediaPlayer_.updateSettings({
              'streaming': {
                'abr': {
                  'maxBitrate': {
                    'video': parseInt((this.dashStats.maxQualityLevel.bandwidth + 1000) / 1000, 10)
                  }
                }
              }
            });
            this.dashStats.autoBitrateEnabled = true;
          }
        } else {
          this.dashStats.autoBitrateEnabled = false;

          if (state) {
            mediaPlayer_.updateSettings({
              'streaming': {
                'abr': {
                  'maxBitrate': {
                    'video': parseInt((qualityLevel.bandwidth + 1000) / 1000)
                  }
                }
              }
            });
          }
        }
      });
    });
    return () => {
      return representations;
    };
  }

  _findActiveAudioTrack() {
    var audioTracks = this.vjsPlayer.audioTracks();

    for (var i = 0; i < audioTracks.length; i++) {
      var track = audioTracks[i];

      if (track.enabled) {
        return track;
      }
    }
  }

  _findActiveTextTrack() {
    var textTracks = this.vjsPlayer.textTracks();

    for (var i = 0; i < textTracks.length; i++) {
      var track = textTracks[i];

      if (track.enabled) {
        return track;
      }
    }
  }

  getActiveAudioTrack() {
    var track = this.activeAudioTrack ? (this.activeAudioTrack.language || this.activeAudioTrack.label).toLowerCase() : null;
    var asset = vimmiPI$1.getActiveAsset();
    return asset && vimmiPI$1.isApplicableMetadataLang(asset) ? asset.get('metadataLang') || null : track;
  }

  watchAudioChanges() {
    var audioTracks = this.vjsPlayer.audioTracks();
    audioTracks.addEventListener('change', () => {
      var from = this.getActiveAudioTrack();

      for (var i = 0; i < audioTracks.length; i++) {
        var track = audioTracks[i];

        if (track.enabled) {
          this.activeAudioTrack = track;
          Analytics.send('media_audio_switch', {
            cur_audio_lang: from,
            tar_audio_lang: (track.language || track.label || 'unknown').toLowerCase()
          });
          return;
        }
      }
    });
  }

  watchTextChanges() {
    var textTracks = this.vjsPlayer.textTracks();
    textTracks.addEventListener('change', function () {
      for (var i = 0; i < textTracks.length; i++) {
        var track = textTracks[i];

        if (track.mode === 'showing') {
          Analytics.send('media_subtitle_switch', {
            cur_subtitle_lang: this.activeTextTrack ? this.activeTextTrack.language || this.activeTextTrack.label || 'unknown' : null,
            tar_subtitle_lang: track.language || track.label || 'unknown'
          });
          this.activeTextTrack = track;
          return;
        }
      }

      Analytics.send('media_subtitle_switch', {
        cur_subtitle_lang: this.activeTextTrack ? this.activeTextTrack.language || this.activeTextTrack.label || 'unknown' : null,
        tar_subtitle_lang: 'unknown'
      });
    });
  }

  handleAspectRatio() {
    var serverRatio = +vimmiPI$1.getActiveAsset().get('item.media_aspect_ratio') || +vimmiPI$1.getActiveAsset().get('extraData.media_aspect_ratio');

    if (serverRatio && (serverRatio < 0.57 || serverRatio > 0.55)) {
      return;
    }

    if (serverRatio && (serverRatio < 1.77 || serverRatio > 1.78)) {
      this.vjsPlayer.addClass('fit-content-contain');
    } else {
      var activeBitrate = this.activeBitrate;

      if (activeBitrate && activeBitrate.width && activeBitrate.height && this.prevActiveBitrateId !== activeBitrate._id) {
        this.prevActiveBitrateId = activeBitrate._id;
        var aspectRatio = activeBitrate.width / activeBitrate.height;
        var parsed = parseFloat(aspectRatio.toString().substr(0, 5));
        this.logger.log('#handleAspectRatio', {
          is16x9: parsed === 1.777,
          aspectRatio: aspectRatio,
          parsed: parsed,
          width: activeBitrate.width,
          height: activeBitrate.height
        });

        if (parsed !== 1.777) {
          this.vjsPlayer.addClass('fit-content-fill');
        } else {
          this.vjsPlayer.removeClass('fit-content-fill');
        }
      }
    }
  }

  handlePreferredAudioLang() {
    var $this = this;
    var audioTrackList = this.vjsPlayer.audioTracks();
    audioTrackList.addEventListener('addtrack', event => {
      if (!vimmiPI$1.getActiveAsset()) {
        return;
      }

      if (vimmiPI$1.isApplicableMetadataLang(vimmiPI$1.getActiveAsset())) {
        return;
      }

      var track = event.track || null;

      if (!track) {
        return;
      }

      eventLog.info('@addtrack', track);

      if (track && vimmiPI$1.getActiveAsset() && !vimmiPI$1.getActiveAsset().get('extraData.appliedPrefLang') && config.get('params.portal.preferred_audio_lang')) {
        var prefLang = normalizeLang(config.get('params.portal.preferred_audio_lang'), 'iso-2');
        var trackLang = track.language ? normalizeLang(track.language, 'iso-2') : null;
        eventLog.info('@addtrack check prefLang', track, prefLang, trackLang);

        if (trackLang === prefLang || (track.label || '').toLowerCase().indexOf(prefLang) !== -1) {
          eventLog.info('@addtrack apply prefLang', track, prefLang, trackLang);
          vimmiPI$1.getActiveAsset().set('extraData.appliedPrefLang', true);
          setTimeout(() => {
            $this.vjsPlayer.trackToActivate = track;
          }, 100);
        }
      }

      eventsSrv.emit(PLAYER_METHODS.GET_AUDIO_TRACK, track);
    });
  }

}
TechSrv._instance = null;

TechSrv.getInstance = function () {
  var vjsPlayer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!TechSrv._instance) {
    TechSrv._instance = new TechSrv(vjsPlayer);
  }

  return TechSrv._instance;
};

class autoplayStateService {
  constructor() {
    _defineProperty(this, "origCanAutoplay", null);
  }

  /**
   * @method checkAutoPlayState
   * @param {function} callback
   * @description checks is browser supports autoplay, with help library canAutoplay.
   * */
  checkAutoPlayState() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.origCanAutoplay !== null)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", _this.origCanAutoplay);

            case 2:
              return _context.abrupt("return", canAutoplay.video({
                inline: true,
                timeout: 1000
              }).then(obj => {
                var state = !!(obj && obj.result);
                Logger('APState').log('#checkAutoPlayState', state, obj);
                _this.origCanAutoplay = state;
                return state;
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }

}

var autoplayState = new autoplayStateService();

var instance$1;
class PMWrap$1 extends PM {
  constructor() {
    super();
  }

  static inst() {
    if (!instance$1) {
      instance$1 = new PMWrap$1();
    }

    return instance$1;
  }
  /**
   * Send postmessage event
   * @method send
   * @param event {String}
   * @param data {any}
   * @param options {Object}
   * @param options.sendMethod {String}
   */


  sendWrappedEvent(event, data, options) {
    options = Object.assign({}, options);
    var defaultData = {};

    if (this.vjsPlayer) {
      defaultData = {
        position: this.vjsPlayer.currentTime(),
        duration: this.vjsPlayer.duration(),
        type: this.vjsPlayer.currentType(),
        src: this.vjsPlayer.currentSrc()
      };
    }

    var sendData = Object.assign(defaultData, data || {});
    this.send({
      target: parent,
      type: event,
      data: sendData,
      sendMethod: options.sendMethod || null
    });
  }

}

class AppPreview {
  constructor() {
    this.ended = false;
    this.viewedTime = 0;
    this.previewFinish = false;
    this.currntModal = null;
    this.logger = Logger('Preview');
    this.timerEl = null;
    this.isChangedControls = false;
    this.preview_info = null;
    this.options = {};
  }

  isShowPreview(asset) {
    return !!asset.preview;
  }

  hide() {
    this.logger.info('#hide', {
      isChangedControls: this.isChangedControls
    });

    if (this.currntModal) {
      this.currntModal.close();
      delete this.currntModal;
    }

    vjsSrv.vjsPlayer.removeClass('previewed-content');
    vjsSrv.vjsPlayer.removeClass('preview-content-end');

    if (this.isChangedControls) {
      if (config.get('params.controls')) {
        vjsSrv.controls(true);
      }

      this.isChangedControls = false;
      this.ended = false;
      vjsSrv.vjsPlayer.off('timeupdate', this.timeUpdate);

      if (!this.previewFinish) {
        eventsSrv.emit(PLAYER_METHODS.PREVIEW_STOP, {
          stream_time: this.viewedTime
        });
        PMWrap$1.inst().sendWrappedEvent(PLAYER_METHODS.PREVIEW_STOP, {
          stream_time: this.viewedTime
        });
      }

      this.previewFinish = false;
      this.viewedTime = 0;
    }

    this.activated(false);
  }

  show(asset) {
    if (this.currntModal) {
      this.hide();
    }

    this.logger.info('#show');
    this.preview_info = asset.preview_info;
    vjsSrv.vjsPlayer.addClass('previewed-content');
    this.currntModal = vjsSrv.vjsPlayer.createModal('', {
      uncloseable: true
    });
    var time = this.calculateTime(asset.preview_info.preview_start, asset.preview_info.preview_end);
    this.currntModal.contentEl_.innerHTML = `<span class="modal-text">${vjsSrv.vjsPlayer.localize('Preview time left')}: <span class="preview-timer">${time}</span></span>`;
    this.timerEl = this.currntModal.contentEl_.querySelector('.preview-timer');
    this.currntModal.addClass('vjs-preview-modal');

    if (config.get('params.controls')) {
      vjsSrv.controls(true);
    }

    this.isChangedControls = true;

    if (!(asset.preview_info.preview_end - asset.preview_info.preview_start)) {
      vjsSrv.vjsPlayer.one('loadedmetadata', () => {
        this.stopWatch(false);
      });
    } else {
      vjsSrv.vjsPlayer.on('timeupdate', this.timeUpdate);
    }
  }

  toggleControls(state) {
    var controls = {
      ControlBar: {
        CustomAudioTrackButton: state
      }
    };

    for (var control in controls) {
      var a = vjsSrv.vjsPlayer.getChild(control);

      if (a) {
        if (typeof controls[control] === "boolean") {
          try {
            controls[control] ? a.enable() : a.disable();
          } catch (e) {}

          controls[control] ? a.show() : a.hide();
        } else {
          for (var subControl in controls[control]) {
            var b = a.getChild(subControl);

            if (b) {
              if (typeof controls[control][subControl] === "boolean") {
                try {
                  controls[control][subControl] ? b.enable() : b.disable();
                } catch (e) {}

                controls[control][subControl] ? b.show() : b.hide();
              } else {
                for (var subControl1 in controls[control][subControl]) {
                  var c = b.getChild(subControl1);

                  if (c) {
                    if (typeof controls[control][subControl][subControl1] === "boolean") {
                      try {
                        controls[control][subControl][subControl1] ? c.enable() : c.disable();
                      } catch (e) {}

                      controls[control][subControl][subControl1] ? c.show() : c.hide();
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  activated(state) {
    if (state === undefined) {
      return this.isActivated;
    }

    return this.isActivated = !!state;
  }

  calculateTime(timeStart, timeEnd) {
    var current = vjsSrv.vjsPlayer.currentTime();
    var second = timeEnd - (timeStart > current ? timeStart : current);
    return Tools$1.toHHMMSS(second);
  }

  stopWatch(triggerMessage) {
    this.previewFinish = true;
    this.logger.info('#stopWatch');
    this.currntModal.addClass('modal-preview-end');
    vjsSrv.vjsPlayer.addClass('preview-content-end');
    vjsSrv.vjsPlayer.pause();

    if (config.get('params.controls')) {
      vjsSrv.controls(false);
    }

    vjsSrv.vjsPlayer.currentTime(0);
    this.currntModal.contentEl_.innerHTML = `<span class="preview-end">${vjsSrv.vjsPlayer.localize(vimmiPI$1.getActiveAsset().get('preview_info.time_left_mess') || 'Preview time left')}</span>`;
    eventsSrv.emit(PLAYER_METHODS.PREVIEW_FINISH, {
      stream_time: vimmiPI$1.getActiveAsset().get('extraData.stream_time'),
      triggerMessage
    });
    PMWrap$1.inst().sendWrappedEvent(PLAYER_METHODS.PREVIEW_FINISH, {
      stream_time: vimmiPI$1.getActiveAsset().get('extraData.stream_time'),
      triggerMessage
    });

    if (vjsSrv.vjsPlayer.isFullscreen()) {
      vjsSrv.vjsPlayer.exitFullscreen();
    }
  }

  timeUpdate() {
    if (!vimmiPI$1.getActiveAsset()) {
      vjsSrv.vjsPlayer.off('timeupdate', this.timeUpdate);
      return;
    }

    if (this.previewFinish) {
      return;
    }

    var $this = Preview;
    $this.viewedTime = vimmiPI$1.getActiveAsset().get('extraData.stream_time');

    if ($this.ended) {
      vjsSrv.vjsPlayer.pause();
      return;
    }

    if (vjsSrv.vjsPlayer.currentTime() < $this.preview_info.preview_start) {
      vjsSrv.vjsPlayer.currentTime($this.preview_info.preview_start + $this.viewedTime);
      return;
    } else if (vjsSrv.vjsPlayer.currentTime() >= Preview.preview_info.preview_end) {
      $this.ended = true;
      $this.stopWatch();
      return;
    }

    Preview.lastPosition = vjsSrv.vjsPlayer.currentTime();
    Preview.timerEl.innerHTML = Preview.calculateTime.call(Preview, Preview.preview_info.preview_start, Preview.preview_info.preview_end);
  }

}
var Preview = new AppPreview();

var instance = null;
class RemoteControl {
  static getInstance() {
    if (!instance) {
      instance = new RemoteControl();
    }

    return instance;
  }

  constructor() {
    _defineProperty(this, "controlsForHandling", {
      'PrevButton': true,
      'RewindBackButton': true,
      'PlayToggle': true,
      'NextButton': true,
      'RewindForwardButton': true,
      'AudioTrackButton': true,
      'TVSettingsButton': true
    });

    this.logger = Logger('RemoteControl');
  }

  handleControlBar() {
    var list = Object.keys(this.controlsForHandling);
    vjsSrv.vjsPlayer.controlBar.children_.map(control => {
      if (control && list.indexOf(control.name_) !== -1 && this.controlsForHandling[control.name_]) {
        control.addClass('remote-ctrl');
      }
    });
  }

  getAllControls() {
    var activeTabControls = document.querySelectorAll('.rem-popup:not(.vjs-hidden) .remote-ctrl:not(.vjs-disabled):not(.vjs-hidden), .rem-popup:not(.vjs-hidden) .remote-ctrl.rem-active');

    if (activeTabControls.length) {
      return Array.prototype.slice.call(activeTabControls, 0);
    }

    return Array.prototype.slice.call(document.querySelectorAll('.remote-ctrl:not(.vjs-disabled):not(.vjs-hidden), .remote-ctrl.rem-active'), 0);
  }

  focusNext(event) {
    var controls = this.getAllControls();
    var active = this.getActive();
    this.logger.log('[focusNext]', {
      controls,
      active
    });
    var pos = controls.indexOf(active);

    if (pos !== -1 && controls.length - 1 > pos) {
      active.classList.remove('rem-active');
      controls[pos + 1].classList.add('rem-active');

      if (controls[pos + 1].handleFocus) {
        controls[pos + 1].handleFocus(controls[pos + 1]);
      }
    }
  }

  focusPrev(event) {
    var controls = this.getAllControls();
    var active = this.getActive();
    this.logger.log('[focusPrev]', {
      controls,
      active
    });
    var pos = controls.indexOf(active);

    if (pos !== -1 && pos - 1 >= 0) {
      active.classList.remove('rem-active');
      controls[pos - 1].classList.add('rem-active');

      if (controls[pos - 1].handleFocus) {
        controls[pos - 1].handleFocus(controls[pos - 1]);
      }
    }
  }

  handleActive(event) {
    var active = this.getActive();
    this.logger.log('[handleActive]', {
      active
    });

    if (!active.classList.contains('vjs-play-control')) {
      active.click();
    }
  }

  handleBack(event) {
    var active = this.getActive();
    this.logger.log('[handleBack]', {
      active,
      parent: active.dataset.parent,
      popup: document.querySelector(`.${active.dataset.parent}:not(.vjs-hidden)`)
    });

    if (active.dataset.parent) {
      var popup = document.querySelector(`.${active.dataset.parent}:not(.vjs-hidden)`);

      if (popup) {
        if (popup.onClose) {
          popup.onClose();
        } else {
          popup.classList.add('vjs-hidden');
        }

        if (event) {
          event.stopImmediatePropagation();
          event.stopPropagation();
        }
      }
    }
  }

  getActive() {
    return document.querySelector('.rem-popup:not(.vjs-hidden) .remote-ctrl.rem-active:not(.vjs-hidden)') || document.querySelector('.rem-popup:not(.vjs-hidden) .remote-ctrl:not(.vjs-hidden)') || document.querySelector('.remote-ctrl.rem-active:not(.vjs-hidden)') || document.querySelector('.vjs-play-control');
  }

}

class PlayerSrv {
  constructor() {
    this.logger = Logger('PlayerSrv');
    this.currentPosition = 0;
    this.isChangedLang = false;
  }

  getFormatLang(langCode) {
    var returnType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var langCodes = {
      'eng': 'en',
      'tha': 'th',
      'rom': 'ro',
      'heb': 'he'
    };

    if (returnType === 2) {
      if (langCodes[langCode]) {
        langCode = langCodes[langCode];
      }
    } else if (returnType === 3) {
      var values = Object.keys(langCodes).map(function (e) {
        return langCodes[e];
      });
      var pos = values.indexOf(langCode);

      if (pos !== -1) {
        langCode = Object.keys(langCodes)[pos];
      }
    }

    return langCode;
  }
  /**
   * @method getCurrentUrl
   * @description build player link
   * @return {string} current player link
   * */


  getCurrentUrl() {
    var asset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opt = {
      height: config.get('params.height'),
      width: config.get('params.width'),
      style_schema: config.get('params.style_schema'),
      autoplay: asset.playerOptions.autoplay === true,
      showEmbedded: config.get('params.showEmbedded') === true,
      qualityChange: config.get('params.qualityChange') === true,
      fullScreen: config.get('params.fullScreen') === true
    };

    if (config.get('params.muted')) {
      opt.mute = true;
    }

    if (config.get('params.audio_tag')) {
      opt.audio_tag = true;
    }

    if (config.get('params.font_size') && location.href.indexOf('font_size=') !== -1) {
      opt.font_size = config.get('params.font_size');
    }

    if (config.get('params.lang')) {
      opt.lang = config.get('params.lang');
    }

    opt.media = asset.media_id;
    var url = new URL(location.origin + location.pathname);

    var _loop = function _loop(name) {
      if (opt[name] === false) {
        return "continue";
      }

      if (Array.isArray(opt[name])) {
        opt[name].map(function (_val) {
          if (_val) {
            url.searchParams.set(name + '[]', _val ? _val : '');
          }
        });
      } else {
        url.searchParams.set(name, opt[name] && opt[name] !== true ? opt[name] : '');
      }
    };

    for (var name in opt) {
      var _ret = _loop(name);

      if (_ret === "continue") continue;
    }

    return url.toString();
  }

  getVideoJsSrc(playbackItem, asset) {
    var opt = {
      type: playbackItem.mimeType,
      withCredentials: false,
      beforeSend: request => {
        console.log(1111111111, request);
      }
    };

    if (playbackItem.srcObject) {
      opt.srcObject = playbackItem.srcObject;
    } else {
      opt.src = playbackItem.url.toString();
    }

    if ((config.get(`params.portal.customer`) || '').toLowerCase() === 'zman' && asset.get('origin') === 'aws' && (device.isSafari() || device.isAppleDevice() && device.isAnyMobile() && device.isChrome())) {
      var t = new URL(playbackItem.url);
      t.host = 'zman-cf-cdn.vidnt.com';
      opt.src = t.toString();
    }

    if (playbackItem.drm) {
      var drmTypeKey = config.get('keySystems')[playbackItem.drm.type];
      opt.keySystems = {};

      if (playbackItem.drm.type === 'HLS/FAIRPLAY') {
        delete opt.withCredentials;
        opt.keySystems[drmTypeKey] = {
          licenseUri: playbackItem.drm.license,
          certificateUri: playbackItem.drm.certificate
        };
      } else if (playbackItem.drm.type === 'DASH/PLAYREADY') {
        delete opt.keySystems;
        delete opt.withCredentials;
        opt.keySystemOptions = [{
          name: drmTypeKey,
          options: {
            serverURL: playbackItem.drm.license
          }
        }];
      } else if (playbackItem.drm.type === 'DASH/WIDEVINE') {
        delete opt.keySystems;
        delete opt.withCredentials;
        opt.keySystemOptions = [{
          name: drmTypeKey,
          options: {
            serverURL: playbackItem.drm.license
          }
        }];
      }
    }

    return opt;
  }
  /**
   * @method wrapBigPlayButton
   * @description wraps videojs bigPlayButton component for better handling user activity
   * */


  wrapBigPlayButton(player) {
    var bigPlayButton = player.getChild('bigPlayBtn').el();
    var wrapper = document.createElement('div');
    wrapper.classList.add('vjs-big-play-button-block');
    bigPlayButton.parentNode.insertBefore(wrapper, bigPlayButton);
    wrapper.addEventListener('touchstart', event => {
      player.userActive(true);
    });
    wrapper.appendChild(bigPlayButton);
    return wrapper;
  }
  /**
   * @method addTag
   * @return {HTMLElement}
   * @description create audio/video html tag, set required params and add it to page
   * */


  addTag() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var tag;

    if (options.useTag) {
      tag = options.useTag;
    } else if (config.get('params.audio_tag')) {
      tag = document.createElement('audio');
    } else {
      tag = document.createElement('video');
    }

    tag.id = config.get('playerId');
    tag.setAttribute('preload', 'auto');
    console.log('[playerSrv][addTag]', options);
    tag.setAttribute('controls', config.get('params.controls'));
    tag.setAttribute('crossorigin', 'anonymous');
    tag.setAttribute('playsinline', true);
    tag.setAttribute('webkit-playsinline', true);
    tag.classList.add('video-js');
    tag.classList.add('before-init');
    tag.classList.add('custom-waiting-video');

    if (config.get('params.account') === 'shop') {
      tag.classList.add('shoprz-init');
    }

    if (config.get('params.font_size')) {
      tag.style.fontSize = config.get('params.font_size');
    }

    if (config.get('params.muted')) {
      tag.setAttribute('muted', true);
    }

    if (!options.useTag) {
      document.body.appendChild(tag);
    }

    return tag;
  }

  transformToAsset(options) {
    var asset = {};
    asset.isLive = options.isLive;
    asset.mediaLink = options.mediaLink || null;
    asset.amsHeaders = options.amsHeaders || null;
    asset.origin = options.origin || null;
    asset.restricted = options.restricted;
    asset.media_id = options.media_id;

    if (options.metadata_url) {
      asset.playback_url = options.metadata_url;
    } else if (options.playback_url) {
      asset.playback_url = options.playback_url;
    } else if (options.mediaStream) {
      asset.mediaStream = options.mediaStream;
    }

    asset.alphaId = options.alphaId;
    asset.itype = options.itype;
    asset.preview = !!options.preview;
    asset.preview_info = options.preview_info || null;
    asset.extraData = options.extraData || {};
    asset.playerOptions = options.playerOptions || {};

    if (options.autoplay) {
      asset.playerOptions.autoplay = options.autoplay;
    }

    if (options.drm_types) {
      asset.drm_types = options.drm_types;
    }

    if (options.drm) {
      asset.drm = options.drm;
    }

    return asset;
  }

}

var PlayerSrv$1 = new PlayerSrv();

class VjsService {
  constructor() {
    _defineProperty(this, "KEYS", {
      REM_PLAY: 415,
      REM_PAUSE: 19,
      REM_STOP: 413,
      REM_REWIND_RIGHT: 417,
      REM_REWIND_LEFT: 412,
      PLAY: 179,
      SPACE: 32,
      ENTER: 13,
      RIGHT: 39,
      LEFT: 37,
      TOP: 38,
      DOWN: 40,
      BACK: 461
    });

    this.vjsPlayer = null;
    this.logger = Logger('VjsService');
    this.readyCllbacks = [];
    this.prevActiveElement = null;
  }

  createPlayer(options) {
    return new Promise((resolve, reject) => {
      var fullOpt = this._handleVideoJsOption(options);

      this.xhrHook();
      this.logger.log('createPlayer', fullOpt);
      window.vjsPlayer = this.vjsPlayer = videoJs(config.get('playerId'), fullOpt, () => {
        this.vjsPlayer.TechSrv = TechSrv.getInstance(this.vjsPlayer);
        PMWrap$1.inst().vjsPlayer = this.vjsPlayer;

        if (options.hotkeys) {
          this._addHotKeysSupports();
        }

        if (!config.get('params.controls')) {
          this.vjsPlayer.getChild('controlBar').hide();
        }

        while (this.readyCllbacks.length) {
          this.readyCllbacks.shift()(this.vjsPlayer);
        }

        resolve(this.vjsPlayer);
      });
    });
  }

  dashBitrateHook(mediaPlayer) {
    var $this = this;
    $this.vjsPlayer.TechSrv.dashStats.totalTraffic = 0;
    mediaPlayer.extend('RequestModifier', function () {
      return {
        modifyRequestHeader: function modifyRequestHeader(xhr) {
          setTimeout(() => {
            var t = xhr.onprogress;

            xhr.onprogress = function (event) {
              if (event.lengthComputable) {
                $this.vjsPlayer.TechSrv.dashStats.totalTraffic += parseInt(event.total / 8);
              }

              t(event);
            };
          });
          return xhr;
        },
        modifyRequestURL: function modifyRequestURL(url) {
          return url;
        }
      };
    });
  }

  xhrHook() {

    videoJs.Vhs.xhr.beforeRequest = function (options) {
      var asset = vimmiPI$1.getActiveAsset();

      options.beforeSend = request => {
        request.addEventListener('loadend', event => {
          var tech = vjsSrv.vjsPlayer.tech({
            IWillNotUseThisInPlugins: true
          });
          var vhsStat = tech.vhs && tech.vhs.stats ? tech.vhs.stats : {};

          if (request.status >= 400 || request.status < 200) {
            asset.set('extraData.xhrError', {
              method: request.method,
              status: request.status,
              statusText: request.statusText,
              responseURL: request.responseURL
            });
          } else {
            asset.set('extraData.xhrError', null);
          }

          if (request.status >= 500 || request.status < 200) {
            var mediaRequests = 0;

            if (mediaRequests > 10 && vhsStat.mediaRequestsErrored) {
              if (100 * (vhsStat.mediaRequestsErrored / vhsStat.mediaRequests) > 60) {
                vjsSrv.vjsPlayer.internalError = new AppError(ErrorCodes.CDN_ERR, 'Too many failed requests!', '');
                vjsSrv.vjsPlayer.pause();
                vjsSrv.vjsPlayer.hasStarted(false);
                vjsSrv.vjsPlayer.currentTime(0);
                vjsSrv.vjsPlayer.reset();
                vjsSrv.vjsPlayer.error(2);
              }
            }
          }
        }, true);
      };

      if (asset && asset.get('origin') === 'aws') {
        var activeManifest = asset.get('activePlayback.url');

        if (options.uri !== activeManifest) {
          var parts = activeManifest.split('?');

          if (parts.length >= 2) {
            options.uri += options.uri.indexOf('?') !== -1 ? '&' : '?' + parts[1];
          }
        }
      }

      return options;
    };
  }
  /**
   * @method tryPlay
   * @description force try to start play video if browser supports autoplay, and if option 'autoplay' is true
   * */


  tryPlay() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = vimmiPI$1.getActiveAsset().get('state.start');

              if (_context.t0) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return autoplayState.checkAutoPlayState();

            case 4:
              _context.t0 = _context.sent;

            case 5:
              if (!_context.t0) {
                _context.next = 9;
                break;
              }

              _this.vjsPlayer.play();

              _context.next = 10;
              break;

            case 9:
              console.warn('auto play not allowed!');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
  /**
   * @method getPromise
   * @description return promise for player, in this case will returned after player created
   * @return {promise}
   * */


  getPromise() {
    return new Promise((resolve, reject) => {
      if (this.vjsPlayer) {
        resolve(this.vjsPlayer);
      } else {
        this.readyCllbacks.push(resolve);
      }
    });
  }

  resetPlayer() {
    return new Promise((resolve, reject) => {
      if (config.get('eventsState.isCallPlay')) {
        this.vjsPlayer.pause();

        if (device.isFirefox() || device.isChrome() || device.isIOS()) {
          this.vjsPlayer.one('playerreset', event => {
            eventLog.info('playerreset', event);
            resolve(true);
          });
          this.logger.log('[resetPlayer]');
          this.vjsPlayer.reset();
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  }

  controls(state) {
    console.log('[vjsService][controls]', state);

    if (vimmiPI$1.getActiveAsset() && vimmiPI$1.getActiveAsset().get('isLive') && config.get('params.style_schema') === 'lg-ais') {
      this.vjsPlayer.controls(false);
    } else {
      this.vjsPlayer.controls(state);
    }
  }

  onPlayerStart() {
    if (vimmiPI$1.getActiveAsset().get('playerOptions.startPosition')) {
      this.currentPosition = vimmiPI$1.getActiveAsset().get('playerOptions.startPosition');
      this.isChangedLang = true;
    }

    var currentBitrate = vimmiPI$1.getActiveAsset().get('extraData.active_bitrate', 0);

    if (currentBitrate > vimmiPI$1.getActiveAsset().get('extraData.actual_max_bitrate', 0)) {
      vimmiPI$1.getActiveAsset().set('extraData.actual_max_bitrate', currentBitrate);
    }

    autoplayState.origCanAutoplay = true;

    if (config.get('eventsState.ended')) {
      return;
    }

    if (!vimmiPI$1.getActiveAsset().get('state.start')) {
      vimmiPI$1.getActiveAsset().set('state.start', true);
      Analytics.send('start');
      eventsSrv.emit(PLAYER_EVENTS.USER_PLAY);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.USER_PLAY);
    } else if (!vimmiPI$1.getActiveAsset().get('state.resumed')) {
      vimmiPI$1.getActiveAsset().set('state.resumed', true);

      if (device.isFirefox() && this.isChangedLang && vimmiPI$1.getActiveAsset().get('extraData.active_position') === null && this.currentPosition) {
        this.vjsPlayer.currentTime(this.currentPosition);
        this.isChangedLang = false;
      }

      Analytics.send('media_resume');
      eventsSrv.emit(PLAYER_EVENTS.USER_RESUME);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.USER_RESUME);
    }
  }
  /**
   * @method addHotKeysSupports
   * @return null
   * @description configure hotkeys
   *
   * */


  _addHotKeysSupports() {
    RemoteControl.getInstance().handleControlBar();
    this.vjsPlayer.on('keydown', event => {
      if (!vimmiPI$1.getActiveAsset()) {
        return;
      }

      if (Preview.isShowPreview(vimmiPI$1.getActiveAsset()) && Preview.ended) {
        return;
      }

      if (config.get('params.style_schema') === 'lg-ais') {
        if (vimmiPI$1.getActiveAsset().isLive) {
          if ([this.KEYS.PLAY, this.KEYS.REM_PAUSE, this.KEYS.REM_PLAY, this.KEYS.REM_STOP, this.KEYS.REM_REWIND_RIGHT, this.KEYS.REM_REWIND_LEFT].indexOf(event.which) !== -1) {
            return;
          }
        }

        if (event.which === this.KEYS.TOP || event.which === this.KEYS.LEFT) {
          RemoteControl.getInstance().focusPrev(event);
        }

        if (event.which === this.KEYS.BACK || event.which === 8) {
          RemoteControl.getInstance().handleBack(event);
        }

        if (event.which === this.KEYS.ENTER) {
          RemoteControl.getInstance().handleActive(event);
        }

        if (event.which === this.KEYS.DOWN || event.which === this.KEYS.RIGHT) {
          RemoteControl.getInstance().focusNext(event);
        }
      }

      if (event.which === this.KEYS.REM_REWIND_RIGHT) {
        this.vjsPlayer.currentTime(this.vjsPlayer.currentTime() + 10);
      }

      if (event.which === this.KEYS.REM_REWIND_LEFT) {
        this.vjsPlayer.currentTime(this.vjsPlayer.currentTime() - 10);
      }

      if ([this.KEYS.REM_STOP, this.KEYS.SPACE, this.KEYS.PLAY, this.KEYS.REM_PLAY, this.KEYS.REM_PAUSE].indexOf(event.which) !== -1 || this.KEYS.ENTER === event.which && RemoteControl.getInstance().getActive() && RemoteControl.getInstance().getActive().classList.contains('vjs-play-control')) {
        if (!this.vjsPlayer.paused()) {
          Analytics.send('chu', {}, {
            force: true
          });
          Analytics.send('media_pause', {
            stop_cause: 'pause'
          });
          this.logger.log('[event] @user action: PAUSE', 'hotKeys', event);
          this.vjsPlayer.pause();

          if (this.KEYS.REM_STOP === event.which) {
            this.vjsPlayer.currentTime(0);
          }

          vimmiPI$1.concurStop();
        } else {
          if (config.get('eventsState.isCallPlay')) {
            this.onPlayerStart();
            eventLog.info('@user action: RESUME', 'hotKeys', event);
          } else {
            eventLog.info('@user action: PLAY', 'hotKeys', event);
          }

          this.tryPlay();
        }

        event.stopImmediatePropagation();
        event.stopPropagation();
      }
    });

    if (this.vjsPlayer.hotkeys && config.get('params.style_schema') !== 'lg-ais') {
      this.vjsPlayer.hotkeys({
        volumeStep: 0.1,
        seekStep: 10,
        enableInactiveFocus: false,
        alwaysCaptureHotkeys: false,
        enableModifiersForNumbers: false
      });
    }
  }

  _handleVideoJsOption() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    options.controlBar = options.controlBar || {};
    var vjsChildren = [...videoJs.options.children];
    vjsChildren.splice(vjsChildren.indexOf('bigPlayButton'), 1, 'bigPlayBtn');
    config.set('vjsOptions.children', vjsChildren);

    if (device.isIOS() && (device.isChrome() || device.isSafari())) {
      config.set('vjsOptions.html5.vhs.overrideNative', false);
      config.set('vjsOptions.html5.nativeAudioTracks', true);
    } else {
      config.set('vjsOptions.html5.nativeAudioTracks', false);
      config.set('vjsOptions.html5.vhs.overrideNative', true);
    }

    config.set('vjsOptions.html5.nativeVideoTracks', false);
    config.set('vjsOptions.html5.vhs.maxPlaylistRetries', 2);
    config.set('vjsOptions.html5.vhs.enableLowInitialPlaylist', false);
    config.set('vjsOptions.html5.vhs.limitRenditionByPlayerDimensions', true);
    config.set('vjsOptions.html5.vhs.useDevicePixelRatio', true);
    config.set('vjsOptions.html5.vhs.smoothQualityChange', true);
    config.set('vjsOptions.html5.vhs.bandwidth', 1200000);

    if (config.get('params.dash')) {
      config.set('vjsOptions.html5.dash', config.get('params.dash'));
    }

    var controllBar = [];

    if (config.get('params.style_schema') !== 'lg-ais') {
      controllBar.push('PrevButton');

      if (options.controlBar.PlayToggle === undefined || options.controlBar.PlayToggle) {
        controllBar.push('PlayToggle');
      }

      controllBar.push('NextButton');
    }

    controllBar.push('currentTimeDisplay');
    controllBar.push('timeDivider');
    controllBar.push('durationDisplay');

    if (options.controlBar.VolumePanel === undefined || options.controlBar.VolumePanel) {
      if (device.isAnyMobile()) {
        if (!device.isSafari()) {
          controllBar.push('MuteToggle');
          controllBar.push('VolumeControl');
        } else {
          controllBar.push('MuteToggle');
        }
      } else {
        controllBar.push('VolumePanel');
      }
    } else {
      config.set('vjsOptions.controlBar.MuteToggle', false);
      config.set('vjsOptions.controlBar.VolumeControl', false);
      config.set('vjsOptions.controlBar.VolumePanel', false);
    }

    if (config.get('params.style_schema') === 'lg-ais') {
      controllBar.push('PrevButton');
    }

    if (options.controlBar.RewindBackButton) {
      controllBar.push('RewindBackButton');
    }

    controllBar.push('remainingTimeDisplay');
    controllBar.push('liveDisplay');
    controllBar.push('progressControl');

    if (config.get('params.style_schema') === 'lg-ais') {
      if (options.controlBar.PlayToggle === undefined || options.controlBar.PlayToggle) {
        controllBar.push('PlayToggle');
      }
    }

    if (options.controlBar.RewindForwardButton) {
      controllBar.push('RewindForwardButton');
    }

    if (config.get('params.style_schema') === 'lg-ais') {
      controllBar.push('NextButton');
    }

    if (options.controlBar.EmbeddedButton) {
      controllBar.push('EmbeddedButton');
    }

    if (options.controlBar.QualitySelectorButton === undefined || options.controlBar.QualitySelectorButton) {
      controllBar.push('QualitySelectorButton');
    }

    if (options.controlBar.AudioTrackButton === undefined || options.controlBar.AudioTrackButton) {
      controllBar.push('AudioTrackButton');

      if (config.get('params.style_schema') !== 'lg-ais') {
        controllBar.push('CustomAudioTrackButton');
      }
    }

    if (options.controlBar.SubtitlesButton === undefined || options.controlBar.SubtitlesButton) {
      controllBar.push('SubtitlesButton');
    }

    if (config.get('params.style_schema') === 'lg-ais') {
      controllBar.push('SettingsButton');
      controllBar.push('TracksPanel');
    }

    if ((options.controlBar.FullscreenToggle === undefined || options.controlBar.FullscreenToggle) && !config.get('params.audio_tag')) {
      controllBar.push('FullscreenToggle');
    } else {
      config.set('vjsOptions.controlBar.FullscreenToggle', false);
    }

    if (config.get('params.style_schema') === 'lg-ais') {
      controllBar.push('TVSettingsButton');
      config.set('vjsOptions.fluid', true);
    }

    if (options.plugins) {
      config.set('vjsOptions.plugins', options.plugins);
    }

    config.set('vjsOptions.controlBar.children', config.get('params.controls') ? controllBar : {});
    return config.get('vjsOptions');
  }

  initVideoJsHooks() {
    videoJs.use('*', player => {
      return {
        callPlay: () => {
          if (!vimmiPI$1.getActiveAsset()) {
            return;
          }

          this.logger.log('deb: callPlay', vjsSrv.vjsPlayer, vimmiPI$1.getActiveAsset());
          vimmiPI$1.getActiveAsset().set('state.callPlay', true);
          config.set('eventsState.isCallPlay', true);

          if (config.get('eventsState.isStartPlay') && config.get('eventsState.ended')) {
            config.set('eventsState.isStartPlay', false);
            vimmiPI$1.getActiveAsset().set('state.start', false);
            vimmiPI$1.getActiveAsset().set('state.playing', false);
            config.set('eventsState.playing', false);
            config.set('eventsState.ended', false);
            Analytics.resetCalculatedOptions(vimmiPI$1.getActiveAsset());
          }
        },
        play: (terminated, value) => {
          if (terminated) {
            this.logger.log('deb: play The play was middleware terminated.');
          } else if (value && value.then) {
            value.then(() => {
              if (!vimmiPI$1.getActiveAsset()) {
                return;
              }

              if (!config.get('eventsState.isStartPlay')) {
                config.set('eventsState.isStartPlay', true);
                vimmiPI$1.getActiveAsset().set('extraData.auto_play', true);
              }

              this.logger.log('deb: play The play succeeded!');
              vjsSrv.onPlayerStart();
            }).catch(err => {
              if (vimmiPI$1.getActiveAsset()) {
                vimmiPI$1.getActiveAsset().set('extraData.auto_play', false);
              }

              config.set('eventsState.isStartPlay', false);
              this.logger.log('deb: play The play was rejected', err);
            });
          } else {
            this.logger.log('deb: play promise not supports! it should start to play');
            config.set('eventsState.isStartPlay', true);

            if (vimmiPI$1.getActiveAsset()) {
              vimmiPI$1.getActiveAsset().set('extraData.auto_play', true);
            }

            vjsSrv.onPlayerStart();
          }
        }
      };
    });

    if (videoJs.Html5DashJS) {
      videoJs.Html5DashJS.hook('updatesource', source => {
        if (vimmiPI$1.getActiveAsset().get('activePlayback.drm.type') === 'DASH/WIDEVINE') {
          var options = PlayerSrv$1.getVideoJsSrc(vimmiPI$1.getActiveAsset().get('activePlayback'), vimmiPI$1.getActiveAsset());

          if (options.keySystemOptions) {
            source.keySystemOptions = options.keySystemOptions;
          }
        }

        return source;
      });
    }
  }

}

var vjsSrv = new VjsService();

class AppPostersManager {
  constructor() {
    this.prevPoster = null;
    this.nextPoster = null;
    this.logger = Logger('AppPostersManager');
    this.ANIMATION_TIMEOUT = 500;
    this.changePosterTimeoutID = null;
    this.stackEvents = [];
    this._secondPoster = null;
  }

  init() {
    vjsSrv.vjsPlayer.tech_.el_.addEventListener('posterAnimationEnd', this.eventListener.bind(this), false);
  }

  eventListener(event) {
    switch (event.type) {
      case 'posterAnimationEnd':
        while (this.stackEvents.length) {
          var _opt = this.stackEvents.shift();

          this[_opt.method](_opt.options, true);
        }

    }

    event.preventDefault();
    event.stopPropagation();
  }

  setCurrentPoster(asset, isAfterAnimation) {
    this.logger.log('setCurrentPoster', asset.extraData.poster);

    if (asset.extraData.poster) {
      vjsSrv.vjsPlayer.poster(asset.extraData.poster);
    } else {
      vjsSrv.vjsPlayer.posterImage.posterPath = '';
      vjsSrv.vjsPlayer.poster('');
    }
  }

}
var PostersManager = new AppPostersManager();

class Languages {
  constructor() {
    _defineProperty(this, "languages", {
      en: {
        "Audio Player": "Audio Player",
        "Video Player": "Video Player",
        "Play": "Play",
        "Pause": "Pause",
        "Replay": "Replay",
        "Current Time": "Current Time",
        "Duration Time": "Duration Time",
        "Remaining Time": "Remaining Time",
        "Stream Type": "Stream Type",
        "LIVE": "LIVE",
        "Loaded": "Loaded",
        "Progress": "Progress",
        "Progress Bar": "Progress Bar",
        "progress bar timing: currentTime={1} duration={2}": "{1} of {2}",
        "Fullscreen": "Fullscreen",
        "Non-Fullscreen": "Non-Fullscreen",
        "Mute": "Mute",
        "Unmute": "Unmute",
        "Playback Rate": "Playback Rate",
        "Subtitles": "Subtitles",
        "subtitles off": "subtitles off",
        "Captions": "Captions",
        "captions off": "captions off",
        "Chapters": "Chapters",
        "Descriptions": "Descriptions",
        "descriptions off": "descriptions off",
        "Audio Track": "Audio Track",
        "Volume Level": "Volume Level",
        "You aborted the media playback": "You aborted the media playback",
        "A network error caused the media download to fail part-way.": "A network error caused the media download to fail part-way.",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.": "The media could not be loaded, either because the server or network failed or because the format is not supported.",
        "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
        "No compatible source was found for this media.": "No compatible source was found for this media.",
        "The media is encrypted and we do not have the keys to decrypt it.": "The media is encrypted and we do not have the keys to decrypt it.",
        "Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled": "Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled",
        "The Browser doesn't support the DRM types that the content supports!": "The web browser does not support DRM, please use other web browsers to play the content.",
        "Play Video": "Play Video",
        "Close": "Close",
        "Close Modal Dialog": "Close Modal Dialog",
        "Modal Window": "Modal Window",
        "This is a modal window": "This is a modal window",
        "This modal can be closed by pressing the Escape key or activating the close button.": "This modal can be closed by pressing the Escape key or activating the close button.",
        ", opens captions settings dialog": ", opens captions settings dialog",
        ", opens subtitles settings dialog": ", opens subtitles settings dialog",
        ", opens descriptions settings dialog": ", opens descriptions settings dialog",
        ", selected": ", selected",
        "captions settings": "captions settings",
        "subtitles settings": "subititles settings",
        "descriptions settings": "descriptions settings",
        "Text": "Text",
        "White": "White",
        "Black": "Black",
        "Red": "Red",
        "Green": "Green",
        "Blue": "Blue",
        "Yellow": "Yellow",
        "Magenta": "Magenta",
        "Cyan": "Cyan",
        "Background": "Background",
        "Window": "Window",
        "Transparent": "Transparent",
        "Semi-Transparent": "Semi-Transparent",
        "Opaque": "Opaque",
        "Font Size": "Font Size",
        "Text Edge Style": "Text Edge Style",
        "None": "None",
        "Raised": "Raised",
        "Depressed": "Depressed",
        "Uniform": "Uniform",
        "Dropshadow": "Dropshadow",
        "Font Family": "Font Family",
        "Proportional Sans-Serif": "Proportional Sans-Serif",
        "Monospace Sans-Serif": "Monospace Sans-Serif",
        "Proportional Serif": "Proportional Serif",
        "Monospace Serif": "Monospace Serif",
        "Casual": "Casual",
        "Script": "Script",
        "Small Caps": "Small Caps",
        "Reset": "Reset",
        "restore all settings to the default values": "restore all settings to the default values",
        "Done": "Done",
        "Caption Settings Dialog": "Caption Settings Dialog",
        "Beginning of dialog window. Escape will cancel and close the window.": "Beginning of dialog window. Escape will cancel and close the window.",
        "End of dialog window.": "End of dialog window.",
        "{1} is loading.": "{1} is loading.",
        "This channel is not available in your package. You can subscribe the packages at ais.co.th or my AIS.": "This channel is not available in your package. You can subscribe the packages at <a target=\"_blank\" href=\"http://www.ais.co.th/play/en/package.html\" >ais.co.th</a> or my AIS.",
        "This video content is not available in your package. You can subscribe the packages at ais.co.th or my AIS.": "This video content is not available in your package. You can subscribe the packages at <a target=\"_blank\" href=\"http://www.ais.co.th/play/en/package.html\" >ais.co.th</a> or my AIS.",
        "This channel is not available in your package.": "This channel is not available in your package.",
        "This video content is not available in your package.": "This video content is not available in your package.",
        "This content is restricted by age.": "This content is restricted by age.",
        "This content is restricted for unauthorized users. Please Login or register.": "This content is restricted for unauthorized users. Please Login or register.",
        "Please Login": "Please Login",
        "This content is restricted for your device.": "This content is restricted for your device.",
        "This content is restricted for your country.": "This content is restricted for your country.",
        "Preview time left": "Preview time left"
      },
      th: {
        "Audio Player": "ปรับเสียง",
        "Video Player": "เล่นวีดีโอ",
        "Play": "เล่น",
        "Pause": "หยุด",
        "Replay": "เล่นใหม่",
        "Current Time": "เวลาปัจจุบัน",
        "Duration Time": "ระยะเวลา",
        "Remaining Time": "เวลาที่เหลือ",
        "Stream Type": "ประเภทการสตรีม",
        "LIVE": "สด",
        "Loaded": "Loaded",
        "Progress": "Progress",
        "Progress Bar": "แถบเวลา",
        "progress bar timing": "progress bar timing",
        "Fullscreen": "แสดงเต็มจอ",
        "Non-Fullscreen": "แบบไม่เต็มหน้าจอ",
        "Mute": "ปิดเสียง",
        "Unmute": "เปิดเสียง",
        "Playback Rate": "Playback Rate",
        "Subtitles": "คำบรรยาย",
        "subtitles off": "ปิดคำบรรยาย",
        "Captions": "คำบรรยายใต้ภาพ",
        "captions off": "ปิดคำบรรยายใต้ภาพ",
        "Chapters": "บท",
        "Descriptions": "คำอธิบาย",
        "descriptions off": "ปิดคำอธิบาย",
        "Audio Track": "แทร็กเสียง",
        "Volume Level": "ระดับเสียง",
        "You aborted the media playback": "ยกเลิกการเล่น",
        "A network error caused the media download to fail part-way.": "เกิดข้อผิดพลาดการเชื่อมต่ออินเทอร์เน็ต ทำให้การสตรีมล้มเหลว",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.": "เกิดข้อผิดพลาดการเชื่อมต่ออินเทอร์เน็ต หรือ เซิร์ฟเวอร์ ทำให้การสตรีมล้มเหลว",
        "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "ไม่สามารถสตรีมคอนเทนต์ เนื่องจากคุณสมบัติเบราว์เซอร์ของคุณไม่รองรับ",
        "No compatible source was found for this media.": "ไม่สามารถสตรีมคอนเทนต์ เนื่องจากคุณสมบัติเบราว์เซอร์ของคุณไม่รองรับ",
        "The media is encrypted and we do not have the keys to decrypt it.": "คอนเท้นถูกเข้ารหัส",
        "Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled": "ขณะนี้บัญชีผู้ใช้งานของคุณมีการรับชมพร้อมกันเกินจำนวนอุปกรณ์ที่กำหนด กรุณาหยุดเล่นเนื้อหาจากบางอุปกรณ์ เพื่อสามารถเริ่มรับชมผ่านอุปกรณ์นี้ได้",
        "The Browser doesn't support the DRM types that the content supports!": "เว็บเบราว์เซอร์นี้ไม่รองรับ DRM กรุณาใช้เว็บเบราว์เซอร์อื่นเพื่อรับชมคอนเทนต์",
        "Play Video": "เล่นวีดีโอ",
        "Close": "ปิด",
        "Close Modal Dialog": "Close Modal Dialog",
        "Modal Window": "Modal Window",
        "This is a modal window": "This is a modal window",
        "This modal can be closed by pressing the Escape key or activating the close button.": "This modal can be closed by pressing the Escape key or activating the close button.",
        ", opens captions settings dialog": ", opens captions settings dialog",
        ", opens subtitles settings dialog": ", opens subtitles settings dialog",
        ", opens descriptions settings dialog": ", opens descriptions settings dialog",
        ", selected": "เลือก",
        "captions settings": "ตั้งค่าคำอธิบายใต้ภาพ",
        "subtitles settings": "ตั้งค่าคำบรรยาย",
        "descriptions settings": "ตั้งค่าคำอธิบาย",
        "Text": "ข้อความ",
        "White": "สีขาว",
        "Black": "สีดำ",
        "Red": "สีแดง",
        "Green": "สีเขียว",
        "Blue": "สีน้ำเงิน",
        "Yellow": "สีเหลือง",
        "Magenta": "สีม่วงแดงเข้ม",
        "Cyan": "สีฟ้า",
        "Background": "พื้นหลัง",
        "Window": "หน้าต่าง",
        "Transparent": "โปร่งใส",
        "Semi-Transparent": "โปร่งแสง",
        "Opaque": "ทึบแสง",
        "Font Size": "ขนาดตัวอักษร",
        "Text Edge Style": "Text Edge Style",
        "None": "ไม่มี",
        "Raised": "เพิ่ม",
        "Depressed": "ลด",
        "Uniform": "Uniform",
        "Dropshadow": "Dropshadow",
        "Font Family": "Font Family",
        "Proportional Sans-Serif": "Proportional Sans-Serif",
        "Monospace Sans-Serif": " Monospace Sans-Serif",
        "Proportional Serif": "Proportional Serif",
        "Monospace Serif": "Monospace Serif",
        "Casual": "Casual",
        "Script": "Script",
        "Small Caps": "Small Caps",
        "Reset": "รีเซ็ต",
        "restore all settings to the default values": "คืนค่าการตั้งค่าทั้งหมดเป็นค่าเริ่มต้น",
        "Done": "เสร็จสิ้น",
        "Caption Settings Dialog": "Caption Settings Dialog",
        "Beginning of dialog window. Escape will cancel and close the window.": "Beginning of dialog window. Escape will cancel and close the window.",
        "End of dialog window.": "End of dialog window.",
        "{1} is loading": "กำลังโหลด",
        "This channel is not available in your package. You can subscribe the packages at ais.co.th or my AIS.": "ช่องนี้ไม่รวมอยู่ในแพ็คเกจของคุณ คุณสามารถสมัครแพ็คเกจได้ที่ <a target=\"_blank\" href=\"http://www.ais.co.th/play/package.html\">ais.co.th</a> หรือ my AIS",
        "This video content is not available in your package. You can subscribe the packages at ais.co.th or my AIS.": "วีดีโอเรื่องนี้ไม่รวมอยู่ในแพ็คเกจของคุณ คุณสามารถสมัครแพ็คเกจได้ที่ <a target=\"_blank\" href=\"http://www.ais.co.th/play/package.html\">ais.co.th</a> หรือ my AIS",
        "This content is restricted by age.": "คอนเทนต์นี้ถูก จำกัด อายุ",
        "This content is restricted for unauthorized users. Please Login or register.": "คอนเทนต์นี้จำกัดการใช้งาน กรุณาเข้าสู่ระบบหรือลงทะเบียนเพื่อใช้งาน",
        "Please Login": "กรุณาเข้าสู่ระบบ",
        "This content is restricted for your device.": "คอนเทนต์นี้ถูก จำกัด สำหรับอุปกรณ์ของคุณ",
        "This content is restricted for your country.": "คอนเทนต์นี้ถูก จำกัด สำหรับประเทศของคุณ"
      },
      he: {
        "Audio Player": "נגן אודיו",
        "Video Player": "נגן וידאו",
        "Play": "נגן",
        "Pause": "השאה",
        "Replay": "השהיה",
        "Current Time": "זמן כעת",
        "Duration Time": "משך זמן",
        "Remaining Time": "זמן נותר",
        "Stream Type": "Stream Type",
        "LIVE": "שידור חי",
        "Loaded": "נטען",
        "Progress": "התקדמות",
        "Progress Bar": "סרגל התקדמות",
        "progress bar timing": "תזמון סרגל התקדמות",
        "Fullscreen": "מסך מלא",
        "Non-Fullscreen": "לא מסך מלא",
        "Mute": "השתק",
        "Unmute": "בטל השתקה",
        "Playback Rate": "קצב השמעה",
        "Subtitles": "כתוביות",
        "subtitles off": "כתוביות כבויות",
        "Captions": "כיתובים",
        "captions off": "כיתובים כבויים",
        "Chapters": "פרקים",
        "Descriptions": "תיאורים",
        "descriptions off": "תיאורים כבויים",
        "Audio Track": "רצועת שמע",
        "Volume Level": "עוצמת קול",
        "You aborted the media playback": "ביטלת את הפעלת המדיה",
        "A network error caused the media download to fail part-way.": "שגיאת רשת גרמה לכישלון הורדת המדיה באופן חלקי",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.": "לא ניתן היה לטעון את המדיה, משום שהשרת או הרשת נכשלו או משום שהפורמט אינו נתמך",
        "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "הפעלת המדיה הופסקה בגלל בעיה טכנית או מכיוון שהדפדפן שלך לא תומך בסוג מדיה זה",
        "No compatible source was found for this media.": "לא נמצא מקור תואם למדיה זו",
        "The media is encrypted and we do not have the keys to decrypt it.": "המדיה מוצפנת ואין לנו את המפתחות לפענח אותה",
        "Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled": "מצטערים, חשבונך חורג ממגבלת ההפצה המקסימאלית במקביל. אנא הפסק את הפעלת התוכן במכשיר אחר כדי להפעיל את הוידאו במכשיר זה",
        "The Browser doesn't support the DRM types that the content supports!": "דפדפן זה אינו תומך בסוגי ה- DRM בהם התוכן תומך",
        "Play Video": "נגן",
        "Close": "סגור",
        "Close Modal Dialog": "סגור תיבת דו שיח של המודל",
        "Modal Window": "חלון מודל",
        "This is a modal window": "זה חלון מודל",
        "This modal can be closed by pressing the Escape key or activating the close button.": "ניתן לסגור מודל זה על ידי לחיצה על מקש Escape או הפעלת לחצן הסגירה",
        ", opens captions settings dialog": ", פותח את תיבת הדו-שיח של הגדרות כיתוב",
        ", opens subtitles settings dialog": ", פותח את תיבת הדו-שיח של הגדרות כתוביות",
        ", opens descriptions settings dialog": ", פותח תיבת דו-שיח הגדרות תיאור",
        ", selected": "נבחר",
        "captions settings": "הגדרות כיתובים",
        "subtitles settings": "הגדרות כתוביות",
        "descriptions settings": "הגדרות תיאורים",
        "Text": "טקסט",
        "White": "לבן",
        "Black": "שחור",
        "Red": "אדום",
        "Green": "ירוק",
        "Blue": "כחול",
        "Yellow": "צהוב",
        "Magenta": "מגנטה",
        "Cyan": "טורקיז",
        "Background": "רקע",
        "Window": "חלון",
        "Transparent": "שקוף",
        "Semi-Transparent": "שקוף למחצה",
        "Opaque": "אטום",
        "Font Size": "גודל פונט",
        "Text Edge Style": "סגנון טקסט קצה ",
        "None": "אף אחד",
        "Raised": "מורם",
        "Depressed": "מדוכא",
        "Uniform": "מדים",
        "Dropshadow": "טיפת צל",
        "Font Family": "גופן משפחה",
        "Proportional Sans-Serif": "Proportional Sans-Serif",
        "Monospace Sans-Serif": " Monospace Sans-Serif",
        "Proportional Serif": "Proportional Serif",
        "Monospace Serif": "Monospace Serif",
        "Casual": "אגבי",
        "Script": "תסריט",
        "Small Caps": "אותיות קטנות",
        "Reset": "אתחול",
        "restore all settings to the default values": "שחזר את כל ההגדרות לערכי ברירת המחדל",
        "Done": "בוצע",
        "Caption Settings Dialog": "תיבת דו-שיח של הגדרות כיתוב",
        "Beginning of dialog window. Escape will cancel and close the window.": "תחילת חלון תיבת דו-שיח. כפתור Escape יבטל ויסגור את החלון",
        "End of dialog window.": "סוף חלון תיבת הדו-שיח",
        "{1} is loading": "טוען",
        "This channel is not available in your package.": "ערוץ זה אינו זמין בחבילה שלך.",
        "This video content is not available in your package.": "תוכן וידאו זה אינו זמין בחבילה שלך.",
        "This content is restricted by age.": "תוכן זה מוגבל לפי גיל",
        "This content is restricted for unauthorized users. Please Login or register.": "תוכן זה מוגבל למשתמשים לא מורשים. אנא התחבר או הירשם",
        "Please Login": "אנא התחבר",
        "This content is restricted for your device.": "תוכן זה מוגבל למכשיר שלך",
        "This content is restricted for your country.": "תוכן זה מוגבל למדינתך",
        "Preview time left": "זמן תצוגה מקדימה שנותר"
      }
    });
  }

  getLang(code) {
    if (this.languages[code]) {
      return this.languages[code];
    }

    return null;
  }

}
var Languages$1 = new Languages();

class AppRestriction {
  constructor() {
    this.currntModal = null;
    this.isChangedControls = false;
    this.options = {};
  }

  isRestricted(asset) {
    return asset && !!asset.restricted && !asset.preview;
  }

  skipPlay() {
    if (config.get('eventsState.isCallPlay')) {
      vjsSrv.vjsPlayer.pause();
    }
  }

  reset() {
    if (this.currntModal) {
      this.currntModal.close();
      delete this.currntModal;
    }
  }

  hide() {
    if (this.currntModal) {
      this.currntModal.close();
      delete this.currntModal;
    }

    if (this.isChangedControls) {
      vjsSrv.vjsPlayer.bigPlayBtn.show();

      if (config.get('params.controls')) {
        vjsSrv.controls(true);
      }

      this.isChangedControls = false;
    }

    vjsSrv.vjsPlayer.removeClass('restricted-content');
  }

  show(asset) {
    this.hide();
    this.skipPlay();

    if (config.get('params.controls')) {
      vjsSrv.controls(false);
    }

    vjsSrv.vjsPlayer.bigPlayBtn.hide();
    this.isChangedControls = true;
    vjsSrv.vjsPlayer.addClass('restricted-content');
    this.currntModal = vjsSrv.vjsPlayer.createModal('', {
      uncloseable: true
    });
    var text = '';
    var customHtmlEl = null;

    switch (asset.restricted.toLowerCase()) {
      case 'concurrency'.toLowerCase():
        text = 'Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled';
        break;

      case 'restrictedForAge'.toLowerCase():
        text = 'This content is restricted by age.';
        break;

      case 'RestrictedForCountry'.toLowerCase():
        text = 'This content is restricted for your country.';
        break;

      case 'RestrictedForDevice'.toLowerCase():
        text = 'This content is restricted for your device.';
        break;

      case 'RestrictedForNotFree'.toLowerCase():
        if ((config.get(`params.portal.customer`) || '').toLowerCase() === 'ais') {
          if (asset.isLive) {
            text = 'This channel is not available in your package. You can subscribe the packages at ais.co.th or my AIS.';
          } else {
            text = 'This video content is not available in your package. You can subscribe the packages at ais.co.th or my AIS.';
          }
        } else {
          if (asset.isLive) {
            text = 'This channel is not available in your package.';
          } else {
            text = 'This video content is not available in your package.';
          }
        }

        this.currntModal.addClass('modal-with-buttons');
        break;

      case 'RestrictedForUnknow'.toLowerCase():
        customHtmlEl = Tools$1.htmlToElement(`
                    <button class="login-play-button" type="button" title="Play Video" >
                        <span aria-hidden="true" class="vjs-icon-placeholder"></span>
                        <span class="vjs-control-text" aria-live="polite">Play Video</span>
                    </button>
                `);

        customHtmlEl.onclick = event => {
          eventsSrv.emit(PLAYER_METHODS.FORCE_LOGIN);
          PMWrap$1.inst().sendWrappedEvent(PLAYER_METHODS.FORCE_LOGIN);
          event.stopImmediatePropagation();
          event.preventDefault();
        };

        if ((config.get(`params.portal.customer`) || '').toLowerCase() === 'ais') {
          text = 'Please Login';
        }

        break;

      case 'RestrictedForLive'.toLowerCase():
      default:
        text = 'This content is restricted for unauthorized users. Please Login or register.';
        break;
    }

    vjsSrv.vjsPlayer.el().dataset.restriction = asset.restricted;
    this.currntModal.contentEl_.innerHTML = `<span class="modal-text">${vjsSrv.vjsPlayer.localize(text)}</span>`;

    if (customHtmlEl) {
      var node = this.currntModal.contentEl_;
      node['insertBefore'](customHtmlEl, node.childNodes[0]);
    }

    this.currntModal.addClass('vjs-restriction-modal');
  }

}
var Restriction = new AppRestriction();

class PrevNextSuggest {
  constructor() {
    this.vjsPlayer = null;
    this.listenerInit = false;
    this.logger = Logger('PrevNextSuggest');
    this.assets = {
      SuggestVideoNext: {},
      SuggestVideoPrev: {}
    };
    vjsSrv.getPromise().then(vjsPlayer => {
      this.vjsPlayer = vjsPlayer;
    });
  }

  addEventsListeners() {
    if (!this.listenerInit) {
      this.listenerInit = true;
      this.vjsPlayer.on(['play', 'timeupdate', 'pause', 'seeked'], () => {
        this.handlePosition();
      });
      this.vjsPlayer.on(['ended', 'error'], () => {
        this.hide('SuggestVideoNext');
      });
    }
  }

  handlePosition() {
    var currentTime = this.vjsPlayer.currentTime() || 0.1;
    var showWhenDuration = 0;

    if (this.vjsPlayer.duration() < 15 * 2) {
      showWhenDuration = Math.floor(this.vjsPlayer.duration() / 2);
    } else {
      showWhenDuration = 15;
    }

    var isDefined = !!this.assets['SuggestVideoNext'] && !!this.assets['SuggestVideoNext'].title;
    var isShow = this.vjsPlayer.duration() - currentTime < showWhenDuration;

    if (!isShow || isShow && this.vjsPlayer.paused() && vimmiPI.getActiveAsset().get('mainPage') && !this.vjsPlayer.isFullscreen()) {
      this.hide('SuggestVideoNext', false);
    } else if (isShow && isDefined) {
      this.show('SuggestVideoNext');
    }
  }

  setOptions(componentName, options) {
    this.addEventsListeners();
    this.assets[componentName] = options;

    this._updateComponent(componentName, options);
  }

  _updateComponent(componentName, options) {
    var comp = this.getComponent(componentName);

    try {
      comp.el().querySelector('.video_title').innerHTML = options.extraData.title;
      comp.el().querySelector('.video_poster img').src = options.poster;
    } catch (e) {
      this.logger.log('PrevNextSuggest _updateComponent', e);
    }

    this.logger.log('PrevNextSuggest _updateComponent', options);
  }

  show(componentName) {
    this.getComponent(componentName).show();
  }

  hideSuggests() {
    this.hide('SuggestVideoNext');
    this.hide('SuggestVideoPrev');
  }

  hide(componentName) {
    var clearOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (clearOptions) {
      this.assets[componentName] = null;
    }

    this.getComponent(componentName).hide();
  }

  handleClick(componentName, event) {
    this.logger.log('PrevNextSuggest handleClick', componentName, event, this.assets);
    this.assets[componentName].playerOptions.autoplay = true;

    if (this.assets[componentName].playerOptions.loadMode !== 'lite') {
      this.assets[componentName].extraData.click_to_media_start = Date.now();
    } else {
      this.assets[componentName].extraData.first_byte_start = Date.now();
      this.assets[componentName].extraData.delay_start = Date.now();
    }

    playerWrapper.play(this.assets[componentName], this.assets[componentName].playerOptions.loadMode !== 'lite');
    PMWrap.inst().sendWrappedEvent(event, Tools$1.copy(this.assets[componentName]));
    eventsSrv.emit(event, Tools$1.copy(this.assets[componentName]));
    this.hideSuggests();
  }

  getComponent(componentName) {
    var comp = this.vjsPlayer.getChild(componentName);

    if (!comp) {
      comp = this.vjsPlayer.addChild(componentName);
    }

    return comp;
  }

}

var _PrevNextSuggestSrv = new PrevNextSuggest();

PrevNextSuggest.register = (componentName, options) => {
  options = options || {
    controlText: '',
    elClass: '',
    pmEvent: null
  };
  var event = options.pmEvent;
  var Component = videoJs.getComponent('Component');
  var suggestVideo = videoJs.extend(Component, {
    constructor: function constructor() {
      Component.apply(this, arguments);
      this.addClass('vjs-video-suggest');
      this.el_.innerHTML = '' + '<div class="video_title"></div>' + '<div class="video_poster"><img src=""></div>';
      this.on('click', () => {
        _PrevNextSuggestSrv.handleClick(componentName, event);
      });
      this.on('tap', () => {
        _PrevNextSuggestSrv.handleClick(componentName, event);
      });
      this.addClass(options.elClass);
      this.hide();
    }
  });
  videoJs.registerComponent(componentName, suggestVideo);
};

var PrevNextSuggestSrv = _PrevNextSuggestSrv;

class PrevNextButton {
  constructor() {
    this.vjsPlayer = null;
    vjsSrv.getPromise().then(vjsPlayer => {
      this.vjsPlayer = vjsPlayer;
    });
    this.options = {
      NextButton: {},
      PrevButton: {}
    };
    this.assets = {
      NextButton: {},
      PrevButton: {}
    };
  }

  handleClick(componentName) {
    if (this.assets[componentName]) {
      this.assets[componentName].playerOptions.autoplay = true;
      PrevNextSuggestSrv.hideSuggests();
      setTimeout(() => {
        playerWrapper.play(this.assets[componentName], this.assets[componentName].get('playerOptions.loadMode') !== 'lite');
        PMWrap$1.inst().sendWrappedEvent(this.options[componentName].pmEvent, Tools$1.copy(this.assets[componentName]));
        eventsSrv.emit(this.options[componentName].pmEvent, Tools$1.copy(this.assets[componentName]));
        this.disable(componentName);
      }, 100);
    }
  }

  isActive(componentName) {
    return !!this.assets[componentName] && !!this.assets[componentName].playerOptions;
  }

  show(componentName) {
    this.getComponent(componentName).show();
  }

  hide(componentName) {
    this.getComponent(componentName).hide();
  }

  disable(componentName) {
    this.assets[componentName] = null;
    this.getComponent(componentName).disable();
  }

  enable(componentName) {
    this.getComponent(componentName).enable();
  }

  setAsset(componentName, asset) {
    this.assets[componentName] = asset;

    this._updateComponent(componentName, asset);
  }

  _updateComponent(componentName, asset) {
    this.getComponent(componentName).controlText(asset.get('extraData.title'));
  }

  getComponent(componentName) {
    var comp = this.vjsPlayer.getChild('controlBar').getChild(componentName);

    if (!comp) {
      var isNext = componentName === 'NextButton';
      var controlBar = this.vjsPlayer.getChild('controlBar');
      var firstChild = controlBar.children_[0];
      var index = firstChild.name_ === 'PlayToggle' ? 1 : 2;
      comp = controlBar.addChild(componentName, {}, isNext ? index : 0);
    }

    return comp;
  }

}

var _PrevNextButtonSrv = new PrevNextButton();

PrevNextButton.register = function (componentName, options) {
  options = options || {
    elClass: 'vjs-play-next-btn',
    pmEvent: null
  };
  _PrevNextButtonSrv.options[componentName] = options;
  var Button = videoJs.getComponent('Button');
  var newButton = videoJs.extend(Button, {
    constructor: function constructor() {
      Button.apply(this, arguments);
      this.hide();
      this.disable();
      this.addClass(options.elClass);
      var iconHolder = this.el().querySelector('.vjs-icon-placeholder');

      if (config.get('params.style_schema') === 'lg-ais') {
        iconHolder.innerHTML = componentName === 'NextButton' ? 'Next episode <span class="icon-right"></span>' : '<span class="icon-left"></span> Prev episode';
      } else {
        iconHolder.classList.add(componentName === 'NextButton' ? 'icon-right-open' : "icon-left-open");
      }

      this.on(['click', 'tap'], () => {
        if (config.get('params.style_schema') !== 'lg-ais') {
          this.disable();
        }

        this.controlText('Loading...');

        _PrevNextButtonSrv.handleClick(componentName);
      });
    }
  });
  videoJs.registerComponent(componentName, newButton);
};

var PrevNextButtonSrv = _PrevNextButtonSrv;

class QualitySelector {
  constructor() {
    this.vjsPlayer = null;
    this.options = {
      default_auto: true
    };
    this.logger = Logger('QualitySelector');
    this.representations = [];
    this.menuItems = [];
    this.selectedIndex = 0;
    this.autoBitrateLabel = 'Auto';
    this.restrictQualityByUserScreen = this.options.restrictQualityByUserScreen || false;
    vjsSrv.getPromise().then(vjsPlayer => {
      if (config.get('params.controlBar.QualitySelectorButton')) {
        this.vjsPlayer = vjsPlayer;
        eventsSrv.on('videoBitrateChanged', (event, data) => {
          this.updateItemsState();
        });
        eventsSrv.on('app_representation_loads', (event, data) => {
          var _this$vjsPlayer$contr;

          if (this.restrictQualityByUserScreen) {
            this.representations = this.filterItemsForScreen(this.vjsPlayer.TechSrv.getRepresentations());
          } else {
            this.representations = this.vjsPlayer.TechSrv.getRepresentations();
          }

          if ((_this$vjsPlayer$contr = this.vjsPlayer.controlBar) !== null && _this$vjsPlayer$contr !== void 0 && _this$vjsPlayer$contr.QualitySelectorButton) {
            this.vjsPlayer.controlBar.QualitySelectorButton.update();
          }
        });
      }
    });
  }

  filterItemsForScreen(items) {
    var screenHeight = 'screen' in window ? screen.height * (window.devicePixelRatio || 1) : window.innerHeight;
    var screenWidth = 'screen' in window ? screen.width * (window.devicePixelRatio || 1) : window.innerWidth;
    this.logger.log('user screen resolution:', screenWidth, screenHeight, window.devicePixelRatio || 1);
    return items.filter(item => {
      if (item.height <= screenHeight && item.width <= screenWidth || item.height <= screenWidth && item.width <= screenHeight) {
        return true;
      } else {
        this.logger.log('dis bitrate:', item.height, item.width, item.bandwidth);
        item.enabled(false);
        return false;
      }
    });
  }

  getTitleForAutoB() {
    var activeBitrate = this.vjsPlayer.TechSrv.activeBitrate;
    var autoBitrateLabel = this.autoBitrateLabel;
    autoBitrateLabel = autoBitrateLabel + '(<span style="font-size: 0.9em;">' + (activeBitrate ? activeBitrate.height + 'p' : '') + '</span>)';
    return autoBitrateLabel;
  }

  updateAutoButton(button, title) {
    if (button) {
      button.controlText(title);
      button.el_.firstElementChild.innerHTML = title;
      button.options_.label = title;
    }
  }

  formatBitrateLabel(item) {
    var bitrate = (item.bandwidth / 1000).toFixed();
    return '<span class="advance-b-label">' + item.width + 'x' + item.height + ' - ' + bitrate + 'kbps</span>' + '<span class="short-b-label">' + (item.height || 0) + 'p' + '</span>';
  }

  updateItemsState() {
    this.menuItems.map(item => {
      if (this.selectedIndex === 0) {
        if (item.options_.index !== 0) {
          this.representations[item.options_.index - 1].enabled(true, true);
          item.selected(false);
        } else {
          item.selected(true);
        }
      } else {
        if (item.options_.index === 0) {
          item.selected(false);
          this.updateAutoButton(item, this.autoBitrateLabel);
        } else if (item.options_.index === this.selectedIndex) {
          item.selected(true);
          this.representations[item.options_.index - 1].isEnabled_ = false;
          this.representations[item.options_.index - 1].enabled(true);
        } else {
          item.selected(false);
          this.representations[item.options_.index - 1].enabled(false);
        }
      }
    });

    if (this.selectedIndex === 0) {
      this.updateAutoButton(this.menuItems[0], this.getTitleForAutoB());
    }
  }

}

var _QualitySelectorSrv = new QualitySelector();

QualitySelector.register = conf => {
  var MenuItem = videoJs.getComponent('MenuItem');
  var MenuItemButton = videoJs.extend(MenuItem, {
    constructor: function constructor() {
      MenuItem.apply(this, arguments);
    },
    handleClick: function handleClick() {
      QualitySelectorSrv.selectedIndex = this.options_.index;
      QualitySelectorSrv.updateItemsState();
    }
  });
  var MenuButton = videoJs.getComponent('MenuButton');
  var QualitySelectorButton = videoJs.extend(MenuButton, {
    constructor: function constructor() {
      MenuButton.apply(this, arguments);
      this.hide();
    },
    controlText: () => {
      return 'Quality change';
    },
    createItems: () => {
      var menuItems = [];
      var representations = _QualitySelectorSrv.representations;

      if (representations.length <= 1) {
        return menuItems;
      }

      for (var i = 0; i !== representations.length; i++) {
        var item = representations[i];
        item.enabled(true);
        var btn = new MenuItemButton(vjsSrv.vjsPlayer, {
          label: '',
          index: i + 1,
          bandwidth: item.bandwidth,
          selected: false,
          selectable: true
        });
        btn.el_.querySelector('.vjs-menu-item-text').innerHTML = QualitySelectorSrv.formatBitrateLabel(item);
        menuItems.push(btn);
      }

      menuItems = menuItems.reverse();

      if (representations.length >= 2) {
        var _btn = new MenuItemButton(vjsSrv.vjsPlayer, {
          label: '',
          index: 0,
          selected: true,
          selectable: true
        });

        _btn.el_.querySelector('.vjs-menu-item-text').innerHTML = QualitySelectorSrv.getTitleForAutoB();
        menuItems.unshift(_btn);
      }

      QualitySelectorSrv.menuItems = menuItems;
      return menuItems;
    },
    buildCSSClass: function buildCSSClass() {
      return MenuButton.prototype.buildCSSClass.call(this) + ' vjs-icon-cog';
    },
    update: function update() {
      return MenuButton.prototype.update.call(this);
    },
    createEl: () => {
      return videoJs.dom.createEl('div', {
        className: 'vjs-menu-button vjs-quality-menu vjs-menu-button-popup vjs-control vjs-button'
      });
    }
  });
  videoJs.registerComponent('QualityMenuItem', MenuItemButton);
  videoJs.registerComponent('QualitySelectorButton', QualitySelectorButton);
};

var QualitySelectorSrv = _QualitySelectorSrv;

class EmbeddedCode {
  constructor() {
    this.vjsPlayer = null;
    vjsSrv.getPromise().then(vjsPlayer => {
      this.vjsPlayer = vjsPlayer;
    });
  }

  getEmbedCode() {
    return `<iframe width="${config.get('EmbeddedCodeOpt.width')}" height="${config.get('EmbeddedCodeOpt.height')}" src="${PlayerSrv$1.getCurrentUrl(vimmiPI.getActiveAsset())}" allowfullscreen allow="autoplay" frameborder="0"></iframe>`;
  }

  copyToBuffer(input) {
    input.focus();
    input.select();
    document.execCommand('copy');
    document.execCommand('Copy', false, null);
  }

  toggle(isShow) {
    if (isShow) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    var _embBtn = this.vjsPlayer.getChild('controlBar').getChild('EmbeddedButton');

    if (_embBtn) {
      _embBtn.enable();

      _embBtn.show();
    }
  }

  hide() {
    var _embBtn = this.vjsPlayer.getChild('controlBar').getChild('EmbeddedButton');

    if (_embBtn) {
      _embBtn.disable();

      _embBtn.hide();
    }
  }

}

var _EmbeddedCodeSrv = new EmbeddedCode();

EmbeddedCode.register = () => {
  var Component = videoJs.getComponent('Component');
  var Button = videoJs.getComponent('Button');
  var EmbeddedButton = videoJs.extend(Button, {
    constructor: function constructor() {
      Button.apply(this, arguments);
      this.addClass('vjs-embedded-btn');
      this.controlText('Embed code');
    },
    handleClick: function handleClick(event) {
      var formComp = this.player().getChild('EmbedFormComponent');

      if (!formComp) {
        formComp = this.player().addChild('EmbedFormComponent');
      }

      formComp.getChild('InputComponent').el().value = _EmbeddedCodeSrv.getEmbedCode();

      if (formComp.hasClass('vjs-hidden')) {
        formComp.show();
        formComp.openTime = Date.now();

        if (event.type !== 'tap') {
          formComp.removeClass('aling-center');
          formComp.el().style.top = event.clientY - formComp.el().clientHeight + 'px';
          formComp.el().style.right = 'calc(' + (window.innerWidth - event.clientX) + 'px + 2em)';
        } else {
          formComp.addClass('aling-center');
        }
      } else {
        formComp.hide();
      }
    }
  });
  var InputComponent = videoJs.extend(Component, {
    constructor: function constructor() {
      Component.apply(this, arguments);
    },
    createEl: function createEl() {
      return videoJs.dom.createEl('input', {
        className: 'vjs-input-player-url'
      }, {
        readonly: true
      });
    }
  });
  var FormComponent = videoJs.extend(Component, {
    constructor: function constructor() {
      Component.apply(this, arguments);
      this.addClass('vjs-hidden');
      this.addClass('vjs-embedded-form');
      var input = this.addChild('InputComponent');
      this.addChild('Button');
      this.getChild('Button').controlText('Copy');
      this.getChild('Button').addClass('vjs-copy-embedded');
      this.getChild('Button').on(['click', 'tap'], event => {
        _EmbeddedCodeSrv.copyToBuffer(input.el());

        this.hide();
        Analytics.send('embed');
      });
      this.on('click', event => {
        this.openTime = Date.now();
      });
      this.player().on(['fullscreenchange', 'play', 'pause'], event => {
        this.hide();
      });
      this.player().on('timeupdate', event => {
        if (this.openTime && this.openTime + 3 * 1000 < Date.now()) {
          this.hide();
        }
      });
    }
  });
  videoJs.registerComponent('InputComponent', InputComponent);
  videoJs.registerComponent('EmbeddedButton', EmbeddedButton);
  videoJs.registerComponent('EmbedFormComponent', FormComponent);
};

var EmbeddedCodeSrv = _EmbeddedCodeSrv;

class CutVideo {
  constructor() {
    this.vjsPlayer = null;
    this.options = {
      start_time: 0,
      duration: 30,
      max_duration: 30,
      min_duration: 2
    };
    vjsSrv.getPromise().then(vjsPlayer => {
      this.vjsPlayer = vjsPlayer;
    });
  }

  enable(options) {
    this.options = Object.assign(this.options, options);
    this.options.disabled = false;
    this.vjsPlayer.addClass('cut-video-enabled');
    var button = this.getControlBar().getChild('CutVideoButton');

    if (!button) {
      this.getControlBar().addChild('CutStartTimeInput');
      this.getControlBar().addChild('CutEndTimeInput');
      button = this.getControlBar().addChild('CutVideoButton');
      this.getSeekBar().addClass('custom-seek-bar');
      this.getSeekBar().addChild('StartCutButton');
      this.getSeekBar().addChild('EndCutButton');
      this.vjsPlayer.on('timeupdate', () => {
        if (!this.options.disabled) {
          if (this.vjsPlayer.currentTime() > this.options.start_time + this.options.duration || this.vjsPlayer.currentTime() < this.options.start_time) {
            this.vjsPlayer.currentTime(this.options.start_time);
          }
        }
      });
    } else {
      button.enable();
      this.getStartButton().show();
      this.getEndButton().show();
      this.getStartButton().enable();
      this.getEndButton().enable();
      this.getEndTimeInput().show();
      this.getStartTimeInput().show();
    }
  }

  disable() {
    this.vjsPlayer.removeClass('cut-video-enabled');
    this.options.disabled = true;
    this.getStartButton().hide();
    this.getEndButton().hide();
    this.getStartButton().disable();
    this.getEndButton().disable();
    this.getEndTimeInput().hide();
    this.getStartTimeInput().hide();
    this.getControlBar().getChild('CutVideoButton').disable();
  }

  get(key) {
    return this.options[key] !== undefined ? this.options[key] : null;
  }

  set(key, value) {
    this.options[key] = value;
  }

  getControlBar() {
    return this.vjsPlayer.getChild('ControlBar');
  }

  getSeekBar() {
    return this.getControlBar().getChild('ProgressControl').getChild('SeekBar');
  }

  getEndButton() {
    return this.getSeekBar().getChild('EndCutButton');
  }

  getStartButton() {
    return this.getSeekBar().getChild('StartCutButton');
  }

  getStartTimeInput() {
    return this.getControlBar().getChild('CutStartTimeInput');
  }

  getEndTimeInput() {
    return this.getControlBar().getChild('CutEndTimeInput');
  }

  parseTimeString() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (string.length) {
      if (string.indexOf(':') !== -1) {
        var chanks = string.split(':');
        var hh = '00';
        var mm = 0;
        var ss = 0;

        if (chanks.length === 3) {
          hh = chanks[0];
          mm = chanks[1];
          ss = chanks[2];
        } else if (chanks.length === 2) {
          mm = chanks[0];
          ss = chanks[1];
        } else {
          return false;
        }

        if (hh.length > 2) {
          hh = hh.slice(0, 2);
        }

        if (mm.length > 2) {
          mm = mm.slice(0, 2);
        }

        if (ss.length > 2) {
          ss = ss.slice(0, 2);
        }

        if (!isNaN(parseInt(hh)) && !isNaN(parseInt(mm)) && !isNaN(parseInt(ss))) {
          hh = parseInt(hh) * 60 * 60;
          mm = parseInt(mm) * 60;
          ss = parseInt(ss);
          return hh + mm + ss;
        }

        return null;
      } else {
        return parseInt(string);
      }
    }

    return null;
  }

  formatSeconds(seconds) {
    seconds = parseInt(seconds);

    if (!isNaN(parseInt(seconds))) {
      var hh = Math.floor(seconds / 60 / 24);
      var mm = Math.floor((seconds - hh * 60 * 24) / 60);
      var ss = Math.floor(seconds - (hh * 60 * 24 + mm * 60));
      return (hh < 10 ? '0' + hh : hh) + ':' + (mm < 10 ? '0' + mm : mm) + ':' + (ss < 10 ? '0' + ss : ss);
    }

    return null;
  }

}

var _CutVideoSrv = new CutVideo();

CutVideo.register = () => {
  var Button = videoJs.getComponent('Button');
  var Component = videoJs.getComponent('Component');
  var ClickableComponent = videoJs.getComponent('ClickableComponent');
  var CutVideoButton = videoJs.extend(Button, {
    constructor: function constructor() {
      Button.apply(this, arguments);
      this.addClass('vjs-cut-video-btn');
      this.controlText('Cut selected part');
    },
    handleClick: function handleClick() {
      var SeekBar = this.player().getChild('controlBar').getChild('ProgressControl').getChild('SeekBar');
      var startBut = SeekBar.getChild('StartCutButton');
      var endBut = SeekBar.getChild('EndCutButton');
      var startTime = parseFloat(startBut._startTime.toFixed(2));
      var endTime = parseFloat(endBut._endTime.toFixed(2));
      var duration = parseFloat((endTime - startTime).toFixed(2));

      if (duration > _CutVideoSrv.get('max_duration') || duration < _CutVideoSrv.get('min_duration')) {
        startBut.addClass('incorrect-time');
        endBut.addClass('incorrect-time');
        setTimeout(() => {
          startBut.removeClass('incorrect-time');
          endBut.removeClass('incorrect-time');
        }, 2000);
        return;
      }

      var eventData = {
        start: startTime,
        end: endTime,
        duration: duration
      };
      eventsSrv.emit(PLAYER_EVENTS.CUT_VIDEO_DATA, eventData);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.CUT_VIDEO_DATA, eventData);
    }
  });
  var CutStartTimeInput = videoJs.extend(Component, {
    constructor: function constructor() {
      Component.apply(this, arguments);
    },
    setTime: function setTime(value) {
      this._input.value = _CutVideoSrv.formatSeconds(value) || '';
    },
    createEl: function createEl() {
      var wrapper = videoJs.dom.createEl('div', {
        className: 'vjs-control vjs-cut-video-input-time'
      }, {
        title: 'Please put here start time in format: HH:mm:ss or mm:ss or just seconds'
      });
      var input = videoJs.dom.createEl('input', {
        className: 'start-time-inp'
      }, {
        placeholder: 'Start time'
      });
      this._input = input;
      input.addEventListener('change', () => {
        this.player().currentTime(_CutVideoSrv.getStartButton()._startTime);
      });
      input.addEventListener('input', () => {
        var time = _CutVideoSrv.parseTimeString(input.value);

        if (time === null) {
          return;
        }

        var videoDuration = this.player().duration();

        if (time > videoDuration || time < 0) {
          this.addClass('incorrect-time');
        } else {
          this.removeClass('incorrect-time');
        }

        if (time < 0) {
          time = 0;
        } else if (time > this.player().duration() || time + _CutVideoSrv.get('min_duration') > this.player().duration()) {
          time = this.player().duration() - _CutVideoSrv.get('min_duration');

          _CutVideoSrv.set('duration', _CutVideoSrv.get('min_duration'));
        } else if (time + _CutVideoSrv.get('duration') > this.player().duration()) {
          _CutVideoSrv.set('duration', this.player().duration() - time);
        } else if (time + _CutVideoSrv.get('duration') < this.player().duration()) {
          _CutVideoSrv.set('duration', _CutVideoSrv.get('max_duration'));
        }

        _CutVideoSrv.getEndButton().moveToSec(time + _CutVideoSrv.get('duration'));

        _CutVideoSrv.getStartButton().moveToSec(time);

        _CutVideoSrv.getEndTimeInput().setTime(time + _CutVideoSrv.get('duration'));
      });
      wrapper.appendChild(input);
      return wrapper;
    }
  });
  var CutEndTimeInput = videoJs.extend(Component, {
    constructor: function constructor() {
      Component.apply(this, arguments);
    },
    setTime: function setTime(value) {
      this._input.value = _CutVideoSrv.formatSeconds(value) || '';
    },
    createEl: function createEl() {
      var wrapper = videoJs.dom.createEl('div', {
        className: 'vjs-control vjs-cut-video-input-time'
      }, {
        title: 'Please put here end time in format: HH:mm:ss or mm:ss or just seconds'
      });
      var input = videoJs.dom.createEl('input', {
        className: 'end-time-inp'
      }, {
        placeholder: 'End time'
      });
      this._input = input;
      input.addEventListener('change', () => {
        this.player().currentTime(_CutVideoSrv.getStartButton()._startTime);
      });
      input.addEventListener('input', () => {
        var time = _CutVideoSrv.parseTimeString(input.value);

        if (time === null) {
          return;
        }

        var videoDuration = this.player().duration();

        if (time > videoDuration || time < CutVideoSrv.get('min_duration')) {
          this.addClass('incorrect-time');
        } else {
          this.removeClass('incorrect-time');
        }

        if (time < _CutVideoSrv.get('min_duration')) {
          time = _CutVideoSrv.get('min_duration');

          _CutVideoSrv.set('duration', _CutVideoSrv.get('min_duration'));
        } else if (time < _CutVideoSrv.get('max_duration')) {
          _CutVideoSrv.set('duration', time);
        } else if (time > videoDuration) {
          time = videoDuration;
        } else if (time >= _CutVideoSrv.get('max_duration')) {
          _CutVideoSrv.set('duration', _CutVideoSrv.get('max_duration'));
        }

        _CutVideoSrv.getEndButton().moveToSec(time);

        _CutVideoSrv.getStartButton().moveToSec(time - _CutVideoSrv.get('duration'));

        _CutVideoSrv.getStartTimeInput().setTime(time - _CutVideoSrv.get('duration'));
      });
      wrapper.appendChild(input);
      return wrapper;
    }
  });
  var StartCutButton = videoJs.extend(ClickableComponent, {
    constructor: function constructor() {
      ClickableComponent.apply(this, arguments);
      this.addClass('vjs-start-cut-position');
      this.controlText('Start position');
      this.addChild('TimeTooltip');
      this.on('mousedown', this._mouseDown);
      window.addEventListener('mousemove', event => {
        this._mouseMove(event);
      });
      window.addEventListener('mouseup', event => {
        this._mouseUp(event);
      });
      this.player().one('timeupdate', () => {
        this.moveToSec(_CutVideoSrv.get('start_time'), true);
      });
      this._isMouseDown = false;
    },
    _mouseDown: function _mouseDown(event) {
      this._isMouseDown = true;
      event.stopPropagation();
    },
    _mouseUp: function _mouseUp(event) {
      if (this._isMouseDown) {
        this.player().userActive(true);
        this.player().currentTime(this._startTime);
        event.stopPropagation();
      }

      this._isMouseDown = false;
    },
    _mouseMove: function _mouseMove(event) {
      if (this._isMouseDown) {
        var seekBar = _CutVideoSrv.getSeekBar();

        var seekBarPoint = videoJs.dom.getPointerPosition(seekBar.el_, event).x;
        var newTime = seekBarPoint * this.player().duration();

        if (newTime + _CutVideoSrv.get('duration') < this.player().duration()) {
          this.moveToSec(newTime, true);

          _CutVideoSrv.getEndButton().moveToSec(this._startTime + _CutVideoSrv.get('duration'), true);
        }

        event.stopPropagation();
      }
    },
    moveToSec: function moveToSec(seconds, isSetInput) {
      var buttonRect = videoJs.dom.getBoundingClientRect(this.el_);
      var seekBarRect = videoJs.dom.getBoundingClientRect(_CutVideoSrv.getSeekBar().el());
      var seekBarNewPoint = seconds / this.player().duration();
      this.player().userActive(true);
      this._startTime = seconds;
      this.el().style.left = seekBarRect.width * seekBarNewPoint - buttonRect.width / 2 + 'px';

      this._updateToolTip(seekBarRect, seekBarNewPoint);

      if (isSetInput) {
        _CutVideoSrv.getStartTimeInput().setTime(seconds);
      }

      _CutVideoSrv.set('start_time', seconds);
    },
    _updateToolTip: function _updateToolTip(seekBarRect, seekBarPoint) {
      var duration = this.player().duration();
      this.getChild('TimeTooltip').update(seekBarRect, seekBarPoint, videoJs.formatTime(seekBarPoint * duration, duration));
    }
  });
  var EndCutButton = videoJs.extend(ClickableComponent, {
    constructor: function constructor() {
      ClickableComponent.apply(this, arguments);
      this.addClass('vjs-end-cut-position');
      this.controlText('End position');
      this.addChild('TimeTooltip');
      this.on('mousedown', this._mouseDown);
      window.addEventListener('mousemove', event => {
        this._mouseMove(event);
      });
      window.addEventListener('mouseup', event => {
        this._mouseUp(event);
      });
      this.player().one('timeupdate', () => {
        this.moveToSec(_CutVideoSrv.get('start_time') + _CutVideoSrv.get('duration'), true);
      });
      this._isMouseDown = false;
    },
    _mouseDown: function _mouseDown(event) {
      this._isMouseDown = true;
      event.stopPropagation();
    },
    _mouseUp: function _mouseUp(event) {
      if (this._isMouseDown) {
        this.player().userActive(true);
        this.player().pause();
        this.player().currentTime(this._endTime);
        event.stopPropagation();
      }

      this._isMouseDown = false;
    },
    _mouseMove: function _mouseMove(event) {
      if (this._isMouseDown) {
        var seekBar = _CutVideoSrv.getSeekBar();

        var seekBarPoint = videoJs.dom.getPointerPosition(seekBar.el(), event).x;
        var newTime = seekBarPoint * this.player().duration();

        if (newTime - _CutVideoSrv.getStartButton()._startTime >= _CutVideoSrv.get('min_duration')) {
          _CutVideoSrv.set('duration', newTime - _CutVideoSrv.getStartButton()._startTime);

          this.moveToSec(newTime, true);

          if (newTime - _CutVideoSrv.getStartButton()._startTime >= _CutVideoSrv.get('max_duration')) {
            _CutVideoSrv.getStartButton().moveToSec(newTime - _CutVideoSrv.get('max_duration'), true);
          }
        }

        event.stopPropagation();
      }
    },
    moveToSec: function moveToSec(seconds, isSetInput) {
      var buttonRect = videoJs.dom.getBoundingClientRect(this.el_);
      var seekBarRect = videoJs.dom.getBoundingClientRect(_CutVideoSrv.getSeekBar().el());
      var seekBarNewPoint = seconds / this.player().duration();
      this.player().userActive(true);
      this._endTime = seconds;
      this.el().style.left = seekBarRect.width * seekBarNewPoint - buttonRect.width / 2 + 'px';

      this._updateToolTip(seekBarRect, seekBarNewPoint);

      if (isSetInput) {
        _CutVideoSrv.getEndTimeInput().setTime(seconds);
      }
    },
    _updateToolTip: function _updateToolTip(seekBarRect, seekBarPoint) {
      var duration = this.player().duration();
      this.getChild('TimeTooltip').update(seekBarRect, seekBarPoint, videoJs.formatTime(seekBarPoint * duration, duration));
    }
  });
  videoJs.registerComponent('CutStartTimeInput', CutStartTimeInput);
  videoJs.registerComponent('CutEndTimeInput', CutEndTimeInput);
  videoJs.registerComponent('StartCutButton', StartCutButton);
  videoJs.registerComponent('EndCutButton', EndCutButton);
  videoJs.registerComponent('CutVideoButton', CutVideoButton);
};

var CutVideoSrv = _CutVideoSrv;

class Snapshot {
  constructor() {
    this.vjsPlayer = null;
    this._canvas = null;
    this._context = null;
    this.options = {};
    vjsSrv.getPromise().then(vjsPlayer => {
      this.vjsPlayer = vjsPlayer;
    });
  }

  getCanvas(width, height) {
    this._canvas = document.createElement('canvas');
    this._canvas.width = width;
    this._canvas.height = height;
    this._context = this._canvas.getContext('2d');
  }

  enable(options) {
    this.options = Object.assign(this.options, options);
    var button = this.vjsPlayer.controlBar.getChild('SnapshotButton');

    if (!button) {
      button = this.vjsPlayer.controlBar.addChild('SnapshotButton');
    }
  }

  disable(options) {}

  getImage() {
    vjsSrv.vjsPlayer.pause();
    var width = this.options.width || vjsSrv.vjsPlayer.tech_.el_.clientWidth;
    var height = this.options.height || vjsSrv.vjsPlayer.tech_.el_.clientHeight;
    this.getCanvas(width, height);

    this._context.drawImage(vjsSrv.vjsPlayer.tech_.el_, 0, 0, width, height);

    this._canvas.toBlob(blob => {
      eventsSrv.emit(PLAYER_EVENTS.SNAPSHOT_DATA, {
        blob: blob
      });
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.SNAPSHOT_DATA, {
        blob: blob
      }, {
        sendMethod: 'blob'
      });
    }, 'image/jpeg', 1);

    if (vjsSrv.vjsPlayer.isFullscreen()) {
      vjsSrv.vjsPlayer.exitFullscreen();
    }
  }

}

var _SnapshotSrv = new Snapshot();

Snapshot.register = () => {
  var Button = videoJs.getComponent('Button');
  var SnapshotButton = videoJs.extend(Button, {
    constructor: function constructor() {
      Button.apply(this, arguments);
      this.addClass('vjs-snapshot-btn');
      this.addClass('vjs-icon-spinner');
      this.controlText('Get snapshot');
    },
    handleClick: function handleClick() {
      SnapshotSrv.getImage();
    }
  });
  videoJs.registerComponent('SnapshotButton', SnapshotButton);
};

var SnapshotSrv = _SnapshotSrv;

function stringToArray(string) {
  var buffer = new ArrayBuffer(string.length * 2);
  var array = new Uint16Array(buffer);

  for (var i = 0, strLen = string.length; i < strLen; i++) {
    array[i] = string.charCodeAt(i);
  }

  return array;
}

function arrayToString(array) {
  var uint16array = new Uint16Array(array.buffer);
  return String.fromCharCode.apply(null, uint16array);
}

function base64DecodeUint8Array(input) {
  console.info('pallyCon.fairplay base64DecodeUint8Array 1', {
    input
  });
  var raw = window.atob(input);
  console.info('pallyCon.fairplay base64DecodeUint8Array 2', {
    raw
  });
  var rawLength = raw.length;
  console.info('pallyCon.fairplay base64DecodeUint8Array 3', {
    rawLength
  });
  var array = new Uint8Array(new ArrayBuffer(rawLength));
  console.info('pallyCon.fairplay base64DecodeUint8Array 4', {
    array
  });

  for (var i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }

  return array;
}

function base64EncodeUint8Array(input) {
  var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var output = "";
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;

  while (i < input.length) {
    chr1 = input[i++];
    chr2 = i < input.length ? input[i++] : Number.NaN;
    chr3 = i < input.length ? input[i++] : Number.NaN;
    enc1 = chr1 >> 2;
    enc2 = (chr1 & 3) << 4 | chr2 >> 4;
    enc3 = (chr2 & 15) << 2 | chr3 >> 6;
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
  }

  return output;
}

function waitForEvent(name, action, target) {
  target.addEventListener(name, function () {
    action(arguments[0]);
  }, false);
}

var pallyCon = {
  keySystem: null,
  certificate: null,
  player: null,
  contentUrl: null,
  contentId: null,
  licenseUrl: null,
  pallyconCustomData: null,
  fairplay: function fairplay(option) {
    if (option.player !== undefined) {
      pallyCon.player = option.player;
    }

    if (option.content_url !== undefined) {
      pallyCon.contentUrl = option.content_url;
    }

    if (option.pallycon_custom_data !== undefined) {
      pallyCon.pallyconCustomData = option.pallycon_custom_data;
    }

    if (option.license_url !== undefined) {
      pallyCon.licenseUrl = option.license_url;
    }

    var request = new XMLHttpRequest();
    request.responseType = 'text';
    request.addEventListener('load', pallyCon.onCertificateLoaded, false);
    request.addEventListener('error', pallyCon.onCertificateError, false);
    request.open('GET', option.certificate_uri, true);
    request.setRequestHeader('Pragma', 'Cache-Control: no-cache');
    request.setRequestHeader("Cache-Control", "max-age=0");
    request.send();
  },
  onCertificateLoaded: function onCertificateLoaded(event) {
    var request = event.target;
    console.info("pallyCon.fairplay request.response =>" + request.response);
    console.info("pallyCon.fairplay request.response length=>" + request.response.length);
    console.info("pallyCon.fairplay request.response type =>" + typeof request.response);
    pallyCon.certificate = base64DecodeUint8Array(request.response);
    pallyCon.player.src({
      'src': pallyCon.contentUrl
    });
    pallyCon.player.tech_.el_.addEventListener('webkitneedkey', pallyCon.onNeedKey, false);
    pallyCon.player.tech_.el_.addEventListener('error', pallyCon.onError, false);
  },
  onCertificateError: function onCertificateError(event) {
    window.console.error('pallyCon.fairplay Failed to retrieve the server certificate.');
  },
  extractContentId: function extractContentId(initData) {
    pallyCon.contentId = arrayToString(initData);
    console.info('pallyCon.fairplay initData before', {
      initData,
      contentId: pallyCon.contentId
    });
    pallyCon.contentId = pallyCon.contentId.substring(pallyCon.contentId.indexOf('skd://') + 6);
    console.info('pallyCon.fairplay initData after', {
      contentId: pallyCon.contentId
    });
    return pallyCon.contentId;
  },
  concatInitDataIdAndCertificate: function concatInitDataIdAndCertificate(initData, id, cert) {
    if (typeof id == "string") id = stringToArray(id);
    var offset = 0;
    var buffer = new ArrayBuffer(initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength);
    var dataView = new DataView(buffer);
    var initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
    initDataArray.set(initData);
    offset += initData.byteLength;
    dataView.setUint32(offset, id.byteLength, true);
    offset += 4;
    var idArray = new Uint16Array(buffer, offset, id.length);
    idArray.set(id);
    offset += idArray.byteLength;
    dataView.setUint32(offset, cert.byteLength, true);
    offset += 4;
    var certArray = new Uint8Array(buffer, offset, cert.byteLength);
    certArray.set(cert);
    return new Uint8Array(buffer, 0, buffer.byteLength);
  },
  selectKeySystem: function selectKeySystem() {
    if (WebKitMediaKeys.isTypeSupported("com.apple.fps.1_0", "video/mp4")) {
      pallyCon.keySystem = "com.apple.fps.1_0";
    } else {
      throw "Key System not supported";
    }
  },
  onError: function onError(event) {
    window.console.error('pallyCon.fairplay A video playback error occurred', event);
  },
  onNeedKey: function onNeedKey(event) {
    var video = event.target;
    var initData = event.initData;
    var contentId = pallyCon.extractContentId(initData);
    initData = pallyCon.concatInitDataIdAndCertificate(initData, contentId, pallyCon.certificate);

    if (!video.webkitKeys) {
      pallyCon.selectKeySystem();
      video.webkitSetMediaKeys(new WebKitMediaKeys(pallyCon.keySystem));
    }

    if (!video.webkitKeys) throw "Could not create MediaKeys";
    var keySession = video.webkitKeys.createSession("video/mp4", initData);
    if (!keySession) throw "Could not create key session";
    keySession.contentId = contentId;
    waitForEvent('webkitkeymessage', pallyCon.licenseRequestReady, keySession);
    waitForEvent('webkitkeyadded', pallyCon.onKeyAdded, keySession);
    waitForEvent('webkitkeyerror', pallyCon.onKeyError, keySession);
  },
  licenseRequestReady: function licenseRequestReady(event) {
    var session = event.target;
    var message = event.message;
    var request = new XMLHttpRequest();
    event.sessionId;
    request.responseType = 'text';
    request.session = session;
    request.addEventListener('load', pallyCon.licenseRequestLoaded, false);
    request.addEventListener('error', pallyCon.licenseRequestFailed, false);
    console.info("pallyCon.fairplays pc=" + base64EncodeUint8Array(message));
    var params = 'spc=' + base64EncodeUint8Array(message) + '&assetId=' + encodeURIComponent(session.contentId);
    request.open('POST', pallyCon.licenseUrl, true);
    request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    request.setRequestHeader("pallycon-customdata-v2", pallyCon.pallyconCustomData);
    console.info('pallyCon.fairplay licenseRequest ', {
      event,
      request,
      params,
      licenseUrl: pallyCon.licenseUrl
    });
    request.send(params);
  },
  licenseRequestLoaded: function licenseRequestLoaded(event) {
    var request = event.target;
    var session = request.session;
    var keyText = request.responseText.trim();
    keyText = base64DecodeUint8Array(keyText);
    session.update(keyText);
  },
  licenseRequestFailed: function licenseRequestFailed(event) {
    window.console.error('pallyCon.fairplay The license request failed.');
  },
  onKeyError: function onKeyError(event) {
    window.console.error('pallyCon.fairplay A decryption key error was encountered');
  },
  onKeyAdded: function onKeyAdded(event) {
    window.console.info('pallyCon.fairplay Decryption key was added to session.');
  }
};

class PlayerWrapper {
  constructor() {
    this.logger = Logger('PlayerWrapper');
    this.registerModuleListeners();
    QualitySelector.register(config.get('params.player_conf.quality_selector') || {});
    EmbeddedCode.register();
    Snapshot.register();
    CutVideo.register();
    PrevNextButton.register('NextButton', {
      controlText: 'Next',
      elClass: 'vjs-play-next-btn',
      pmEvent: PLAYER_EVENTS.PLAYING_NEXT
    });
    PrevNextButton.register('PrevButton', {
      controlText: 'Previous',
      elClass: 'vjs-play-prev-btn',
      pmEvent: PLAYER_EVENTS.PLAYING_PREV
    });
    PrevNextSuggest.register('SuggestVideoNext', {
      controlText: '',
      elClass: 'vjs-video-suggest-next',
      pmEvent: PLAYER_EVENTS.PLAYING_NEXT
    });
    PrevNextSuggest.register('SuggestVideoPrev', {
      controlText: '',
      elClass: 'vjs-video-suggest-prev',
      pmEvent: PLAYER_EVENTS.PLAYING_PREV
    });
  }

  create(options) {
    var langCode = PlayerSrv$1.getFormatLang(config.get('params.lang'));

    if (config.get('params.style_schema') === 'lg-ais') {
      videoJs.Vhs.GOAL_BUFFER_LENGTH = 1;
    } else {
      videoJs.Vhs.GOAL_BUFFER_LENGTH = 5;
      videoJs.Vhs.MAX_GOAL_BUFFER_LENGTH = 30;
    }

    return new Promise((resolve, reject) => {
      var langData = Languages$1.getLang(langCode);

      if (langData) {
        videoJs.addLanguage(langCode, langData);
      } else {
        langCode = 'en';
      }

      config.set('vjsOptions.language', langCode);
      PlayerSrv$1.addTag(options);
      vjsSrv.createPlayer(options).then(player => {
        resolve(player);
      });
    });
  }

  registerModuleListeners() {
    vimmiPI$1.on('playback_created', (event, createdPlaybackItem) => {
      this.logger.log('playback_created', JSON.stringify(createdPlaybackItem, null, '  '));
      vimmiPI$1.getActiveAsset().set('extraData.errorHandlerTimeoutId', null);
      vimmiPI$1.getActiveAsset().set('extraData.appliedPrefLang', false);
      this.setPlayerPlaybackItem(createdPlaybackItem, vimmiPI$1.getActiveAsset().get('playerOptions.autoplay'));
    }).on('playback_updated', (event, updatedPlaybackItem) => {
      this.logger.log('playback_updated', JSON.stringify(updatedPlaybackItem, null, '  '));
      vimmiPI$1.getActiveAsset().set('extraData.errorHandlerTimeoutId', null);
      vimmiPI$1.getActiveAsset().set('extraData.appliedPrefLang', false);
      this.setPlayerPlaybackItem(updatedPlaybackItem, vimmiPI$1.getActiveAsset().get('playerOptions.autoplay'));
    }).on('playback_error', (event, error) => {
      this.logger.log('playback_error', JSON.stringify(error, null, '  '));
      vimmiPI$1.getActiveAsset().set('extraData.errorHandlerTimeoutId', null);
      vjsSrv.vjsPlayer.internalError = error;
      vjsSrv.vjsPlayer.error({
        message: error.message,
        code: error.code > 5 ? 0 : error.code
      });
    }).on('concurrency_state', (event, state) => {
      if (Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
        Restriction.show(vimmiPI$1.getActiveAsset());
      } else {
        Restriction.hide();
      }

      this.logger.log('concurrency_state', state);
    });
  }
  /**
   * @method preloadNewVideo
   * @param options
   * @description The method pre-loads new video, it means - reset player, handle restriction, set new poster
   */


  applyStartPosition() {
    if (Preview.isShowPreview(vimmiPI$1.getActiveAsset()) && !Preview.activated()) {
      Preview.activated(true);
      var previewInfo = vimmiPI$1.getActiveAsset().get('preview_info');
      vimmiPI$1.getActiveAsset().set('playerOptions.startPosition', null);
      vjsSrv.vjsPlayer.currentTime(previewInfo.preview_start);
    } else if (vimmiPI$1.getActiveAsset().get('playerOptions.startPosition') && vjsSrv.vjsPlayer.duration() - vimmiPI$1.getActiveAsset().get('playerOptions.startPosition') > 1 && (config.get('eventsState.loadeddata') || config.get('eventsState.loadedmetadata'))) {
      vjsSrv.vjsPlayer.currentTime(vimmiPI$1.getActiveAsset().get('playerOptions.startPosition'));

      if (config.get('debug')) {
        this.logger.log('moved to position:', vimmiPI$1.getActiveAsset().get('playerOptions.startPosition'));
      }

      vimmiPI$1.getActiveAsset().set('playerOptions.startPosition', null);
    }
  }
  /**
   * @param asset {Object} the video asset  //todo:
   *
   * */


  play(asset) {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isFullAsset;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isFullAsset = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
              config.set('eventsState.changeSource', true);

              _this.logger.log('@playVideo', JSON.stringify(asset, null, '  '), isFullAsset);

              if (vimmiPI$1.getActiveAsset() && !config.get('eventsState.ended') && !config.get('eventsState.error') && config.get('eventsState.isStartPlay') && !Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
                Analytics.send('chu', {}, {
                  force: true,
                  asset: vimmiPI$1.getActiveAsset()
                });
                Analytics.send('stop', {
                  stop_cause: 'switch'
                }, {
                  asset: vimmiPI$1.getActiveAsset()
                });
              }

              Restriction.reset();
              vjsSrv.vjsPlayer.removeClass('fit-content-fill');

              if (vjsSrv.vjsPlayer.error()) {
                vjsSrv.vjsPlayer.error(null);
              }

              if (!vjsSrv.vjsPlayer.currentSrc()) {
                _context.next = 13;
                break;
              }

              config.set('params.muted', vjsSrv.vjsPlayer.muted());
              _context.next = 11;
              return vjsSrv.resetPlayer();

            case 11:
              _context.next = 14;
              break;

            case 13:
              config.get('params.muted', false);

            case 14:
              vjsSrv.vjsPlayer.ready(() => {
                if (Restriction.isRestricted(asset)) {
                  config.set('eventsState', {
                    isStartPlay: false,
                    isCallPlay: config.get('eventsState.isCallPlay'),
                    prevUserActiveState: false,
                    loadstart: false,
                    waiting: false,
                    loadedmetadata: false,
                    loadeddata: false,
                    playing: false,
                    ended: false,
                    error: false
                  });
                  vjsSrv.vjsPlayer.removeClass('pre-loading');
                  vjsSrv.vjsPlayer.reset();
                  PostersManager.setCurrentPoster(asset);

                  if (config.get('debug')) {
                    _this.logger.log('video restricted, skipped playing', asset);
                  }

                  Restriction.show(asset);
                  return;
                } else {
                  Restriction.hide(asset);
                  PostersManager.setCurrentPoster(asset);
                }

                vjsSrv.vjsPlayer.addClass('custom-waiting-video');

                if (vimmiPI$1.getActiveAsset()) {
                  PlayerSrv$1.prevAsset = vimmiPI$1.getActiveAsset();
                }

                asset.extraData.first_byte_start = Date.now();

                if (isFullAsset) {
                  asset.metadataLang = PlayerSrv$1.prevAsset ? PlayerSrv$1.prevAsset.get('metadataLang') : config.get('params.portal.preferred_audio_lang') || null;
                  asset.set('extraData.delay_start', Date.now());
                  vimmiPI$1.applyAsset(asset);

                  _this.preparePlayer(asset);
                } else {
                  asset.metadataLang = config.get('params.portal.preferred_audio_lang') || null;
                  asset.extraData.click_to_media_start = asset.extraData.click_to_media_start || Date.now();
                  var method = 'getByMediaId';

                  if (asset.mediaStream) {
                    method = 'getByMediaStream';
                  } else if (asset.playback_url) {
                    method = asset.playback_url.indexOf('/metadata.') !== -1 ? 'getByMetadataUrl' : 'getByPlaybackUrl';
                  } else if (asset.alphaId && !asset.drm) {
                    method = 'getByMetadataUrl';
                  }

                  _this.logger.log(`vimmiPI.${method} before`, asset);

                  vimmiPI$1[method](asset, true, !!!asset.preview).then(fullAsset => {
                    if (fullAsset) {
                      fullAsset.set('extraData.delay_start', Date.now());
                      fullAsset.set('extraData.click_to_media_end', Date.now());

                      _this.logger.log(`vimmiPI.${method} after`, fullAsset);

                      if (config.get('debug')) {
                        console.info('debug_link - ', PlayerSrv$1.getCurrentUrl(fullAsset));
                      }

                      _this.preparePlayer(fullAsset);
                    }
                  }).catch(error => {
                    console.error(error);

                    if (config.get('debug')) {
                      _this.logger.warn('getByMediaId, error', error);
                    }

                    if (vjsSrv.vjsPlayer.currentSrc()) {
                      config.set('params.muted', vjsSrv.vjsPlayer.muted());
                      vjsSrv.resetPlayer();
                    } else {
                      config.get('params.muted', false);
                    }

                    setTimeout(() => {
                      error.finalError = true;
                      vjsSrv.vjsPlayer.internalError = error;
                      vjsSrv.vjsPlayer.error({
                        message: error.name || error.message,
                        code: error.code > 5 ? 0 : error.code
                      });
                      vjsSrv.vjsPlayer.errorDisplay.show();
                    });
                  });
                }
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }

  setPlayerPlaybackItem(playbackItem) {
    var _arguments2 = arguments,
        _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var autoplay, asset, videoJsSource, origFN;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              autoplay = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : true;
              asset = vimmiPI$1.getActiveAsset();

              if (asset.get('extraData.saveState')) {
                asset.set('extraData.missedBytes', asset.get('extraData.missedBytes', 0) + asset.get('extraData.bytes', 0));
              }

              videoJsSource = PlayerSrv$1.getVideoJsSrc(playbackItem, vimmiPI$1.getActiveAsset());

              if (playbackItem.drm && asset.origin === 'anevia' && playbackItem.drm.type === 'HLS/FAIRPLAY') {
                origFN = pallyCon.onCertificateLoaded;

                pallyCon.onCertificateLoaded = function (event) {
                  origFN(event);
                  vjsSrv.get().load();
                };

                pallyCon.fairplay({
                  license_url: videoJsSource.keySystems[config.get('keySystems')[playbackItem.drm.type]].licenseUri,
                  player: vjsSrv.vjsPlayer,
                  pallycon_custom_data: playbackItem.drm.token,
                  certificate_uri: videoJsSource.keySystems[config.get('keySystems')[playbackItem.drm.type]].certificateUri,
                  content_url: videoJsSource.src
                });

                if (config.get('debug')) {
                  _this2.logger.log('sets source for anevia', videoJsSource);
                }
              } else {
                if (videoJsSource.srcObject) {
                  vjsSrv.vjsPlayer.src('/assets/blank.mp4');
                  vjsSrv.vjsPlayer.tech(true).el().srcObject = videoJsSource.srcObject;
                } else {
                  vjsSrv.vjsPlayer.src(videoJsSource);
                }

                if (config.get('debug')) {
                  _this2.logger.log('sets source', videoJsSource);
                }

                vjsSrv.vjsPlayer.load();
              }

              if (config.get('params.muted')) {
                vjsSrv.vjsPlayer.muted(true);
              }

              if (autoplay || asset.get('extraData.saveState')) {
                vjsSrv.tryPlay();
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
  /**
   * @method preparePlayer
   * @param {Object} asset - media asset
   * @description make preparation to start play new video
   * */


  preparePlayer(asset) {
    if (asset.isLive) {
      vjsSrv.vjsPlayer.addClass('vjs-v-live');
    } else {
      vjsSrv.vjsPlayer.removeClass('vjs-v-live');
    }

    config.set('eventsState', {
      isStartPlay: false,
      isCallPlay: config.get('eventsState.isCallPlay'),
      prevUserActiveState: false,
      loadstart: false,
      waiting: false,
      loadedmetadata: false,
      loadeddata: false,
      playing: false,
      ended: false,
      error: false
    });
    vjsSrv.vjsPlayer.internalError = null;
    vjsSrv.vjsPlayer.removeClass('pre-loading');
    Analytics.beforePlay(asset);

    if (config.get('params.controls')) {
      vjsSrv.controls(true);
    }

    if (asset.preview) {
      Preview.show(asset);
    } else {
      Preview.hide();
    }

    vjsSrv.vjsPlayer.removeClass('empty-player');
    vjsSrv.vjsPlayer.removeClass('vjs-error');

    if (asset.playerOptions.controls) {
      vjsSrv.controls(true);
    } else if (asset.playerOptions.controls === false) {
      vjsSrv.controls(false);
    }

    if (asset.playerOptions.mainPage) {
      vjsSrv.vjsPlayer.addClass('vjs-main-player');
    } else {
      vjsSrv.vjsPlayer.removeClass('vjs-main-player');
    }

    if (!asset.playerOptions.bigButton && asset.playerOptions.bigButton !== undefined) {
      vjsSrv.vjsPlayer.bigPlayBtn.hide();
    } else {
      vjsSrv.vjsPlayer.bigPlayBtn.show();
    }

    if (vjsSrv.vjsPlayer.controlBar.NextButton) {
      vjsSrv.vjsPlayer.controlBar.NextButton.disable();
    }

    if (vjsSrv.vjsPlayer.controlBar.PrevButton) {
      vjsSrv.vjsPlayer.controlBar.PrevButton.disable();
    }

    EmbeddedCodeSrv.toggle(asset.playerOptions.showEmbedded);

    if (config.get('params.analytics.cm')) {
      if (asset.extraData.iid) {
        this.logger.info('set media id for cm', asset.extraData.iid);
        vjsSrv.vjsPlayer.tech_.el_.setAttribute('data-mediaid', asset.extraData.iid);
      } else {
        if (config.get('debug')) {
          this.logger.warn('iid field isn\'t defined for current video', asset);
        }
      }
    }
  }

}

var playerWrapper = new PlayerWrapper();

var Button$1 = videoJs.getComponent('Button');
var ForwardButton = videoJs.extend(Button$1, {
  constructor: function constructor() {
    Button$1.apply(this, arguments);
    this.addClass("forward-btn");
    this.controlText('Rewind forward');
    this.el().querySelector('.vjs-icon-placeholder').classList.add("icon-fast-forward");
    this.on(['click', 'tap'], () => {
      vjsSrv.vjsPlayer.currentTime(vjsSrv.vjsPlayer.currentTime() + 10);
    });
  },
  update: function update() {
    Button$1.prototype.update.call(this);
  }
});
var BackButton = videoJs.extend(Button$1, {
  constructor: function constructor() {
    Button$1.apply(this, arguments);
    this.addClass("back-btn");
    this.controlText('Rewind back');
    this.el().querySelector('.vjs-icon-placeholder').classList.add("icon-fast-backward");
    this.on(['click', 'tap'], () => {
      vjsSrv.vjsPlayer.currentTime(vjsSrv.vjsPlayer.currentTime() - 10);
    });
  },
  update: function update() {
    Button$1.prototype.update.call(this);
  }
});
videoJs.registerComponent('RewindBackButton', BackButton);
videoJs.registerComponent('RewindForwardButton', ForwardButton);

class AudioTracksService {
  constructor() {
    this.logger = Logger('AudioTracksService');
    this.vjsPlayer = null;
    this.options = {};
    vjsSrv.getPromise().then(vjsPlayer => {
      this.vjsPlayer = vjsPlayer;
    });
  }
  /**
   *
   * @param newTrack{String} - 'tha', 'eng'
   * @param trackType{String} normal|custom
   * */


  changeTrack(newTrack) {
    var trackType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

    if (trackType === 'default') {
      var trackList = vjsSrv.vjsPlayer.audioTracks();
      this.logger.log('[changeTrack]', trackType, {
        newTrack,
        trackList
      });
      var desiredTrack = trackList.tracks_.find(track => track.id === newTrack);
      desiredTrack.enabled = true;
    } else if (trackType === 'custom') {
      if (!vimmiPI$1.isApplicableMetadataLang(vimmiPI$1.getActiveAsset())) {
        return;
      }

      var cur_audio_lang = (vimmiPI$1.getActiveAsset().get('metadataLang') || '').toLowerCase();

      if (newTrack === cur_audio_lang) {
        return;
      }

      this.logger.log('[changeTrack]', trackType, {
        newTrack,
        trackList: vimmiPI$1.getActiveAsset().get('item.m_audio'),
        cur_audio_lang
      });

      if (!vimmiPI$1.getActiveAsset().get('isLive')) {
        vimmiPI$1.getActiveAsset().set('playerOptions.startPosition', this.vjsPlayer.currentTime());
      }

      vimmiPI$1.getActiveAsset().set('extraData.saveState', true);
      var cur_media_session_id = vimmiPI$1.getActiveAsset().get('media_session_id');
      this.vjsPlayer.addClass('custom-waiting-video');
      vimmiPI$1.applyNewMetadataLang(newTrack.toLowerCase()).then(result => {
        Analytics.send('media_audio_switch', {
          media_session_id: (config.get(`params.portal.user_id`) || config.get(`params.portal.temp_user_id`) || 'unknown') + '_' + cur_media_session_id,
          cur_audio_lang: cur_audio_lang,
          tar_audio_lang: newTrack.toLowerCase()
        });
        this.vjsPlayer.hasStarted(true);
      }).catch(error => {
        this.logger.log.warn('[changeTrack][applyNewMetadataLang]', error);
      });
    } else {
      this.logger.log.warn('[changeTrack]', 'unknown error');
    }
  }

  enableCustomButton() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = Object.assign({}, this.options, options || {});
    var customTracks = vimmiPI$1.getActiveAsset().get('item.m_audio');

    if (customTracks.length > 1) {
      var customTracksButton = this.vjsPlayer.getChild('ControlBar').getChild('CustomAudioTrackButton');

      if (customTracksButton) {
        customTracksButton.show();
        customTracksButton.update();
      }
    }
  }

  disableCustomButton() {
    var customTracksButton = this.vjsPlayer.getChild('ControlBar').getChild('CustomAudioTrackButton');

    if (customTracksButton) {
      customTracksButton.hide();
    }
  }

}
var AudioTracksSrv = new AudioTracksService();

var Button = videoJs.getComponent('Button');
var TVSettingsButton = videoJs.extend(Button, {
  constructor: function constructor() {
    Button.apply(this, arguments);
    this.el().querySelector('.vjs-icon-placeholder').innerHTML = '<span class="icon-cog"></span>';
    this.el().classList.add("tv-settings-button");
    this.player().addChild('TVSettingsPanel');
    this.on(['click', 'tap'], event => {
      this.player().getChild('controlBar').hide();
      this.player().getChild('TVSettingsPanel').show();
      this.player().getChild('TVSettingsPanel').update();
      this.player().getChild('TVSettingsPanel').focus();
    });
  }
});
var Component = videoJs.getComponent('Component');
var TVSettingsPanel = videoJs.extend(Component, {
  constructor: function constructor() {
    this._target = 'tv-settings-popup';
    Component.apply(this, arguments);
    this.addClass("tv-settings-popup");
    this.addClass("rem-popup");
    this.createElements();
    this.hide();

    this.el().onClose = () => {
      this.hide();
      this.player().getChild('controlBar').show();
    };
  },
  createElements: function createElements() {
    var target = this._target;
    this.el().innerHTML = `<div class="tv-setting-tabs ">
                <button type="button" data-target="tv-setting-tabs-content-info" data-parent="${target}" class="tv-tab remote-ctrl vjs-hidden rem-active">Description</button>
                <button type="button" data-target="tv-setting-tabs-content-lang" data-parent="${target}" class="tv-tab remote-ctrl vjs-hidden">Languages</button>
            </div>
            <div class="tv-setting-tabs-content">
                <div class="tv-tab-content tv-setting-tabs-content-info">
                    <div class="tv-tc-poster">
                        <img alt="" src=""/>
                    </div>
                    <div class="tv-tc-info">
                        <div class="tv-tc-title"></div>
                        <div class="tv-tc-description"></div>
                    </div>
            
                </div>
                <div class="tv-tab-content tv-setting-tabs-content-lang vjs-hidden">
                
                </div>
            </div>`;
    var tabs = this.el().querySelectorAll('.tv-tab');
    var tabsContent = this.el().querySelectorAll('.tv-setting-tabs-content .tv-tab-content');

    if (tabs && tabs.length) {
      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];

        tab.handleFocus = activeTab => {
          for (var j = 0; j < tabsContent.length; j++) {
            var tabContent = tabsContent[j];

            if (tabContent.classList.contains(activeTab.dataset.target)) {
              tabContent.classList.remove('vjs-hidden');
            } else {
              tabContent.classList.add('vjs-hidden');
            }
          }
        };
      }
    }
  },
  show: function show(event) {
    Component.prototype.show.call(this, event);
    var controls = this.el().querySelectorAll('.remote-ctrl');

    for (var i = 0; i < controls.length; i++) {
      controls[i].classList.remove('vjs-hidden');
    }
  },
  hide: function hide(event) {
    Component.prototype.hide.call(this, event);
    var controls = this.el().querySelectorAll('.remote-ctrl');

    for (var i = 0; i < controls.length; i++) {
      controls[i].classList.add('vjs-hidden');
    }
  },
  update: function update() {
    var component = this;
    var target = this._target;
    var tabContentInfo = this.el().querySelector('.tv-setting-tabs-content-info');
    var posterEl = tabContentInfo.querySelector('.tv-tc-poster img');
    var titleEl = tabContentInfo.querySelector('.tv-tc-title');
    var descriptionEl = tabContentInfo.querySelector('.tv-tc-description');
    var languagesBlock = this.el().querySelector('.tv-setting-tabs-content-lang');

    if (posterEl) {
      if (posterEl.src !== vimmiPI$1.getActiveAsset().get('extraData.poster') || !vimmiPI$1.getActiveAsset().get('extraData.poster')) {
        posterEl.src = vimmiPI$1.getActiveAsset().get('extraData.poster');
      }
    }

    if (titleEl) {
      titleEl.innerHTML = vimmiPI$1.getActiveAsset().get('extraData.title');
    }

    if (descriptionEl) {
      descriptionEl.innerHTML = vimmiPI$1.getActiveAsset().get('extraData.description');
    }

    if (languagesBlock) {
      languagesBlock.innerHTML = '';

      if (vimmiPI$1.isApplicableMetadataLang(vimmiPI$1.getActiveAsset())) {
        var customTracks = vimmiPI$1.getActiveAsset().get('item.m_audio');

        if (customTracks.length <= 1) {
          setTimeout(() => {
            this.el().querySelector('.tv-setting-tabs-content-lang').classList.add('vjs-hidden');
          });
        } else {
          customTracks.map(customTrack => {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.dataset.parent = target;
            btn.dataset.lang = customTrack;
            btn.classList.add('remote-ctrl');

            if (customTrack === vimmiPI$1.getActiveAsset().get('metadataLang')) {
              btn.classList.add('tv-btn-active');
            }

            btn.innerHTML = customTrack;

            btn.onclick = function () {
              AudioTracksSrv.changeTrack(customTrack, 'custom');
              component.el().onClose();
            };

            languagesBlock.appendChild(btn);
          });
        }
      } else {
        var audioTracks = Array.prototype.slice.call(this.player().audioTracks(), 0);

        if (audioTracks.length <= 1) {
          setTimeout(() => {
            this.el().querySelector('.tv-setting-tabs-content-lang').classList.add('vjs-hidden');
          });
        } else {
          audioTracks.map(audioTrack => {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.dataset.parent = target;
            btn.dataset.lang = audioTrack.language;
            btn.classList.add('remote-ctrl');

            if (audioTrack.enabled) {
              btn.classList.add('tv-btn-active');
            }

            btn.innerHTML = audioTrack.label || audioTrack.language;

            btn.onclick = function () {
              AudioTracksSrv.changeTrack(audioTrack.language, 'default');
              component.el().onClose();
            };

            languagesBlock.appendChild(btn);
          });
        }
      }
    }
  }
});
/**
 * @param {Array<string>} langs
 */

videoJs.registerComponent('TVSettingsButton', TVSettingsButton);
videoJs.registerComponent("TVSettingsPanel", TVSettingsPanel);

var MenuItem = videoJs.getComponent('MenuItem');
var CustomAudioTrackMenuItem = videoJs.extend(MenuItem, {
  constructor: function constructor(player, options) {
    MenuItem.apply(this, arguments);
    this.track = options.track;
  },
  handleClick: function handleClick(event) {
    MenuItem.prototype.handleClick.call(this, event);
    var items = this.player().getChild('ControlBar').getChild('CustomAudioTrackButton').items;
    items.map(item => {
      item.selected(item.track === this.track);
    });
    var cur_audio_lang = (vimmiPI$1.getActiveAsset().get('metadataLang') || '').toLowerCase();

    if (cur_audio_lang !== this.track) {
      AudioTracksSrv.changeTrack(this.track, 'custom');
    }
  }
});
var MenuButton = videoJs.getComponent('MenuButton');
var CustomAudioTrackButton = videoJs.extend(MenuButton, {
  constructor: function constructor() {
    MenuButton.apply(this, arguments);
    this.addClass('vjs-audio-button');
    this.addClass('custom-track');
    this.hide();
  },
  createItems: function createItems(items) {
    if (items === void 0) {
      items = [];
    }

    if (vimmiPI$1.getActiveAsset()) {
      var tracks = vimmiPI$1.getActiveAsset().get('item.m_audio');

      for (var i = 0; i < tracks.length; i++) {
        items.push(new CustomAudioTrackMenuItem(this.player_, {
          track: tracks[i],
          label: tracks[i],
          selected: vimmiPI$1.getActiveAsset().get('metadataLang') === tracks[i],
          selectable: true,
          multiSelectable: false
        }));
      }
    }

    return items;
  }
});
videoJs.registerComponent('CustomAudioTrackMenuItem', CustomAudioTrackMenuItem);
videoJs.registerComponent('CustomAudioTrackButton', CustomAudioTrackButton);

var BigPlayButton = videoJs.getComponent('BigPlayButton');
var BigPlayBtn = videoJs.extend(BigPlayButton, {
  constructor: function constructor() {
    BigPlayButton.apply(this, arguments);
  },
  handleClick: function handleClick(event) {
    BigPlayButton.prototype.handleClick.call(this, event);
  }
});
videoJs.registerComponent('BigPlayBtn', BigPlayBtn);

var appLogger = Logger('App');
class VimmiPlayer {
  on(eventName, handler) {
    return eventsSrv.on(eventName, handler);
  }

  off(eventName, handler) {
    return eventsSrv.off(eventName, handler);
  }

  /**
   * @param tagId {string}  video tag id on the page
   * @param options {Object} player initial options
   * @param options.account {String} customer account
   * @param options.qualityChange {Boolean} @deprecated - use "controlBar" instead. show or hide quality selector
   * @param options.fullScreen {Boolean} @deprecated - use "controlBar" instead. show or hide fullScreen toggle button
   * @param options.showEmbedded {Boolean} @deprecated - use "controlBar" instead. show or hide showEmbedded toggle button
   * @param options.mute {Boolean} @deprecated - use "muted" instead. mute unmute initial play
   * @param options.muted {Boolean} mute or unmute initial play, default unmuted
   * @param options.debug {Boolean} enable/disable debug mode
   * @param options.lang {String} player ui lang
   * @param options.dash {Object} dashJs options
   * @param options.useTag {Element} video tag, will used instead creating new one
   * @param options.initEmpty {Boolean} init player as empty
   * @param options.controls {Boolean} init player with controls
   * @param options.hotkeys {Boolean} enable hotkey supports
   * @param options.controlBar {Object} json to configure player control bar
   * @param options.plugins {Object} json to configure player plugins
   * for AIS
   * @param options.sl {Boolean} use second location, need only for AIS
   * */
  constructor(tagId) {
    var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _defineProperty(this, "logger", appLogger);

    _defineProperty(this, "autoplayState", autoplayState);

    _defineProperty(this, "vimmiPI", vimmiPI$1);

    _defineProperty(this, "controls", {
      play() {
        appLogger.log('@play', config.get('eventsState'));
        vjsSrv.tryPlay();
      },

      stop() {
        vjsSrv.resetPlayer();
        vjsSrv.vjsPlayer.reset();
      },

      pause() {
        appLogger.log('@pause', config.get('eventsState'));

        if (config.get('eventsState.isCallPlay')) {
          vjsSrv.vjsPlayer.pause();
        }
      },

      mute() {
        if (vjsSrv.vjsPlayer.muted()) {
          config.get('params.muted', false);
          vjsSrv.vjsPlayer.muted(false);
        } else {
          config.get('params.muted', true);
          vjsSrv.vjsPlayer.muted(true);
        }
      },

      /**
       * @method controlsState to manipulate cotrols of player (hide/show/change)
       * @param event {Object} event
       * @param event.name {String} name of action
       * @param event.data {Object} configs the config object
       * */
      controlsState(event) {
        var options = event && event.data ? event.data : {};

        switch (event.name) {
          case 'disableControls':
            vjsSrv.controls(false);
            vjsSrv.vjsPlayer.bigPlayBtn.hide();
            break;

          case 'enableControls':
            vjsSrv.controls(true);
            vjsSrv.vjsPlayer.bigPlayBtn.show();
            break;

          case 'enablePrev':
            PrevNextButtonSrv.enable('PrevButton');
            break;

          case 'disablePrev':
            PrevNextButtonSrv.disable('PrevButton');
            break;

          case 'showPrev':
            PrevNextButtonSrv.show('PrevButton');
            break;

          case 'hidePrev':
            PrevNextButtonSrv.disable('PrevButton');
            PrevNextButtonSrv.hide('PrevButton');
            break;

          case 'loadPrev':
          case 'loadNext':
            var internalAsset = PlayerSrv$1.transformToAsset(Object.assign({}, config.get('params'), options));
            var button = 'NextButton';

            if (event.name === 'loadPrev') {
              button = 'PrevButton';
            }

            internalAsset.extraData.click_to_media_start = internalAsset.extraData.click_to_media_start || Date.now();

            if (vimmiPI$1.getActiveAsset() && vimmiPI$1.getActiveAsset().get('metadataLang')) {
              internalAsset.metadataLang = vimmiPI$1.getActiveAsset().get('metadataLang');
            }

            vimmiPI$1.getByMediaId(internalAsset, false).then(asset => {
              asset.set('extraData.click_to_media_end', Date.now());
              PrevNextButtonSrv.setAsset(button, asset);
              PrevNextButtonSrv.enable(button);
              PrevNextButtonSrv.show(button);
            }).catch(error => {
              console.log(error);
            });
            break;

          case 'enableNext':
            PrevNextButtonSrv.enable('NextButton');
            break;

          case 'disableNext':
            PrevNextButtonSrv.disable('NextButton');
            break;

          case 'showNext':
            PrevNextButtonSrv.show('NextButton');
            break;

          case 'hideNext':
            PrevNextButtonSrv.disable('NextButton');
            PrevNextButtonSrv.hide('NextButton');
            break;
        }
      },

      /**
       * @method cutAPI to enable/disable cutting api
       * @param event {Object} event
       * @param event.type {'disable'|'enable'} type of action
       * @param event.data {Object}  the config object
       * @param event.data.start_time {Number} start time of selector
       * @param event.data.duration {Number} initial duration
       * @param event.data.max_duration {Number} max duration
       * @param event.data.min_duration {Number} mix duration
       * */
      cutAPI(event) {
        appLogger.log('@cutAPI', event);

        if (event && event.type && event.data) {
          if (event.type === 'enable') {
            CutVideoSrv.enable(event.data);
          } else if (event.type === 'disable') {
            CutVideoSrv.disable(event.data);
          }
        }
      },

      /**
       * @method cutAPI to enable/disable cutting api
       * @param event {Object} event
       * @param event.type {'disable'|'enable'} type of action
       * @param event.data {Object}  the config object
       * @param event.data.width {number} width of snapshot frame
       * @param event.data.height {number} height of snapshot frame
       * */
      snapshotAPI(event) {
        appLogger.log('@snapshotAPI', event);

        if (event && event.type) {
          if (event.type === 'enable') {
            SnapshotSrv.enable(event.data);
          } else if (event.type === 'disable') {
            SnapshotSrv.disable(event.data);
          }
        }
      }

    });

    console.info(`Player version: ${"2.9.47"}, VideoJs version: ${videoJs.VERSION}, build date: ${"2021-10-07T12:27:49.090Z"}`);
    _options = _options || {};
    _options.controlBar = _options.controlBar || {};

    if (_options.mute !== undefined) {
      _options.muted = !!_options.mute;
      delete _options.mute;
    }

    if (_options.showEmbedded) {
      _options.controlBar.EmbeddedButton = !!_options.showEmbedded;
      delete _options.showEmbedded;
    }

    if (_options.fullScreen !== undefined) {
      _options.controlBar.FullscreenToggle = !!_options.fullScreen;
      delete _options.fullScreen;
    }

    if (_options.qualityChange !== undefined) {
      _options.controlBar.QualitySelectorButton = !!_options.qualityChange;
      delete _options.qualityChange;
    }

    _options.controls = _options.controls === undefined ? true : _options.controls;
    _options.hotkeys = _options.hotkeys === undefined ? true : _options.hotkeys;
    config.set('playerId', tagId);
    config.set('params', _options);
    config.set('debug', config.get('params.debug'));
    config.set('screenType', device.isSmartTv() ? 'bs' : 'ss');
    config.set('platform', device.isSmartTv() ? 'stv' : 'web');
    config.set('params.env', config.get('params.env') || 'prod');
    secondLocation.disable();

    if (config.get('params.sl')) {
      secondLocation.setEnv(config.get('params.env') || 'prod');
      secondLocation.setScreenType(config.get('screenType'));
      secondLocation.setPlatform(config.get('platform'));
      secondLocation.enable();
    }

    vjsSrv.initVideoJsHooks();

    this._init({
      controls: _options.controls,
      hotkeys: _options.hotkeys,
      plugins: _options.plugins || null,
      controlBar: _options && _options.controlBar ? _options.controlBar : null,
      useTag: _options && _options.useTag ? _options.useTag : null
    });
  }

  _init(options) {
    playerWrapper.create(options).then(vjsPlayer => {
      this.vjsPlayer = vjsPlayer;

      this._handleWindowEvent();

      this._handlePMEvents();

      this._handlePlayerEvents();

      PostersManager.init();
      vjsPlayer.removeClass('before-init');

      if (config.get('params.initEmpty')) {
        vjsPlayer.addClass('empty-player');
      } else {
        var asset = PlayerSrv$1.transformToAsset(config.get('params'));
        playerWrapper.play(asset, false);
      }

      if (device.isSafari()) {
        vjsPlayer.addClass('non-ima-fullscreen');
      }

      this.logger.log('@player ready, conf:', config.get('params'));
      var eventData = {};

      if (lifecycle.state !== 'terminated') {
        eventsSrv.emit(PLAYER_EVENTS.READY, eventData);
        PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.READY, eventData);
      }
    });
  }

  _handleWindowEvent() {
    window.addEventListener('click', evt => {
      eventsSrv.emit(PLAYER_EVENTS.AREA_CLICK);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.AREA_CLICK);
    }, true);
    vjsSrv.vjsPlayer.addClass(`screen-${screenMode()}`);
    window.addEventListener('orientationchange', () => {
      Analytics.send('media_screen_switch');
      eventsSrv.emit(PLAYER_EVENTS.ORI_CAHNGE);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.ORI_CAHNGE);
      vjsSrv.vjsPlayer.removeClass(`screen-portrait`);
      vjsSrv.vjsPlayer.removeClass(`screen-landscape`);
      vjsSrv.vjsPlayer.addClass(`screen-${screenMode()}`);
    });
    window.addEventListener('resize', () => {
      eventsSrv.emit(PLAYER_EVENTS.RESIZE);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.RESIZE);
      vjsSrv.vjsPlayer.removeClass(`screen-portrait`);
      vjsSrv.vjsPlayer.removeClass(`screen-landscape`);
      vjsSrv.vjsPlayer.addClass(`screen-${screenMode()}`);
    });
    var isPaused = false;
    lifecycle.addEventListener('statechange', event => {
      eventLog.log('statechange', `${event.oldState} -> ${event.newState}`);

      if (event.newState === 'hidden') {
        if (device.isAnyMobile()) {
          if (config.get('eventsState.isCallPlay')) {
            vjsSrv.vjsPlayer.pause();
            isPaused = true;
          }
        }
      } else if (event.newState === 'active') {
        if (device.isAnyMobile() && isPaused) {
          if (config.get('eventsState.isCallPlay')) {
            vjsSrv.vjsPlayer.play();
            isPaused = false;
          }
        }
      } else if (event.newState === 'terminated') {
        if (vimmiPI$1.getActiveAsset() && vimmiPI$1.getActiveAsset().get('extraData.iid') && config.get('eventsState.isStartPlay') && !config.get('eventsState.ended')) {
          config.set('eventsState.ended', true);
          Analytics.send('progress', {}, {
            only: ['sati', 'ga']
          });
          Analytics.send('chu', {}, {
            force: true
          });
          Analytics.send('stop', {
            stop_cause: 'app focus lost'
          }, {
            beacon: true,
            fetch: false
          });
        } else {
          Analytics.beforePageClose({
            beacon: true,
            fetch: false
          });
        }

        if (config.get('eventsState.isStartPlay')) {
          vimmiPI$1.concurStop(true);
        }
      }
    });
  }

  _handlePMEvents() {
    PMWrap$1.inst().on(PLAYER_METHODS.MUTE, event => {
      this.controls.mute(event);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.PLAY, event => {
      this.controls.play(event);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.PAUSE, event => {
      this.controls.pause(event);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.PLAY_NEW_VIDEO, event => {
      this.playVideo(event);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.SET_RESTRICTION, event => {
      this.setRestriction(event);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.TOGGLE_PREVIEW, event => {
      this.togglePreview(event);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.BUTTONS_ACT, event => {
      this.controls.controlsState(event);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.CONTROLS_STATE, event => {
      this.controls.controlsState(event);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.CONFIGURATION, event => {
      this.configure(event.data);
    });
    PMWrap$1.inst().on(PLAYER_METHODS.CUT_VIDEO_API, this.controls.cutAPI);
    PMWrap$1.inst().on(PLAYER_METHODS.SNAPSHOT_API, this.controls.snapshotAPI);
    PMWrap$1.inst().on('spec_pause', () => {
      if (vimmiPI$1.getActiveAsset()) {
        if (vimmiPI$1.getActiveAsset().get('extraData.errorHandlerTimeoutId')) {
          clearTimeout(vimmiPI$1.getActiveAsset().get('extraData.errorHandlerTimeoutId'));
        }

        vjsSrv.vjsPlayer.pause();
        vjsSrv.vjsPlayer.hasStarted(false);
        vjsSrv.vjsPlayer.currentTime(0);
        vjsSrv.vjsPlayer.reset();
        PostersManager.setCurrentPoster(vimmiPI$1.getActiveAsset());
      }
    });
    PMWrap$1.inst().on('spec_play', () => {
      var asset = vimmiPI$1.getActiveAsset();

      if (asset) {
        asset.playerOptions.autoplay = true;

        if (asset.get('extraData.errorHandlerTimeoutId')) {
          clearTimeout(asset.get('extraData.errorHandlerTimeoutId'));
        }

        this.playVideo(asset);
      }
    });
  }

  _handlePlayerEvents() {
    var _timeUpdate_prevTime = 0;
    var isMuted = vjsSrv.vjsPlayer.muted();
    vjsSrv.vjsPlayer.on('fullscreenchange', () => {
      eventsSrv.emit(PLAYER_EVENTS.FULLSCR_CHANGE);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.FULLSCR_CHANGE);
    });
    vjsSrv.vjsPlayer.on('loadstart', () => {
      this.logger.info('[event] loadstart');
      AudioTracksSrv.disableCustomButton();

      if (!vimmiPI$1.getActiveAsset().get('state.ready')) {
        vjsSrv.vjsPlayer.addClass('custom-waiting-video');
      } else {
        vjsSrv.vjsPlayer.removeClass('custom-waiting-video');
      }

      config.set('eventsState.error', false);

      if (vimmiPI$1.getActiveAsset()) {
        vimmiPI$1.getActiveAsset().set('extraData.n_streams', 0);
        vimmiPI$1.getActiveAsset().set('extraData.max_bitrate', 0);
        vimmiPI$1.getActiveAsset().set('extraData.min_bitrate', 0);
      }

      config.set('eventsState.changeSource', false);
    });
    vjsSrv.vjsPlayer.on('durationchange', event => {
      eventLog.info('durationchange', {
        duration: vjsSrv.vjsPlayer.duration(),
        currentTime: vjsSrv.vjsPlayer.currentTime()
      });
      vjsSrv.vjsPlayer.removeClass('pre-loading');

      if (vjsSrv.vjsPlayer.duration() === Infinity || vimmiPI$1.getActiveAsset().get('isLive') && device.isFirefox()) {
        eventsSrv.emit(PLAYER_EVENTS.LOADEDMETADATA);
        PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.LOADEDMETADATA);
        vjsSrv.vjsPlayer.removeClass('custom-waiting-video');

        if (!vimmiPI$1.getActiveAsset().get('extraData.delay_end')) {
          vimmiPI$1.getActiveAsset().set('extraData.delay_end', Date.now());
        }

        if (!vimmiPI$1.getActiveAsset().get('extraData.first_byte_end')) {
          vimmiPI$1.getActiveAsset().set('extraData.first_byte_end', Date.now());
        }

        if (!vimmiPI$1.getActiveAsset().get('state.ready')) {
          vimmiPI$1.getActiveAsset().set('state.ready', true);
          setTimeout(() => {
            if (!Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
              Analytics.send('player_ready', {}, {
                only: ['buh']
              });
            }
          });
        }

        playerWrapper.applyStartPosition();

        if (device.isSafari()) {
          vjsSrv.tryPlay();
        }
      }
    });
    vjsSrv.vjsPlayer.on('loadedmetadata', () => {
      eventLog.info('loadedmetadata');
      vjsSrv.vjsPlayer.removeClass('pre-loading');
      Analytics.onTimeUpdate(vimmiPI$1.getActiveAsset());

      if (config.get('params.style_schema') === 'lg-ais') {
        if (vimmiPI$1.isApplicableMetadataLang(vimmiPI$1.getActiveAsset())) {
          vimmiPI$1.getActiveAsset().get('item.m_audio').map(track => {
            eventsSrv.emit(PLAYER_METHODS.GET_AUDIO_TRACK, {
              track: {
                track: track,
                label: track,
                selected: vimmiPI$1.getActiveAsset().get('metadataLang') === track
              }
            });
          });
        }
      } else {
        if (vimmiPI$1.isApplicableMetadataLang(vimmiPI$1.getActiveAsset())) {
          this.logger.log('load custom audio track, based on metadata', vimmiPI$1.getActiveAsset().get('item.m_audio'));
          AudioTracksSrv.enableCustomButton();
        } else {
          AudioTracksSrv.disableCustomButton();
        }
      }

      config.set('eventsState.loadedmetadata', true);

      if (vjsSrv.vjsPlayer.duration() !== Infinity) {
        if (device.isSafari()) {
          if (!vimmiPI$1.getActiveAsset().get('extraData.delay_end')) {
            vimmiPI$1.getActiveAsset().set('extraData.delay_end', Date.now());
          }

          if (!vimmiPI$1.getActiveAsset().get('extraData.first_byte_end')) {
            vimmiPI$1.getActiveAsset().set('extraData.first_byte_end', Date.now());
          }

          if (!vimmiPI$1.getActiveAsset().get('extraData.saveState')) {
            eventsSrv.emit(PLAYER_EVENTS.LOADEDMETADATA);
            PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.LOADEDMETADATA);
          }

          vjsSrv.tryPlay();
        }
      } else {
        if (device.isSafari()) {
          vjsSrv.tryPlay();
        }
      }

      if (!vimmiPI$1.getActiveAsset().get('state.ready')) {
        vimmiPI$1.getActiveAsset().set('state.ready', true);
        setTimeout(() => {
          if (!Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
            Analytics.send('player_ready', {}, {
              only: ['buh']
            });
          }
        });
      }

      vjsSrv.vjsPlayer.removeClass('custom-waiting-video');
    });
    vjsSrv.vjsPlayer.on('loadeddata', event => {
      eventLog.info('loadeddata', {
        paused: vjsSrv.vjsPlayer.paused(),
        fixPlayButton: !!(vjsSrv.vjsPlayer.paused() && vjsSrv.vjsPlayer.el().classList.contains('vjs-playing'))
      });

      if (vjsSrv.vjsPlayer.paused() && vjsSrv.vjsPlayer.el().classList.contains('vjs-playing')) {
        vjsSrv.vjsPlayer.el().classList.replace('vjs-playing', 'vjs-paused');
      }

      config.set('eventsState.loadeddata', true);
      vjsSrv.vjsPlayer.removeClass('custom-waiting-video');

      if (vjsSrv.vjsPlayer.duration() !== Infinity) {
        if (!device.isSafari()) {
          if (!vimmiPI$1.getActiveAsset().get('extraData.delay_end')) {
            vimmiPI$1.getActiveAsset().set('extraData.delay_end', Date.now());
          }

          if (!vimmiPI$1.getActiveAsset().get('extraData.first_byte_end')) {
            vimmiPI$1.getActiveAsset().set('extraData.first_byte_end', Date.now());
          }

          if (!vimmiPI$1.getActiveAsset().get('extraData.saveState')) {
            eventsSrv.emit(PLAYER_EVENTS.LOADEDMETADATA);
            PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.LOADEDMETADATA);
          }
        }
      }

      if (!vimmiPI$1.getActiveAsset().get('state.ready')) {
        vimmiPI$1.getActiveAsset().set('state.ready', true);
        setTimeout(() => {
          if (!Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
            Analytics.send('player_ready', {}, {
              only: ['buh']
            });
          }
        });
      }
    });
    vjsSrv.vjsPlayer.on('volumechange', () => {
      if (isMuted && vjsSrv.vjsPlayer.muted()) {
        return;
      }

      if (!isMuted && !vjsSrv.vjsPlayer.muted()) {
        return;
      }

      isMuted = vjsSrv.vjsPlayer.muted();
      config.get('params.muted', isMuted);
    });
    vjsSrv.vjsPlayer.on('play', event => {
      eventLog.info('play', {
        readyState: vjsSrv.vjsPlayer.readyState(),
        networkState: vjsSrv.vjsPlayer.networkState()
      });
      config.set('eventsState.isCallPlay', true);

      if (Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
        Restriction.skipPlay();
      }
    });
    vjsSrv.vjsPlayer.on('pause', () => {
      eventLog.info('pause', {
        readyState: vjsSrv.vjsPlayer.readyState(),
        networkState: vjsSrv.vjsPlayer.networkState()
      });
      vimmiPI$1.getActiveAsset().set('state.resumed', false);
      vimmiPI$1.getActiveAsset().set('state.pause', true);
    });
    vjsSrv.vjsPlayer.on('playing', () => {
      eventLog.info('playing', {
        readyState: vjsSrv.vjsPlayer.readyState(),
        networkState: vjsSrv.vjsPlayer.networkState(),
        currentTime: vjsSrv.vjsPlayer.currentTime(),
        isStartPlay: config.get('eventsState.isStartPlay')
      });
      vimmiPI$1.concurPlay();

      if (vjsSrv.vjsPlayer.currentTime() !== 0) {
        eventsSrv.emit(PLAYER_EVENTS.PLAYING);
        PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.PLAYING);
      }

      if (!vimmiPI$1.getActiveAsset().get('state.playing') && vimmiPI$1.getActiveAsset().get('state.callPlay')) {
        vimmiPI$1.getActiveAsset().set('state.playing', true);
        Analytics.send('media_is_playing');
      }

      if (vjsSrv.vjsPlayer.trackToActivate) {
        vjsSrv.vjsPlayer.trackToActivate.enabled = true;
        eventLog.info('set active track', vjsSrv.vjsPlayer.trackToActivate);
        delete vjsSrv.vjsPlayer.trackToActivate;
      }

      playerWrapper.applyStartPosition();
      config.set('eventsState.waiting', false);
      vimmiPI$1.getActiveAsset().set('state.pause', false);
    });
    vjsSrv.vjsPlayer.on('seeking', event => {
      if (!vimmiPI$1.getActiveAsset().get('state.pause') && vimmiPI$1.getActiveAsset().get('state.start') && !config.get('eventsState.seeking')) {
        vimmiPI$1.getActiveAsset().set('state.pause', true);
        Analytics.send('chu', {}, {
          force: true
        });
        Analytics.send('media_pause', {
          position: !vimmiPI$1.getActiveAsset().isLive ? 0 : Tools$1.fixTo(vimmiPI$1.getActiveAsset().get('extraData.active_position') || 0),
          stop_cause: 'seeking'
        });
      }

      config.set('eventsState.seeking', true);
    });
    vjsSrv.vjsPlayer.on('seeked', () => {
      eventLog.info('seeked', {
        currentTime: vjsSrv.vjsPlayer.currentTime()
      });
      vimmiPI$1.getActiveAsset().set('extraData.position_from', vimmiPI$1.getActiveAsset().get('extraData.active_position'));
      vimmiPI$1.getActiveAsset().set('extraData.active_position', vjsSrv.vjsPlayer.currentTime());

      if (!vimmiPI$1.getActiveAsset().isLive && config.get('eventsState.seeking') && !Preview.ended) {
        Analytics.send('seek');
      }

      if (vimmiPI$1.getActiveAsset().get('state.pause') && vimmiPI$1.getActiveAsset().get('state.start') && config.get('eventsState.seeking')) {
        vjsSrv.onPlayerStart();
        vimmiPI$1.getActiveAsset().set('state.pause', false);
      }

      if (Math.ceil(vjsSrv.vjsPlayer.duration()) <= Math.ceil(vjsSrv.vjsPlayer.currentTime() + 0.5)) {
        vjsSrv.vjsPlayer.trigger('ended');
      }

      config.set('eventsState.seeking', false);
    });
    vjsSrv.vjsPlayer.on('timeupdate', () => {
      if (vimmiPI$1.getActiveAsset()) {
        var stats = vjsSrv.vjsPlayer.TechSrv.stats;
        vimmiPI$1.getActiveAsset().set('extraData.active_bitrate', stats.streamBitrate || stats.averageBitrate || vimmiPI$1.getActiveAsset().get('extraData.active_bitrate') || 0);
        vimmiPI$1.getActiveAsset().set('extraData.bytes', stats.bytesReceived || 0);
        var stream_time = vimmiPI$1.getActiveAsset().get('extraData.stream_time', 0);
        var current = vjsSrv.vjsPlayer.currentTime();
        var from = vimmiPI$1.getActiveAsset().get('extraData.active_position') || current;

        if (from < current && from + 2 < current || from > current && from - 2 > current) {
          config.set('eventsState.seeking', true);
        } else {
          stream_time += current - from;
        }

        vimmiPI$1.getActiveAsset().set('extraData.stream_time', stream_time);
        Analytics.onTimeUpdate(vimmiPI$1.getActiveAsset());

        if (!config.get('eventsState.seeking')) {
          vimmiPI$1.getActiveAsset().set('extraData.active_position', vjsSrv.vjsPlayer.currentTime());
        }

        vimmiPI$1.getActiveAsset().set('extraData.position_to', vjsSrv.vjsPlayer.currentTime());
      }

      config.set('eventsState.prevUserActiveState', vjsSrv.vjsPlayer.userActive());
      var currentTime = vjsSrv.vjsPlayer.currentTime() || 0.1;

      if (Math.floor(currentTime) !== _timeUpdate_prevTime && vimmiPI$1.getActiveAsset()) {
        if (!vjsSrv.vjsPlayer.paused()) {
          Analytics.send('chu');
        }

        eventsSrv.emit(PLAYER_EVENTS.TIME_UPDATE, {
          positionPrev: _timeUpdate_prevTime,
          stream_time: vimmiPI$1.getActiveAsset().get('extraData.stream_time')
        });
        PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.TIME_UPDATE, {
          positionPrev: _timeUpdate_prevTime,
          stream_time: vimmiPI$1.getActiveAsset().get('extraData.stream_time')
        });
        _timeUpdate_prevTime = Math.floor(currentTime);
      }
    });
    vjsSrv.vjsPlayer.on('waiting', () => {
      eventLog.info('waiting', {
        readyState: vjsSrv.vjsPlayer.readyState(),
        networkState: vjsSrv.vjsPlayer.networkState(),
        player: vjsSrv.vjsPlayer
      });
      config.set('eventsState.waiting', true);

      if (vimmiPI$1.getActiveAsset() && !vimmiPI$1.getActiveAsset().get('extraData.start_buffering')) {
        vimmiPI$1.getActiveAsset().set('extraData.start_buffering', Date.now());
        Analytics.send('media_buffering_start');
      }

      eventsSrv.emit(PLAYER_EVENTS.WAITING);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.WAITING);
    });
    vjsSrv.vjsPlayer.on('ended', event => {
      eventLog.info('ended', {
        isStartPlay: config.get('eventsState.isStartPlay'),
        ended: config.get('eventsState.ended'),
        eventsStateEnded: config.get('eventsState.ended')
      });

      if (vjsSrv.vjsPlayer.isFullscreen() && device.isIOS() && device.isSafari()) {
        vjsSrv.vjsPlayer.exitFullscreen();
      }

      vimmiPI$1.concurStop();

      if (!config.get('eventsState.ended') && config.get('eventsState.isStartPlay')) {
        Analytics.send('progress', {}, {
          only: ['sati', 'ga']
        });
        Analytics.send('chu', {}, {
          force: true
        });
        Analytics.send('stop', {
          stop_cause: 'end'
        });
        eventsSrv.emit(PLAYER_EVENTS.ENDED);
        PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.ENDED);
        config.set('eventsState.ended', true);

        if (PrevNextButtonSrv.isActive('NextButton')) {
          PrevNextButtonSrv.handleClick('NextButton');
        }
      }
    });
    vjsSrv.vjsPlayer.on('abort', event => {
      eventLog.info('abort', {
        event: event,
        eventsStateEnded: config.get('eventsState.ended')
      });

      if (config.get('eventsState.changeSource')) {
        return;
      }

      if (vimmiPI$1.getActiveAsset() && vimmiPI$1.getActiveAsset().get('extraData.saveState') || config.get('eventsState.ended') || config.get('eventsState.error')) {
        return;
      }

      var asset = vimmiPI$1.getActiveAsset();

      if (!config.get('eventsState.loadstart')) {
        asset = PlayerSrv$1.prevAsset;
      }

      var error = new Error('video end');
      error.code = ErrorCodes.NET_ERR;
      Analytics.send('abort', {
        position: asset && !asset.isLive ? Tools$1.fixTo(asset.extraData.active_position, 0) || 0 : 0
      }, {
        asset: asset,
        error: error
      });
    });
    vjsSrv.vjsPlayer.on('error', event => {
      var _asset$extraData;

      var asset = vimmiPI$1.getActiveAsset();
      var xhrError = asset === null || asset === void 0 ? void 0 : (_asset$extraData = asset.extraData) === null || _asset$extraData === void 0 ? void 0 : _asset$extraData.xhrError;
      eventLog.warn('error', {
        readyState: vjsSrv.vjsPlayer.readyState(),
        networkState: vjsSrv.vjsPlayer.networkState(),
        error: vjsSrv.vjsPlayer.error(),
        internalError: vjsSrv.vjsPlayer.internalError,
        xhrError
      });
      var error = vjsSrv.vjsPlayer.internalError || vjsSrv.vjsPlayer.error();

      if (!error.code) {
        error.code = ErrorCodes.NET_ERR;
      }

      vimmiPI$1.concurStop();
      vjsSrv.vjsPlayer.removeClass('custom-waiting-video');
      Analytics.send('media_error', {}, {
        error: error
      });

      if (error.errCode !== 800 && error.name !== "playbackUrls" && (!xhrError || (xhrError === null || xhrError === void 0 ? void 0 : xhrError.status) >= 200 && (xhrError === null || xhrError === void 0 ? void 0 : xhrError.status) < 400 || (xhrError === null || xhrError === void 0 ? void 0 : xhrError.status) >= 500)) {
        var errorHandlerTimeoutId = null;

        if ((xhrError === null || xhrError === void 0 ? void 0 : xhrError.status) >= 500) {
          setTimeout(() => {
            errorHandlerTimeoutId = vimmiPI$1.handlePlaybackError(error);
          }, 2000);
        } else {
          errorHandlerTimeoutId = vimmiPI$1.handlePlaybackError(error);
        }

        if (asset) {
          asset.set('extraData.errorHandlerTimeoutId', errorHandlerTimeoutId);
        }
      } else {
        vjsSrv.vjsPlayer.removeClass('pre-loading');
      }

      config.set('eventsState.error', true);
    });

    pallyCon.onError = error => {
      eventLog.info('pallyCon onError', {
        readyState: vjsSrv.vjsPlayer.readyState(),
        networkState: vjsSrv.vjsPlayer.networkState(),
        error: vjsSrv.vjsPlayer.error(),
        internalError: vjsSrv.vjsPlayer.internalError
      });
      vjsSrv.vjsPlayer.error({
        message: error && error.message ? error.message : error,
        code: 3
      });
    };

    var timeStamp = Date.now();
    vjsSrv.vjsPlayer.on('dblclick', event => {
      if (!config.get('params.controls')) {
        return;
      }

      this.logger.info('[click] user dblclick', event.type);

      if (config.get('params.audio_tag') || vimmiPI$1.getActiveAsset() && Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
        return;
      }

      if (vjsSrv.vjsPlayer.isFullscreen()) {
        vjsSrv.vjsPlayer.exitFullscreen();
      } else {
        vjsSrv.vjsPlayer.requestFullscreen();
      }
    });
    vjsSrv.vjsPlayer.on('touchend', () => {
      if (!config.get('params.controls')) {
        return;
      }

      this.logger.info('[click] user touchend', event.type);

      if (config.get('params.audio_tag') || Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
        return;
      }

      if (timeStamp + 250 >= Date.now()) {
        if (vjsSrv.vjsPlayer.isFullscreen()) {
          vjsSrv.vjsPlayer.exitFullscreen();
        } else {
          vjsSrv.vjsPlayer.requestFullscreen();
        }
      }

      timeStamp = Date.now();
    });
    var wrapperForBigButton = PlayerSrv$1.wrapBigPlayButton(vjsSrv.vjsPlayer);

    var pauseFn = event => {
      if (!config.get('params.controls')) {
        return false;
      }

      console.log(event, event.target.classList.contains('vjs-big-play-button') || event.target.parentElement.classList.contains('vjs-big-play-button'));

      if (event.target.classList.contains('vjs-big-play-button') || event.target.parentElement.classList.contains('vjs-big-play-button')) {
        return true;
      }

      if (!vjsSrv.vjsPlayer.paused() && !vjsSrv.vjsPlayer.hasClass('vjs-waiting') && (!device.isAnyMobile() || config.get('eventsState.prevUserActiveState') && device.isAnyMobile())) {
        Analytics.send('chu', {}, {
          force: true
        });
        Analytics.send('media_pause', {
          stop_cause: 'pause'
        });
        eventLog.log('@user action: PAUSE', 'wrapper', event);
        eventsSrv.emit(PLAYER_EVENTS.USER_PAUSE);
        PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.USER_PAUSE);
        vimmiPI$1.concurStop();

        if (config.get('eventsState.isCallPlay')) {
          vjsSrv.vjsPlayer.pause();
        }
      }
    };

    wrapperForBigButton.addEventListener('click', pauseFn);
    vjsSrv.vjsPlayer.getChild('bigPlayBtn').on(['click', 'tap'], this._handlePlayClick);
    var playToggle = vjsSrv.vjsPlayer.getChild('controlBar').getChild('playToggle');

    if (playToggle) {
      playToggle.on(['click', 'tap'], this._handlePlayClick);
    }
  }

  _handlePlayClick(event) {
    if (!config.get('params.controls') && vjsSrv.vjsPlayer.paused()) {
      return;
    }

    eventLog.info('#handlePlayClick:', 'playButton', {
      eventsState: Tools$1.copy(config.get('eventsState'))
    });

    if (!config.get('eventsState.isStartPlay')) ; else if (!vjsSrv.vjsPlayer.paused()) ; else {
      Analytics.send('chu', {}, {
        force: true
      });
      Analytics.send('media_pause', {
        stop_cause: 'pause'
      });
      eventsSrv.emit(PLAYER_EVENTS.USER_PAUSE);
      PMWrap$1.inst().sendWrappedEvent(PLAYER_EVENTS.USER_PAUSE);
      eventLog.info('@user action: PAUSE', 'playButton', event);
      vjsSrv.vjsPlayer.pause();
      vimmiPI$1.concurStop();
    }
  }

  get asset() {
    return vimmiPI$1.getActiveAsset() || null;
  }

  playVideo(options) {
    PrevNextSuggestSrv.hideSuggests();
    var asset = PlayerSrv$1.transformToAsset(Object.assign({}, config.get('params'), options));

    if (vimmiPI$1.getActiveAsset()) {
      vimmiPI$1.concurStop();
    }

    playerWrapper.play(asset, false);
  }
  /**
   * @method configure
   * @param {Object} configs the config object
   * @param {Object} configs.analytics the config object for analytics modules (supported only 'buh')
   * @param {Object} [configs.analytics.buh]  config for BUH analytics
   * @param {Number} configs.analytics.buh.chugap interval to send chu events (seconds)
   * @param {String} configs.analytics.buh.ep the analytics domain endpoint
   * @param {String} configs.analytics.buh.customPath the analytics path (to rewrite default "/event/evn/")
   * @param {Boolean} configs.analytics.buh.nstk  ?
   * @param {Boolean} configs.analytics.buh.buhsy  // disable sending BUH analytics when come false from ams // false = disable, true = enable
   * @param {Boolean} configs.analytics.buh.olsy  Use old analytics system (CM). Default is true. // false = disable, true = enable
   * @param {Boolean} configs.analytics.buh.package  send events in packages
   * @param {Number} configs.analytics.buh.egap  Max gap in seconds to send events. Default 30 seconds. // used for sending packages
   * @param {Object} configs.analytics.buh.packageOpt   config for events packaging
   * @param {Number} configs.analytics.buh.packageOpt.maxEvents   max events in 1 package
   * @param {Number} configs.analytics.buh.packageOpt.minEvents   min events in 1 package
   * @param {Boolean} configs.analytics.buh.stkwrite   ?
   * @param {Object} [configs.player_conf]  the config object for the player itself
   * @param {Object} configs.player_conf.quality_selector  the config object for the quality selector plugin
   * @param {Boolean} configs.player_conf.vimmi_copyright  show vimmi context menu instead browser default
   * @param {Object} configs.portal   the config object with portal info and credentials
   * @param {String} configs.portal.server  the AMS backend domain
   * @param {String} configs.portal.customer  customer ('ais'|....)
   * @param {Array} configs.portal.restrictedDevices  list of devices for restrictions (to send to AMS as "d" query parameter)
   * @param {'mob'|'stb'|'web'} configs.portal.platform
   * @param {Object} [configs.portal.concurrency]  config for concurrency took from AMS
   * @param {Array} configs.portal.concurrency.content  list of watched content ex: ['not_free']
   * @param {String} configs.portal.concurrency.cgrp  - ?
   * @param {String} configs.portal.concurrency.ep  - domain to send the concurrency status
   * @param {Number} configs.portal.concurrency.cgap  - interval in seconds for keepalive requests
   * @param {String} configs.portal.Device-Info  - formatted string with device info ex: "com.vimmi.ais.portal, Windows + Chrome, AppVersion: 4.7.15, 10, Language: tha"
   * @param {String} configs.portal.language  - iso-2 or iso-3 lang code ex: tha, eng, basically used for request header preparing
   *
   * @param {String} configs.portal.app_version  - version of app
   * @param {String} configs.portal.app_info  - info about app. based on "customer" and "platform". used for analytics ex:  "AIS-WEB"
   * @param {String} configs.portal.public_app_key  - unknown goal key ex: "vimmiCB1D0336"
   *
   * @param {String} configs.portal.device_key  - unknown goal string, ex: "com.vimmi.ais.portal"
   * @param {String} configs.portal.device_id  - unique device id (Base generated by FingerprintJs)
   * @param {String} configs.portal.buhDeviceId  - unique random string stored in Web, used as part of device id to more unique device identification in BUH (ios issue)
   *
   * @param {String} configs.portal.private_id  - AMS user private id
   * @param {String} configs.portal.sid  -  AMS user session id
   * @param {String} configs.portal.user_id  -  AMS user id
   * @param {String} configs.portal.user_lang  - iso-2 or iso-3 lang code ex: tha, eng, basically used for analytics
   * @param {String} configs.portal.temp_user_id  - random hash string, used for analytics
   * @param {String} configs.portal.classification  - user classification
   * @param {string} configs.portal.preferred_audio_lang  - iso-2 or iso-3 lang code, to using as default for content
   *
   * @param {Object} configs.portal.metadata  - Custom metadata query params, to overwrite ex: cdn=redfox to cdn=redfox-https
   *
   *
   * */


  configure(configs) {
    this.logger.log('@configure', configs);
    configs = configs || {};

    if (configs.player_conf) {
      config.set('params', Object.assign(config.get('params'), configs.player_conf));
    }

    vimmiPI$1.conf({
      backend: configs.portal.server,
      customer: configs.portal.customer,
      deviceRestrictions: configs.portal.restrictedDevices,
      platform: configs.portal.platform || ['web'],
      concurrency: configs.portal.concurrency,
      appInfo: {
        "Api-Version": "2.8.2",
        "Device-Info": configs.portal['Device-Info'],
        language: configs.portal.language,
        app_version: configs.portal.app_version
      },
      authInfo: {
        public_app_key: configs.portal.public_app_key,
        device_key: configs.portal.device_key,
        privateId: configs.portal.private_id,
        device_id: configs.portal.device_id,
        sid: configs.portal.sid
      },
      ams: {
        portal: {
          player: {
            metadata: configs.portal.metadata
          }
        }
      }
    });

    for (var key in configs) {
      config.set(`params.${key}`, configs[key]);
    }

    Analytics.configure(configs);
  }

  changeAudio(trackId, trackType) {
    if (trackId && trackType) {
      AudioTracksSrv.changeTrack(trackId, trackType);
    }
  }

  setRestriction(options) {
    this.logger.log('@setRestriction', options);

    if (vimmiPI$1.getActiveAsset()) {
      vimmiPI$1.getActiveAsset().set('restricted', options.restricted);

      if (Restriction.isRestricted(vimmiPI$1.getActiveAsset())) {
        Restriction.show(vimmiPI$1.getActiveAsset());
        vjsSrv.vjsPlayer.reset();
      } else {
        Restriction.hide();
        vjsSrv.vjsPlayer.play();
      }
    }
  }

  togglePreview(options) {
    appLogger.log('@togglePreview', options);

    if (options.preview && options.preview_info) {
      vimmiPI$1.getActiveAsset().set('preview', true);
      vimmiPI$1.getActiveAsset().set('preview_info', options.preview_info);
      Preview.show(vimmiPI$1.getActiveAsset());
    } else {
      vimmiPI$1.getActiveAsset().set('preview', false);
      vimmiPI$1.getActiveAsset().set('preview_info', null);
      Preview.hide();
    }
  }

  hide() {
    vjsSrv.vjsPlayer.addClass('vjs-hidden');
  }

  show() {
    vjsSrv.vjsPlayer.removeClass('vjs-hidden');
  }

  requestFullscreen() {
    if (!vjsSrv.vjsPlayer.isFullscreen()) {
      vjsSrv.vjsPlayer.requestFullscreen();
    }
  }

  exitFullscreen() {
    if (vjsSrv.vjsPlayer.isFullscreen()) {
      vjsSrv.vjsPlayer.exitFullscreen();
    }
  }

}

export { VimmiPlayer as default };
